export default {
  "app": {
    "root": "https://www.guidetosunnah.com/ar/apps",
    "pages": 10,
    "categories": [
      {
        "url": "https://www.guidetosunnah.com/ar/apps/mwaqa-wtbyqat-lkhdmt-alsnt-taryf-balnby",
        "label": "تعريف بالنبي ﷺ"
      },
      {
        "url": "https://www.guidetosunnah.com/ar/apps/mwaqa-wtbyqat-lkhdmt-alsnt-mwswaat-wbhth-hdythy",
        "label": "موسوعات وبحث حديثي"
      },
      {
        "url": "https://www.guidetosunnah.com/ar/apps/mwaqa-wtbyqat-lkhdmt-alsnt-dfaa-an-alsnt",
        "label": "دفاع عن السنة"
      },
      {
        "url": "https://www.guidetosunnah.com/ar/apps/mwaqa-wtbyqat-lkhdmt-alsnt-alsyrt-alnbwyt",
        "label": "السيرة النبوية"
      },
      {
        "url": "https://www.guidetosunnah.com/ar/apps/mwaqa-wtbyqat-lkhdmt-alsnt-api",
        "label": "API"
      },
      {
        "url": "https://www.guidetosunnah.com/ar/apps/deaf_mute",
        "label": "الصم والبكم"
      },
      {
        "url": "https://www.guidetosunnah.com/ar/apps/blind",
        "label": "المكفوفون"
      }
    ],
    "items": [
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-1ttbyk-1almosoaa-1alhdythy",
        "title": "تطبيق الموسوعة الحديثية",
        "description": "",
        "image": "https://www.guidetosunnah.com/storage/posts/512x512bb4_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/512x512bb4_showWebsiteThumb.jpg",
        "stores": {
          "ios": "https://apps.apple.com/app/almwsw-t-alhdythyt-aldrr-alsnyt/id599410474?ls=1",
          "android": "https://play.google.com/store/apps/details?id=com.zad.hadith&hl=ar"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/post-95181783349907",
        "title": "تطبيق \"جامع الكتب التسعة\"",
        "description": "تطبيق إسلامي خاص بعلم الحديث النبوي الشريف يشتمل على كتب الحديث، ليكون لكل طالب علم في الحديث لاكتشاف الدرر السنية في هدي النبي صلى الله عليه وسلم.",
        "image": "https://www.guidetosunnah.com/storage/posts/download-83231_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/download-83231_showWebsiteThumb.jpg",
        "stores": {
          "ios": "https://apps.apple.com/us/app/%D8%AC%D8%A7%D9%85%D8%B9-%D8%A7%D9%84%D9%83%D8%AA%D8%A8-%D8%A7%D9%84%D8%AA%D8%B3%D8%B9%D8%A9/id1149785262",
          "android": "https://play.google.com/store/apps/details?id=com.arabiait.sunna&hl=ar"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-4ttbyk-4alamam-4almhdth-4alalbany",
        "title": "تطبيق الإمام المحدث الألباني",
        "description": "",
        "image": "https://www.guidetosunnah.com/storage/posts/app-image-big-43027_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/app-image-big-43027_showWebsiteThumb.jpg",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=net.hammady.android.alalbany&hl=ar"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-5ttbyk-5gamaa-5alhdyth",
        "title": "تطبيق جامع الحديث",
        "description": "",
        "image": "https://www.guidetosunnah.com/storage/posts/jamaa-alhdyth-alnboy-18_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/jamaa-alhdyth-alnboy-18_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/us/app/%D8%AC%D8%A7%D9%85%D8%B9-%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB-%D9%82%D8%B7%D8%B1-%D8%A7%D9%84%D8%AE%D9%8A%D8%B1%D9%8A%D8%A9/id1165160502",
          "android": "https://play.google.com/store/apps/details?id=org.qcharity.gameaelhadith&hl=ar"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-6ttbyk-6mktb-6alhdyth",
        "title": "تطبيق مكتبة الحديث",
        "description": "تطبيق يضم الأحاديث النبوية من كتب الحديث، بالإضافة إلى إمكانية البحث فيها، مع إمكانية تغيير الخط والخلفية حسب رغبة القارئ.",
        "image": "https://www.guidetosunnah.com/storage/posts/unnamed9_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/unnamed9_showWebsiteThumb.jpg",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=com.nyitgroup.yemenlibrary&hl=ar"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-7ttbyk-7alarbaaon-7alnooy-7maa-7alshrh",
        "title": "تطبيق الأربعون النووية مع الشرح",
        "description": "",
        "image": "https://www.guidetosunnah.com/storage/posts/icon10_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/icon10_showWebsiteThumb.png",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=com.reda.nawawiforty&hl=ar"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-8ttbyk-8ahadyth-8nboy-8shyh",
        "title": "تطبيق أحاديث نبوية صحيحة",
        "description": "",
        "image": "https://www.guidetosunnah.com/storage/posts/hadith498_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/hadith498_showWebsiteThumb.png",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=com.mfk4apps.a7adeth&hl=ar"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-9ttbyk-9hadith-9of-9the-9day",
        "title": "تطبيق Hadith of the Day",
        "description": "",
        "image": "https://www.guidetosunnah.com/storage/posts/512x512bb-112_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/512x512bb-112_showWebsiteThumb.jpg",
        "stores": {
          "ios": "https://apps.apple.com/us/app/hadith-of-the-day/id480437544?ign-mpt=uo%3D4",
          "android": "https://play.google.com/store/apps/details?id=com.HOTD.HadithoftheDay&hl=ar"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-10ttbyk-10ahadyth-10nboy-10msor-10bdon-10nt",
        "title": "تطبيق أحاديث نبوية مصورة - بدون نت",
        "description": "",
        "image": "https://www.guidetosunnah.com/storage/posts/msor11493_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/msor11493_showWebsiteThumb.png",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=com.andromo.dev524178.app503780&hl=ar"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-11ttbyk-11ahadyth-11nboy-11shryf-11bdon-11antrnt",
        "title": "تطبيق أحاديث نبوية شريفة - بدون انترنت",
        "description": "",
        "image": "https://www.guidetosunnah.com/storage/posts/hdyth491_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/hdyth491_showWebsiteThumb.png",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=net.andromo.dev524178.app490243&hl=ar"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-12ttbyk-12hdyth-12kl-12saaa-12bdon-12antrnt",
        "title": "تطبيق حديث كل ساعة - بدون إنترنت",
        "description": "دليل شامل لمشاريع خدمة السنة النبوية وعلومها وما يتعلق بهما من مبادرات ومنتجات وأفكار، يضع بين يدي المهتمين ما يعينهم على معرفة الأعمال القائمة وآفاق التحسين والتطوير وأوجه الاحتياج.",
        "image": "https://www.guidetosunnah.com/storage/posts/1-1222_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/1-1222_showWebsiteThumb.jpg",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=com.boulla.ahadith&hl=ar"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-13ttbyk-13mosoaa-13alhdyth-13alshryf-13algdyd",
        "title": "تطبيق موسوعة الحديث الشريف الجديدة",
        "description": "دليل شامل لمشاريع خدمة السنة النبوية وعلومها وما يتعلق بهما من مبادرات ومنتجات وأفكار، يضع بين يدي المهتمين ما يعينهم على معرفة الأعمال القائمة وآفاق التحسين والتطوير وأوجه الاحتياج.",
        "image": "https://www.guidetosunnah.com/storage/posts/download-320_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/download-320_showWebsiteThumb.jpg",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=org.sonna.www.sonna&hl=ar"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-14ttbyk-14shyh-14mslm",
        "title": "تطبيق صحيح مسلم",
        "description": "تطبيق صحيح مسلم هو تطبيق إسلامي يحتوي على جميع أحاديث كتاب: صحيح مسلم المسمى بـ «المسند الصحيح المختصر من السنن بنقل العدل عن العدل إلى رسول الله صلى الله عليه وسلم»",
        "image": "https://www.guidetosunnah.com/storage/posts/tnzyl-ttbyk-shyh-mslm-llandroyd-brabt-mbashr-152723292217_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/tnzyl-ttbyk-shyh-mslm-llandroyd-brabt-mbashr-152723292217_showWebsiteThumb.png",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=com.reda.sahihmuslim&hl=ar"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-15ttbyk-15shyh-15albkhary",
        "title": "تطبيق صحيح البخاري",
        "description": "تطبيق يحتوي على جميع أحاديث كتاب \"الجامع المسند الصحيح المختصر من أمور رسول الله صلى الله عليه وسلم وسننه وأيامه\" المسمى بـ صحيح البخاري.",
        "image": "https://www.guidetosunnah.com/storage/posts/unnamed-218_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/unnamed-218_showWebsiteThumb.png",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=com.reda.sahihbukhari"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-17ttbyk-17mosoaa-17alhdyth-17alshryf-17aslam-17oyb",
        "title": "تطبيق موسوعة الحديث الشريف – إسلام ويب",
        "description": "",
        "image": "https://www.guidetosunnah.com/storage/posts/750x750bb-17279_relatedServiceThumb.jpeg",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/750x750bb-17279_showWebsiteThumb.jpeg",
        "stores": {
          "ios": "https://apps.apple.com/us/app/%D9%85%D9%88%D8%B3%D9%88%D8%B9%D8%A9-%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB-%D8%A7%D9%84%D8%B4%D8%B1%D9%8A%D9%81/id1001425531",
          "android": "https://play.google.com/store/apps/details?id=net.islamweb.hadith"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-18ttbyk-18hadith-18collection",
        "title": "تطبيق Hadith Collection",
        "description": "",
        "image": "https://www.guidetosunnah.com/storage/posts/app-icon-5e83548f530da21_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/app-icon-5e83548f530da21_showWebsiteThumb.jpg",
        "stores": {
          "ios": "https://apps.apple.com/us/app/hadith-collections/id1563527366"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-19ttbyk-19alf-19sn-19fy-19alyom",
        "title": "تطبيق ألف سنة في اليوم",
        "description": "",
        "image": "https://www.guidetosunnah.com/storage/posts/unnamed-323_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/unnamed-323_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/us/app/%D8%A3%D9%84%D9%81-%D8%B3-%D9%86%D8%A9-%D9%81%D9%8A-%D8%A7%D9%84%D9%8A%D9%88%D9%85-%D9%88%D8%A7%D9%84%D9%84%D9%8A%D9%84%D8%A9/id453223651",
          "android": "https://play.google.com/store/apps/details?id=com.thousandsunnah.sam&hl=ar"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-20ttbyk-20snn-20athkar-20yomy-20lkl-20mslm",
        "title": "تطبيق سنن – أذكار يومية لكل مسلم",
        "description": "",
        "image": "https://www.guidetosunnah.com/storage/posts/icon24_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/icon24_showWebsiteThumb.jpg",
        "stores": {
          "ios": "https://apps.apple.com/sa/app/%D8%B3%D9%86%D9%86-%D8%A3%D8%B0%D9%83%D8%A7%D8%B1-%D9%8A%D9%88%D9%85%D9%8A%D8%A9-%D9%84%D9%83%D9%84-%D9%85%D8%B3%D9%84%D9%85/id1460779836",
          "android": "https://play.google.com/store/apps/details?id=com.madarsoft.alsonan&hl=ar&gl=US"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-21ttbyk-21hsn-21almslm-21algdyd",
        "title": "تطبيق حصن المسلم الجديد",
        "description": "",
        "image": "https://www.guidetosunnah.com/storage/posts/app-image-5e8403990ee3a25_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/app-image-5e8403990ee3a25_showWebsiteThumb.jpg",
        "stores": {
          "ios": "https://apps.apple.com/us/app/%D8%AD%D8%B5%D9%86-%D8%A7%D9%84%D9%85%D8%B3%D9%84%D9%85-%D8%A7%D9%84%D8%AC%D8%AF%D9%8A%D8%AF/id964833363"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-24ttbyk-24shyh-24albkhary-24omslm",
        "title": "تطبيق صحيح البخاري ومسلم",
        "description": "",
        "image": "https://www.guidetosunnah.com/storage/posts/screen-1-7258_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screen-1-7258_showWebsiteThumb.jpg",
        "stores": {
          "ios": "https://apps.apple.com/us/app/%D8%B5%D8%AD%D9%8A%D8%AD-%D8%A7%D9%84%D8%A8%D8%AE%D8%A7%D8%B1%D9%8A-%D9%88-%D9%85%D8%B3%D9%84%D9%85/id414559023"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-25ttbyk-25bstan-25alahadyth-25llatfal",
        "title": "تطبيق بستان الأحاديث للأطفال",
        "description": "يتميز التطبيق بفكرته الجديدة في أسلوب تحفيظ الطفل للأحاديث من خلال التكرار الصوتي والكتابه وحساب نقاط الحفظ ووضعها في متجر الألعاب لخلق روح المنافسة بين المستخدمين.",
        "image": "https://www.guidetosunnah.com/storage/posts/download-629_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/download-629_showWebsiteThumb.jpg",
        "stores": {
          "ios": "https://apps.apple.com/sa/app/id872947885"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-26ttbyk-26athkary-26alyomy-26llatfal",
        "title": "تطبيق أذكاري اليومية للأطفال",
        "description": "تطبيق مميز يساعد الأطفال على حفظ الأذكار والأدعية اليومية، يحتوي التطبيق على ٢٠ دعاء وذكر من خلال فكرة جمع النقاط، مدعوم بالأصوات والمؤثرات التي تساعد الطفل على إكمال حفظ الأدعية ومتابعتها يومياً.",
        "image": "https://www.guidetosunnah.com/storage/posts/athkary-alyomy30_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/athkary-alyomy30_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/sa/app/%D8%A3%D8%B0%D9%83%D8%A7%D8%B1%D9%8A-%D8%A7%D9%84%D9%8A%D9%88%D9%85%D9%8A%D8%A9/id884053049"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-27ttbyk-27samh-27almtsamh",
        "title": "تطبيق سامح المتسامح",
        "description": "",
        "image": "https://www.guidetosunnah.com/storage/posts/laab-samh-almtsamh31_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/laab-samh-almtsamh31_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/app/samh-almtsamh/id956090964"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-28ttbyk-28ryad-28alsalhyn",
        "title": "تطبيق رياض الصالحين",
        "description": "دليل شامل لمشاريع خدمة السنة النبوية وعلومها وما يتعلق بهما من مبادرات ومنتجات وأفكار، يضع بين يدي المهتمين ما يعينهم على معرفة الأعمال القائمة وآفاق التحسين والتطوير وأوجه الاحتياج.",
        "image": "https://www.guidetosunnah.com/storage/posts/app-image-5e84ef35dfb2a32_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/app-image-5e84ef35dfb2a32_showWebsiteThumb.jpg",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=com.zad.riyadhsalheen"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-29hadeeth-29lite",
        "title": "Hadeeth Lite",
        "description": "",
        "image": "https://www.guidetosunnah.com/storage/posts/images33_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/images33_showWebsiteThumb.jpg",
        "stores": {
          "ios": "https://apps.apple.com/us/app/hadeeth-lite/id352309834"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-31ttbyk-31alhdyth-31alnboy-31alshryf",
        "title": "تطبيق الحديث النبوي الشريف",
        "description": "",
        "image": "https://www.guidetosunnah.com/storage/posts/512x512bb-235_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/512x512bb-235_showWebsiteThumb.jpg"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-32ttbyk-32albakyat-32athkar",
        "title": "تطبيق الباقيات أذكار",
        "description": "لحرصنا على الالتزام بسنة النبي صلى الله عليه وسلم، ومواكبة لتقنيات العصر، صممت «شركة الدار العربية لتقنية المعلومات» - وبرعاية كريمة من «وقف والدة بدر بن صالح الراجحي وأولادها»، تطبيق (الباقيات أذكار) بلغات متعددة، للهواتف والأجهزة الذكية ، وهو تطبيق متخصص لعرض الأذكار من الكتاب والسنة بصورة تفاعلية سهلة، مع العديد من المزايا.",
        "image": "https://www.guidetosunnah.com/storage/posts/app-image-5abc4c0a5360436_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/app-image-5abc4c0a5360436_showWebsiteThumb.jpg",
        "stores": {
          "ios": "https://apps.apple.com/sa/app/%D8%A7%D9%84%D8%A8%D8%A7%D9%82%D9%8A%D8%A7%D8%AA-%D8%A3%D8%B0%D9%83%D8%A7%D8%B1-azkar-albaqiyat/id1041788729",
          "android": "https://play.google.com/store/apps/details?id=com.arabiait.azkar&hl=ar&gl=US"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-137ttbyk-137mota-137alamam-137malk",
        "title": "تطبيق موطأ الإمام مالك",
        "description": "تطبيق إسلامى يحتوي على جميع أحاديث كتاب ( الموطأ للإمام مالك).",
        "image": "https://www.guidetosunnah.com/storage/posts/mota501_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/mota501_showWebsiteThumb.png",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=com.reda.malek"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-138ttbyk-138ryad-138alsalhyn-138maa-138alshrh-138almbst",
        "title": "تطبيق رياض الصالحين مع الشرح المبسط",
        "description": "",
        "image": "https://www.guidetosunnah.com/storage/posts/ryad505_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/ryad505_showWebsiteThumb.png",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=com.reda.riyadh&hl=ar"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-139ttbyk-139snn-139aby-139daod",
        "title": "تطبيق سنن أبي داود",
        "description": "تطبيق إسلامي يحتوي على جميع أحاديث كتاب ( سنن أبي داود).",
        "image": "https://www.guidetosunnah.com/storage/posts/daod509_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/daod509_showWebsiteThumb.png",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=com.reda.abidawood"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-140ttbyk-140snn-140abn-140magh",
        "title": "تطبيق سنن ابن ماجه",
        "description": "",
        "image": "https://www.guidetosunnah.com/storage/posts/majh513_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/majh513_showWebsiteThumb.png",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=com.reda.majah"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-141ttbyk-141alahadyth-141alkdsy-141maa-141alshrh",
        "title": "تطبيق الأحاديث القدسية مع الشرح",
        "description": "",
        "image": "https://www.guidetosunnah.com/storage/posts/kdsy516_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/kdsy516_showWebsiteThumb.png",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=com.reda.holyhadiths"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-142ttbyk-142snn-142altrmthy",
        "title": "تطبيق سنن الترمذي",
        "description": "تطبيق يحتوي على جميع أحاديث كتاب سنن الترمذي المسمى بـ «الجامع المختصر من السنن عن رسول الله ومعرفة الصحيح والمعلول وما عليه العمل».",
        "image": "https://www.guidetosunnah.com/storage/posts/altrmthy519_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/altrmthy519_showWebsiteThumb.png",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=com.reda.termezy"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-143ttbyk-143snn-143alnsayy",
        "title": "تطبيق سنن النسائي",
        "description": "تطبيق إسلامى يحتوى على جميع أحاديث كتاب سنن النسائي المسمى بـ «المجتبى من السنن الكبرى».",
        "image": "https://www.guidetosunnah.com/storage/posts/alnsaey523_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/alnsaey523_showWebsiteThumb.png",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=com.reda.nasa2y"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-144ttbyk-144almaagm-144alsghyr",
        "title": "تطبيق المعجم الصغير",
        "description": "تطبيق إسلامي يحتوى على جميع أحاديث كتاب ( المعجم الصغير ).",
        "image": "https://www.guidetosunnah.com/storage/posts/maajm527_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/maajm527_showWebsiteThumb.png",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=com.reda.mo3jamS"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-145ttbyk-145snn-145aldarmy",
        "title": "تطبيق سنن الدارمي",
        "description": "هو تطبيق إسلامى يحتوي على جميع أحاديث كتاب ( سنن الدارمي )، ويحتوي هذا الكتاب على 3567 حديثـًا من أحاديث رسول الله صلى الله عليه وسلم.",
        "image": "https://www.guidetosunnah.com/storage/posts/aldarmy1529_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/aldarmy1529_showWebsiteThumb.png",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=com.reda.daremy&hl=ar"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-146ttbyk-146alshmayl-146almhmdy",
        "title": "تطبيق الشمائل المحمدية",
        "description": "تطبيق إسلامي يحتوي على جميع أحاديث كتاب الشمائل المحمدية. الشمائل المحمدية هو أحد كتب السيرة، ألفه الإمام أبو عيسى محمد الترمذي (209-279) صاحب كتاب سنن الترمذي، ذكر الترمذي في هذا الكتاب أوصاف النبي الخلقية والخُلقية صحيحة موثقة، وبين الشمائل والأخلاق والآداب التي تحلى بها للتأسي به سلوكاً وعملاً واهتداءً، وقد بذل فيه الترمذي جهدا كبيرا يدل على كثرة حفظه واتساع روايته، فقسمه إلى 55 بابا، وجمع فيه حوالي 400 حديثا.",
        "image": "https://www.guidetosunnah.com/storage/posts/shmael533_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/shmael533_showWebsiteThumb.png",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=com.reda.shama2el&hl=ar&gl=US"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-147ttbyk-147nor-147alykyn-147fy-147syr-147syd-147almrslyn",
        "title": "تطبيق نور اليقين في سيرة سيد المرسلين",
        "description": "سيرة النبي محمد ﷺ بداية من نسبه مرورا بحياته والأحداث التي كانت فيها وانتهاء بمعجزاته عليه أفضل السلام وأتم التسليم.",
        "image": "https://www.guidetosunnah.com/storage/posts/nor537_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/nor537_showWebsiteThumb.png",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=com.neama_reda.nooralyaqin"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-148ttbyk-148nor-148alaayon-148fy-148tlkhys-148syr-148alamyn",
        "title": "تطبيق نور العيون في تلخيص سيرة الأمين",
        "description": "نور العيون في تلخيص سيرة الأمين المأمون ﷺ، لابن سيد الناس.",
        "image": "https://www.guidetosunnah.com/storage/posts/alaayon540_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/alaayon540_showWebsiteThumb.png",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=com.neama_reda.nooraleyoon"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-149ttbyk-149ndr-149hdyth-149hadith",
        "title": "تطبيق نضر ( حديث - Hadith )",
        "description": "تطبيق يعرض لك حديث يوميًا مع شرح الحديث ومعاني المفردات وفوائد مستخرجه من الحديث وترجمة باللغه الانجليزيه لشرح الحديث",
        "image": "https://www.guidetosunnah.com/storage/posts/ndr543_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/ndr543_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/us/app/%D9%86%D8%B6%D8%B1-%D8%AD%D8%AF%D9%8A%D8%AB-hadith/id1505529704",
          "android": "https://play.google.com/store/apps/details?id=hadith.nadr.com"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-150ttbyk-150albahth-150alhdythy",
        "title": "تطبيق الباحث الحديثي",
        "description": "",
        "image": "https://www.guidetosunnah.com/storage/posts/bahth546_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/bahth546_showWebsiteThumb.png",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=com.thedawah.hadith"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-152ttbyk-152hadith-152collection-152all-152in-152one",
        "title": "تطبيق Hadith Collection (All in one)",
        "description": "14 كتاب من كتب الحديث وأكثر من 41000 حديث مع ميزة البحث في تطبيق واحد",
        "image": "https://www.guidetosunnah.com/storage/posts/hadith552_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/hadith552_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/us/app/hadith-collection-all-in-one/id1511696610",
          "android": "https://play.google.com/store/apps/details?id=com.greentech.hadith&hl=en&gl=US"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-153ttbyk-153gamaa-153alshyhyn-153maa-153alsot",
        "title": "تطبيق جامع الصحيحين مع الصوت",
        "description": "كتاب \"جامع الصحيحين\"، تأليف: د. \"وليد بن عبدالرحمن الحمدان\".",
        "image": "https://www.guidetosunnah.com/storage/posts/jamaa555_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/jamaa555_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/us/app/%D8%AC%D8%A7%D9%85%D8%B9-%D8%A7%D9%84%D8%B5%D8%AD%D9%8A%D8%AD%D9%8A%D9%86-%D9%85%D8%B9-%D8%A7%D9%84%D8%B5%D9%88%D8%AA/id1549462302",
          "android": "https://play.google.com/store/apps/details?id=com.almaalem_ye.jamea_alsahiheen"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-154ttbyk-154mosoaa-154alahadyth-154alnboy-154almtrgm",
        "title": "تطبيق موسوعة الأحاديث النبوية المترجمة",
        "description": "مشروع متكامل لاختيار الأحاديث النبوية المتكررة في المحتوى الإسلامي وشرحها بصورة مبسطة ووافية، ثم ترجمتها بجودة عالية وفق إجراءات دقيقة إلى اللغات الحية، وإتاحتها مجاناً بكل الوسائل المتاحة.",
        "image": "https://www.guidetosunnah.com/storage/posts/mawso3a558_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/mawso3a558_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/us/app/hadeethenc/id1561038652",
          "android": "https://play.google.com/store/apps/details?id=com.hadeethenc.app"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-155ttbyk-155tkryb-155alsn-155alnboy",
        "title": "تطبيق تقريب السنة النبوية",
        "description": "مكتبة إلكترونية تتيح تصفح كتب الشيخ صالح أحمد الشامي",
        "image": "https://www.guidetosunnah.com/storage/posts/sunnah561_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/sunnah561_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/us/app/%D8%AA%D9%82%D8%B1%D9%8A%D8%A8-%D8%A7%D9%84%D8%B3%D9%86%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-hadith/id1546216363",
          "android": "https://play.google.com/store/apps/details?id=smartech.online.taqreeb.sunnah"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-156ttbyk-156boab-156alsyr-156alnboy",
        "title": "تطبيق بوابة السيرة النبوية",
        "description": "تطبيق السيرة النبوية هو تطبيق إلكتروني مجاني غير ربحي، يخاطب شعوب العالم بمختلف مستوياتهم ولغاتهم باستخدام أحدث الأساليب المتاحة، لتعريفهم بالسيرة العطرة لرسول الله محمد (صلى الله عليه وسلم) والإجابة عن التساؤلات ودحض الشبهات من خلال تطبيق تفاعلي مستند على المصادر الشرعية الموثوقة فيما ورد حول سيرة الرسول (صلى الله عليه وسلم).",
        "image": "https://www.guidetosunnah.com/storage/posts/syoe564_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "تعريف بالنبي ﷺ",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/syoe564_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/us/app/al-sirah-%D8%A8%D9%88%D8%A7%D8%A8%D8%A9-%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9/id1164145998",
          "android": "https://play.google.com/store/apps/details?id=com.itgsolutions.sera"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-162ttbyk-162ktb-162mton-162talb-162alaalm",
        "title": "تطبيق كتب متون طالب العلم",
        "description": "يحتوي التطبيق على أربعة عشر كتاب من المتون العلمية تتضمن ثمانية مستويات وهي المستوى التمهيدي والمستوى الأول حتى المستوى السادس بالإضافة الى مستوى المتون الإضافية.",
        "image": "https://www.guidetosunnah.com/storage/posts/mton572_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "تعريف بالنبي ﷺ",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/mton572_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/sa/app/id1550735120?platform=iphone",
          "android": "https://play.google.com/store/apps/details?id=com.enseyab.MotoonBooks&hl=ar&gl=US"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-164ttbyk-164kn-164maarfa-164brsol-164allh",
        "title": "تطبيق كن معرفا برسول الله",
        "description": "مشروع عالمي يسعى لمساعدة الدعاة وتأهيـــل الشبــــــاب على الدعوة للإسلام والتعريف بسيــد الأنام صلى الله عليه وسلم بشتى الوسائل والتقنيات الحديثة . عدم اقتصار الدعوة على أفراد بعينهم وتجديد روح الدعوة والتعريف برسول الله صلى الله عليه وسلم في نفوس شباب الأمة وتوفير البيئة المناسبة لذلك .",
        "image": "https://www.guidetosunnah.com/storage/posts/maarf575_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "تعريف بالنبي ﷺ",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/maarf575_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/us/app/%D9%83%D9%86-%D9%85%D8%B9%D8%B1%D9%81%D8%A7-%D8%A8%D8%B1%D8%B3%D9%88%D9%84-%D8%A7%D9%84%D9%84%D9%87/id1545351485?platform=iphone",
          "android": "https://play.google.com/store/apps/details?id=konMoarfan.rasoulallah.net&hl=ar&gl=US"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-165ttbyk-165alsyr-165alnboy-165bsot-165bdr-165almshary",
        "title": "تطبيق السيرة النبوية بصوت بدر المشاري",
        "description": "",
        "image": "https://www.guidetosunnah.com/storage/posts/almshary578_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/almshary578_showWebsiteThumb.png",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=com.BadrAlMishary.sirahnabawiyah"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-166ttbyk-166alsyr-166alnboy-166fy-166alf-166soal",
        "title": "تطبيق السيرة النبوية في ألف سؤال",
        "description": "",
        "image": "https://www.guidetosunnah.com/storage/posts/soeal581_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/soeal581_showWebsiteThumb.png",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=sand.onethousands.modern"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-177adaaony",
        "title": "ادعوني",
        "description": "أدعية من القرآن الكريم وصحيح السنة؛ يُدعى بها في ساعات ومواطن الإجابة، وفي مشاعر الحج والعمرة.",
        "image": "https://www.guidetosunnah.com/storage/posts/adaaony737_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "تعريف بالنبي ﷺ",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/adaaony737_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/tr/app/%D8%A7%D8%AF%D8%B9%D9%88%D9%86%D9%8A/id1403373314?platform=iphone",
          "android": "https://play.google.com/store/apps/details?id=com.arabiait.udoony&hl=ar&gl=US"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-180almosoaa-180alaakdy",
        "title": "الموسوعة العقدية",
        "description": "تطبيق شامل ومجاني للموسوعة العقدية بموقع الدرر السنية، يشمل جميع مسائل العقيدة والتوحيد على منهج أهل السنة والجماعة، ويحوي عدداً كبيراً من الإمكانيات والمميزات المتطورة مثل:",
        "image": "https://www.guidetosunnah.com/storage/posts/aakdy740_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/aakdy740_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/eg/app/%D8%A7%D9%84%D9%85%D9%88%D8%B3%D9%88%D8%B9%D8%A9-%D8%A7%D9%84%D8%B9%D9%82%D8%AF%D9%8A%D8%A9/id1658507430",
          "android": "https://play.google.com/store/apps/details?id=net.dorar.aqeeda"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-181fkh-181allbas-181oalzyn",
        "title": "فقه اللباس والزينة",
        "description": "تطبيق شامل مجاني لفقه اللباس والزينة، يحوي جميع الإمكانات والمميزات الموجودة في موقع الدرر السنية، مع إمكانية الحصول على خدمة التصفح والبحث دون الحاجة إلى إتصال بالإنترنت.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2023-02-28-202138741_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "تعريف بالنبي ﷺ",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2023-02-28-202138741_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/us/app/%D9%81%D9%82%D9%87-%D8%A7%D9%84%D9%84%D8%A8%D8%A7%D8%B3-%D9%88%D8%A7%D9%84%D8%B2%D9%8A%D9%86%D8%A9/id1238580632?ls=1",
          "android": "https://play.google.com/store/apps/details?id=com.dorar.libas"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-182ma-182alaslam",
        "title": "ما الإسلام",
        "description": "تعرف على الإسلام وتعاليمه السمحة وما هي خصائص الشريعة الإسلامية وماذا قدم الإسلام إلى العالم ونظرة الإسلام إلى العديد من القضايا الهامة والكثير من المقالات الهامة داخل التطبيق.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2023-03-21-182927752_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "تعريف بالنبي ﷺ",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2023-03-21-182927752_showWebsiteThumb.png",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=com.mfk4apps.what_is_islam"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-183algmaa-183byn-183alshyhyn",
        "title": "الجمع بين الصحيحين",
        "description": "تطبيق « الجمع بين الصحيحين » إصدار جمعية سنن التعليمية تنفيذ مركز حفاظ السنة، يعرض نسخة رقمية لكتاب الجمع بين الصحيحين تأليف الشيخ الحافظ يحيى اليحيى، مع شرح مختصر له، وبيان غريبه وقراءة صوتية مرتبة على الكتب والأبواب، مع إمكانية البحث يعين الحافظ والزائر على الاستفادة منه بيسر وسهولة.",
        "image": "https://www.guidetosunnah.com/storage/posts/aljmaa758_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/aljmaa758_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/app/id1621893047",
          "android": "https://play.google.com/store/apps/details?id=com.hoffadhApp&hl=ar&gl=US"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-184shrh-184aamd-184alahkam-184abn-184baz",
        "title": "شرح عمدة الأحكام - ابن باز",
        "description": "",
        "image": "https://www.guidetosunnah.com/storage/posts/aamd-alahkam762_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/aamd-alahkam762_showWebsiteThumb.png",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=com.omdatahkam.ibnbaz&hl=ar&gl=US"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-185rod-185alafham",
        "title": "روض الأفهام",
        "description": "تطبيق كتاب روض الأفهام للشيخ محمد القناص يشرح فيه كتاب بلوغ المرام للحافظ أحمد بن علي بن حجر العسقلاني.",
        "image": "https://www.guidetosunnah.com/storage/posts/rod766_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/rod766_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/app/id1468019176",
          "android": "https://play.google.com/store/apps/details?id=com.raothalafham&hl=ar&gl=US"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-186almntkhb-186mn-186almaaany",
        "title": "المنتخب من المعاني",
        "description": "تطبيق المنتخب من المعاني المستنبطة من الأحاديث في فتح الباري.",
        "image": "https://www.guidetosunnah.com/storage/posts/mntkhb770_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/mntkhb770_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/app/id1365017269",
          "android": "https://play.google.com/store/apps/details?id=com.montakhap.montakhap2&hl=ar&gl=US"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-187gamaa-187almlk-187aabdallh-187llsn-187alnboy-187almthr",
        "title": "جامع الملك عبدالله للسنة النبوية المطهرة",
        "description": "",
        "image": "https://www.guidetosunnah.com/storage/posts/aabdallh773_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/aabdallh773_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/app/id1637888723?platform=iphone",
          "android": "https://play.google.com/store/apps/details?id=sunna.alifta.gov.sa&hl=ar&gl=US"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-188knz-188klmat-188alhdyth-188alshryf",
        "title": "كنز كلمات الحديث الشريف",
        "description": "دليل شامل لمشاريع خدمة السنة النبوية وعلومها وما يتعلق بهما من مبادرات ومنتجات وأفكار، يضع بين يدي المهتمين ما يعينهم على معرفة الأعمال القائمة وآفاق التحسين والتطوير وأوجه الاحتياج.",
        "image": "https://www.guidetosunnah.com/storage/posts/knz778_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/knz778_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/app/id1562635307",
          "android": "https://play.google.com/store/apps/details?id=com.alemi.hadeethwordstreasure&hl=ar&gl=US"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-189knoz-189alaalm",
        "title": "كنوز العلم",
        "description": "تطبيق كنوز العلم",
        "image": "https://www.guidetosunnah.com/storage/posts/knoz782_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "تعريف بالنبي ﷺ",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/knoz782_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/app/id1387295963",
          "android": "https://play.google.com/store/apps/details?id=com.kidsapp.baynoona&hl=ar&gl=US"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-190alhfath-190alsghar",
        "title": "الحفاظ الصغار",
        "description": "تطبيق تفاعلي يأخذ بأيدي أطفالنا الأحباب إلى التعلق بالسنة النبوية المطهرة، والتزام آدابها، والسلوك على دربها، عن طريق برنامج لحفظ أحاديث نبينا المصطفى صلى الله عليه وسلم، ومعرفة معانيها وإرشاداتها التربوية، ومطالعة أسماء الصحابة الأعلام رواة الأحاديث الأجلاء رضي الله عنهم أجمعين، كل ذلك بطريقة سهلة وممتعة، وشاشات تصميمية شيقة.",
        "image": "https://www.guidetosunnah.com/storage/posts/alhfath1785_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/alhfath1785_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/app/id1142617356",
          "android": "https://play.google.com/store/apps/details?id=com.muslimapps.hadith4kids&hl=ar&gl=US"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-191almslm-191alsghyr",
        "title": "المسلم الصغير",
        "description": "هو برنامج متميز يعلم الأطفال من ٦-١٢ سنة الأمور المهمة في مجال أصول الإيمان والمهم من أحكام الطهارة والصلاة، مع نبذة في السيرة النبوية، والآداب الإسلامية وبعض الأحاديث النبوية المختصرة التي تناسب الصغار، بطريقة تفاعلية كتابةً وصوتاً.",
        "image": "https://www.guidetosunnah.com/storage/posts/almslm-alsghyr791_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "تعريف بالنبي ﷺ",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/almslm-alsghyr791_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/sa/app/%D8%A7%D9%84%D9%85%D8%B3%D9%84%D9%85-%D8%A7%D9%84%D8%B5%D8%BA%D9%8A%D8%B1/id1491555630?l=ar",
          "android": "https://play.google.com/store/apps/details?id=app.islam&hl=ar&gl=US"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-198hdyth-198tgalogh",
        "title": "حديث تجالوغ",
        "description": "",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2023-11-28-190341803_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2023-11-28-190341803_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/us/app/hadith-tagalog/id6466199461?platform=iphone",
          "android": "https://play.google.com/store/apps/details?id=com.hadithTagalog.jsd&hl=en&gl=US"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-200hfath-200altalb",
        "title": "حفاظ - الطال‪ب",
        "description": "",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2023-12-30-190407805_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2023-12-30-190407805_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/kw/app/%D8%AD%D9%81%D8%A7%D8%B8-%D8%A7%D9%84%D8%B7%D8%A7%D9%84%D8%A8/id1604822853?l=ar",
          "android": "https://play.google.com/store/apps/details?id=com.arabdt.hoffaz&hl=en&gl=US"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-201almktb-201alsoty-201llktb-201altsaa",
        "title": "المكتبة الصوتية للكتب التسعة",
        "description": "يحتوي تسجيلات صوتية للكتب التسعة للسنة النبوية بمعدل (52355) حديث في (454) مادة صوتية.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-01-02-194908806_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-01-02-194908806_showWebsiteThumb.png",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=com.Sunah9book"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-204ttbyk-204mktb-204alshykh-204saayd-204bn-204aaly-204bn-204ohf-204alkhtany",
        "title": "تطبيق مكتبة الشيخ سعيد بن علي بن وهف القحطاني",
        "description": "مكتبة وقفية رقمية مفهرسة خاصة بكتب الشيخ سعيد بن علي بن وهف القحطاني، تحتوي على خدمات بحث وخدمات تفاعلية، تتميز بحداثة المحتوى وإمكانية إدارة المعلومة آليًا، مع سهولة الوصول إليها.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-06-29-193603812_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-06-29-193603812_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/sa/app/%D9%85%D9%83%D8%AA%D8%A8%D8%A9-%D8%A7%D9%84%D8%B4%D9%8A%D8%AE-%D8%B3%D8%B9%D9%8A%D8%AF-%D8%A8%D9%86-%D8%B9%D9%84%D9%8A-%D8%A8%D9%86-%D9%88%D9%87%D9%81/id14666080"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-207ttbyk-207shyh-207aldaaaaa-207oalthnaaa-207aal-207allh",
        "title": "تطبيق صحيح الدعاء والثناء على الله",
        "description": "تطبيق يجمع الأدعية الصحيحة بتخريجها؛ ليدعوَ بها المؤمن على بصيرة، مجتنبًا الأدعية البدعية المنتشرة في أوساط المسلمين اليوم، وليحسن اللجوء إلى الله تعالى ملتزمًا باب عبودية دعائه ورجائه، فما خاب عبدٌ دعاه، ولا ضاق أمرٌ بعبدٍ رجاه.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-06-29-195953815_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "تعريف بالنبي ﷺ",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-06-29-195953815_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/us/app/%D8%B5%D8%AD%D9%8A%D8%AD-%D8%A7%D9%84%D8%AF%D8%B9%D8%A7%D8%A1-%D9%88-%D8%A7%D9%84%D8%AB%D9%86%D8%A7%D8%A1-%D8%B9%D9%84%D9%89-%D8%A7%D9%84%D9%84%D9%87/id155702746",
          "android": "https://play.google.com/store/apps/details?id=com.smartech.doa.eqtidaa"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-208mktb-208almbr-208mabarrah-208library",
        "title": "مكتبة المبرة - Mabarrah Library",
        "description": "تطبيق يقدم جميع إصدارات المبرة المقروءة والمسموعة والمرئية، وغيرها من مخرجات المبرة، وبإمكانيات مميزة.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-07-02-194147816_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "دفاع عن السنة",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-07-02-194147816_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/us/app/%D9%85%D9%83%D8%AA%D8%A8%D8%A9-%D8%A7%D9%84%D9%85%D8%A8%D8%B1%D8%A9-mabarrah-library/id1439434994",
          "android": "https://play.google.com/store/apps/details?id=my.mabarrah&hl=ar"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-210awrad-210aorad",
        "title": "Awrad - أوراد",
        "description": "تطبيق يشتمل على محتوى كتاب أوراد أهل السنة والجماعة للشيخ مؤيد عبدالفتاح حمدان، نقدمه للمستخدمين لتكون الأدعية معهم وعلى هواتفهم وجميع أجهزتهم أينما كانوا، وهو يهدف إلى توفير الأدعية الصحيحة وإيصالها إلى المسلمين في أي مكان، ويتميز بإمكانية الاستماع إلى هذه الأذكار المسجلة بأصوات مذيعين معروفَين.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-07-02-195340818_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-07-02-195340818_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/us/app/awrad-%D8%A3%D9%88%D8%B1%D8%A7%D8%AF/id458544588",
          "android": "https://play.google.com/store/apps/details?id=com.awrad.android&hl=ar"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-211mgmoaa-211ftao-211abn-211tymy",
        "title": "مجموع فتاوى ابن تيمية",
        "description": "هذا التطبيق موسوعة رقمية متكاملة لفتاوى الإمام ابن تيمية، والتي تعد من أهم الكتب الشرعية في المكتبة الإسلامية العامرة، ويعتبر هذا المشروع الرقمي المتطور خدمة إضافية مهمة لتراث فتاوى هذا الإمام الذي له مكانة جليلة بين علماء المسلمين، والتطبيق يعمل على نظامي أبل وأندرويد، ويواكب المشاريع الرقمية الجديدة من جميع النواحي، وتدعو إليه الحاجة الملحة لخدمة تراث الشيخ والإسهام في نشره عالميًّا.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-07-03-175903819_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-07-03-175903819_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/us/app/%D9%85%D8%AC%D9%85%D9%88%D8%B9-%D9%81%D8%AA%D8%A7%D9%88%D9%89-%D8%A7%D8%A8%D9%86-%D8%AA%D9%8A%D9%85%D9%8A%D8%A9-fatawa/id6443640155",
          "android": "https://play.google.com/store/apps/details?id=online.smartech.ibntaymia&hl=ar"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/post-63901774726728",
        "title": "من حقهم في المساجد خطب",
        "description": "دليل شامل لمشاريع خدمة السنة النبوية وعلومها وما يتعلق بهما من مبادرات ومنتجات وأفكار، يضع بين يدي المهتمين ما يعينهم على معرفة الأعمال القائمة وآفاق التحسين والتطوير وأوجه الاحتياج.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-07-06-174314820_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "الصم والبكم",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-07-06-174314820_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/us/app/%D9%85%D9%86-%D8%AD%D9%82%D9%87%D9%85-%D9%81%D9%8A-%D8%A7%D9%84%D9%85%D8%B3%D8%A7%D8%AC%D8%AF-%D8%AE%D8%B7%D8%A8-sermons/id6443889126",
          "android": "https://play.google.com/store/apps/details?id=online.smartech.sermons&hl=ar"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-213hsn-213almslm",
        "title": "حصن المسلم",
        "description": "لا يقتصر تطبيق حصن المسلم على الأذكار فقط، إنما يقدم شرحًا وافيًا لها مع خدمة الأدعية الصوتية، وعرض الأذكار بأكثر من 20 لغة، مع تصميم بسيط وجذاب، ويتحقق فيه الكثير من المزايا.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-07-09-184356822_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-07-09-184356822_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/cg/app/%D8%AD%D8%B5%D9%86-%D8%A7%D9%84%D9%85%D8%B3%D9%84%D9%85-hisn-almuslim/id1439791907",
          "android": "https://play.google.com/store/apps/details?id=com.arabiait.hisnmuslim"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-214ttbyk-214mns-214taaa-214altaalymy",
        "title": "تطبيق منصة تاء التعليمية",
        "description": "• هو منصة علمية للعلوم الشرعية تشتمل على دروس في:",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-07-16-190551823_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-07-16-190551823_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/sa/app/%D9%85%D9%86%D8%B5%D8%A9-%D8%AA%D8%A7%D8%A1-%D8%A7%D9%84%D8%AA%D8%B9%D9%84%D9%8A%D9%85%D9%8A%D8%A9/id1594065816",
          "android": "https://play.google.com/store/apps/details?id=com.arabiait.ta2"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-215mktb-215altohyd",
        "title": "مكتبة التوحيد",
        "description": "مكتبة التوحيد تضم بعض الكتب المهمة عن عقيدة التوحيد وأركان الاسلام الخمسة والتطبيق وجميع الكتب التي بداخلها تحمل مجانا لله سبحانه وتعالى وسوف يتم ان شاء الله إضافة الكتب تباعا.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-08-03-094448827_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-08-03-094448827_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/us/app/%D9%85%D9%83%D8%AA%D8%A8%D8%A9-%D8%A7%D9%84%D8%AA%D9%88%D8%AD%D9%8A%D8%AF/id544215080?platform=iphone"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-216aakydty",
        "title": "عقيدتي",
        "description": "تطبيق عقيدتي مُهتمٌّ بتصحيح العقيدة، وتعزيز وسطيّة الاعتقاد، وتسهيل وصولها إلى جميع المسلمين، بعيداً عن كل ما يُسبب الخلافات وإيذاء الآخرين، فالهدف بيان الحق وإظهاره.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-08-03-095051834_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "دفاع عن السنة",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-08-03-095051834_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/us/app/%D8%B9%D9%82%D9%8A%D8%AF%D8%AA%D9%8A/id1598811611",
          "android": "https://play.google.com/store/apps/details?id=com.ebooks.kotob&hl=ar&gl=US"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-217almktb-217alshaml",
        "title": "المكتبة الشاملة",
        "description": "برنامج مجاني يهدف إلى جمع ما يحتاجه طالب العلم من كتب وأبحاث في العلوم الشرعية، وما يخدمها من علوم الآلة، في صيغة نصية قابلة للبحث فيها والنسخ منها.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-08-03-095717839_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-08-03-095717839_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/us/app/%D8%A7%D9%84%D9%85%D9%83%D8%AA%D8%A8%D8%A9-%D8%A7%D9%84%D8%B4%D8%A7%D9%85%D9%84%D8%A9/id1589857697",
          "android": "https://play.google.com/store/apps/details?id=com.arabdt.shamla&hl=ar&gl=US"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-218alsyr-218oaltarykh",
        "title": "السيرة والتاريخ",
        "description": "موسوعة حديثة تحمل فكرة جديدة، فهي موسوعة علمية تاريخية تضم مجموعة من كتب التراث، إلا أن هذه الموسوعة تضم أيضا مدخلا بعنوان (الموسوعة) ويضم هذا المدخل شجرة تاريخية، وتحت هذه الشجرة تم استخلاص أهم النصوص المتعلقة بالأحداث التاريخية المختلفة، لتمثل خلاصة ما قيل حول ذلك الحدث التاريخي، مع عزو المعلومات لموضعها في كتب التراث.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-08-03-100513843_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-08-03-100513843_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/us/app/%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D9%88%D8%A7%D9%84%D8%AA%D8%A7%D8%B1%D9%8A%D8%AE/id1559417471"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-219mosoaa-219alakhlak",
        "title": "موسوعة الأخلاق",
        "description": "تطبيق شامل لموسوعة ضخمة من الأخلاق الإسلامية، وُضِعَت ضمن قوالب وأقسام متنوعة.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-08-03-102144847_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "دفاع عن السنة",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-08-03-102144847_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/us/app/%D9%85%D9%88%D8%B3%D9%88%D8%B9%D8%A9-%D8%A7%D9%84%D8%A3%D8%AE%D9%84%D8%A7%D9%82/id615288603"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-220aathny",
        "title": "عظني",
        "description": "تطبيق عِظني واعظ ناطق بمواعظ الكتاب والسنة والسلف الصالحين، يذكرك بين حين وآخر بكلمات طيبات توقظك إذا غفلت وتذكرك إذا نسيت..",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-08-03-102653851_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "تعريف بالنبي ﷺ",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-08-03-102653851_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/us/app/%D8%B9%D8%B8%D9%86%D9%8A/id1603902438?platform=iphone",
          "android": "https://play.google.com/store/apps/details?id=com.midade.mwa3ez&hl=ar&gl=US"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-221alsn-221oalsyr-221alnboy",
        "title": "السنة والسيرة النبوية",
        "description": "التطبيق يشمل السنة والسيرة النبوية يعرض السيرة النبوية على شكل مقاطع فديو بإخراج مميز من باب التنوع في نشر سيرة نبينا محمد صلى الله عليه وسلم، بالإضافه إلى الأذكار والأدعية، وأقسام جديدة في المستقبل.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-08-06-085826855_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "تعريف بالنبي ﷺ",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-08-06-085826855_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/sa/app/%D8%A7%D9%84%D8%B3%D9%86%D8%A9-%D9%88%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9/id6503708782?platform=iphone"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-223oah-223alam-223ummah-223oasis",
        "title": "واحة الأمة - Ummah Oasis",
        "description": "استمع إلى القرآن الكريم بصوت أكثر من 200 قارئ مع التفسير الصوتي بالإضافة إلى راديو إسلامي يحوي على العديد من القنوات التي تهتم في مجال: (العقيدة، الفقه، الحديث، الأخلاق).",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-08-18-043312858_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-08-18-043312858_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/sa/app/%D9%88%D8%A7%D8%AD%D8%A9-%D8%A7%D9%84%D8%A3%D9%85%D8%A9-ummah-oasis/id6467782028",
          "android": "https://play.google.com/store/apps/details?id=com.ummahoasis"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-224deen-224quran-224hadith-224duas",
        "title": "Deen - Quran, Hadith, Duas",
        "description": "تطبيق إسلامي خالي من الإعلانات يهدف إلى جعل القرآن والحديث في متناول الجميع وإثرائهم. نحن نؤمن أن أي شخص، بغض النظر عن خلفيته أو معتقداته، يمكنه أن يجد قيمة في استكشاف كلام الله سبحانه وتعالى وتوجيهات النبي صلى الله عليه وسلم بشكل مباشر.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-09-07-185530869_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-09-07-185530869_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/us/app/deen-quran-hadith-duas/id1616229199",
          "android": "https://play.google.com/store/apps/details?id=com.deen"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-225takd-225dlyl-225alahadyth-225alnboy",
        "title": "تأكد - دليل الأحاديث النبوية",
        "description": "تطبيق مجاني يهدف إلى مساعدة المسلمين على التحقق من الروايات المختلفة عن الرسول محمد صلى الله عليه وسلم ومعرفة ما إذا كانت صحيحة أم لا. يتميز التطبيق بتصميم بسيط وسهل الاستخدام، ويحتوي على قاعدة بيانات كبيرة تضم العديد من الأحاديث النبوية.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-09-11-185548872_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-09-11-185548872_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/sa/app/%D8%AA%D8%A7%D9%83%D8%AF-%D8%AF%D9%84%D9%8A%D9%84-%D8%A7%D9%84%D8%A7%D8%AD%D8%A7%D8%AF%D9%8A%D8%AB-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9/id6448849653",
          "android": "https://play.google.com/store/apps/details?id=com.yusif.taakad"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-226ahadyth-226alktb-226altsaa",
        "title": "أحاديث الكتب التسعة",
        "description": "تطبيق يجمع أحاديث كل الكتب الخاصة بالحديث الشريف يهدف التطبيق إلى جعل المصححين يقومون بالتأكد من صحة كتابة نص الحديث من حيث التشكيل وطريقة عرض الكلمة.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-09-11-190318879_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-09-11-190318879_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/sa/app/%D8%A3%D8%AD%D8%A7%D8%AF%D9%8A%D8%AB-%D8%A7%D9%84%D9%83%D8%AA%D8%A8-%D8%A7%D9%84%D8%AA%D8%B3%D8%B9%D8%A9/id1599503384",
          "android": "https://play.google.com/store/apps/details?id=com.eqraTech.hadith_test&hl=ar"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-2271000-227hdyth-227mn-227shyh-227albkhary",
        "title": "1000 حديث من صحيح البخاري",
        "description": "",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-09-11-193046883_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-09-11-193046883_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/sa/app/1000-%D8%AD%D8%AF%D9%8A%D8%AB-%D9%85%D9%86-%D8%B5%D8%AD%D9%8A%D8%AD-%D8%A7%D9%84%D8%A8%D8%AE%D8%A7%D8%B1%D9%8A/id6474170271",
          "android": "https://play.google.com/store/apps/details?id=com.zahabea.buxare&hl=en_US"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-228roa-228alhdyth",
        "title": "رواة الحديث",
        "description": "تطبيق شامل ويسير للبحث عن رتبة وبيانات رواة الحديث النبوي. التطبيق يحتوي على بيانات أكثر من ٤٥٠٠٠ ألف رواي للحديث النبوي وهو سهل الاستخدام وفعال حيث يساعد طلاب ومحبي علم الحديث على معرفة حال الراوي عن طريق البحث عن اسمه أو شهرته لمعرفة إذا كان ثقة، أو مقبول أو ضعيف أو مجهول، بناء على كلام علماء الحديث مثل ابن حجر، والذهبي، وأحمد، والنسائي، والرازي وغيرهم. التطبيق يحتوي أيضا على بيانات أخرى مثل عن حياة الراوي وشيوخه وتلاميذه.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-09-11-193857886_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-09-11-193857886_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/sa/app/%D8%B1%D9%88%D8%A7%D8%A9-%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB-hadith-narrators/id6478346360",
          "android": "https://play.google.com/store/apps/details?id=com.rwahAlHadeth.rwahAlHadeth&hl=ar"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-229athkar-229almslm",
        "title": "أذكار المسلم",
        "description": "الآن وبعد طول انتظار نقدم لكم تطبيق \"أذكار المسلم\" الجديد، والذي من خلاله ستقضون تجربة إيمانية رائعة لا مثيل لها.. عبر إظهار الأذكار والأدعية على الشاشة أثناء تصفحك للهاتف، وبشكل مميز دون الحاجة للدخول إلى البرنامج!",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-09-11-200109891_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-09-11-200109891_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/us/app/%D8%A7%D8%B0%D9%83%D8%A7%D8%B1-%D8%A7%D9%84%D9%85%D8%B3%D9%84%D9%85-%D8%AD%D8%B5%D9%86-%D8%A7%D9%84%D9%85%D8%B3%D9%84%D9%85/id1536074432",
          "android": "https://play.google.com/store/apps/details?id=com.third.update.muslim&hl=en_US"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-230athkar-230alyom",
        "title": "أذكار اليوم",
        "description": "يقول ابن القيم رحمه الله حاجه العبد للمعوذات اشد من حاجته للطعام والشراب واللباس - داوم على أذكارك لتدرك معنى احفظ الله يحفظك - فلا تنسى ذكر الله وحافظ على أذكار اليوم فهي حصن المسلم.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-09-11-200653894_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-09-11-200653894_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/us/app/%D8%A3%D8%B0%D9%83%D8%A7%D8%B1-%D8%A7%D9%84%D9%8A%D9%88%D9%85-%D8%AD%D8%B5%D9%86-%D8%A7%D9%84%D9%85%D8%B3%D9%84%D9%85/id1493123965",
          "android": "https://play.google.com/store/apps/details?id=com.azabonline.athkar_daily&hl=ar"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-231seerah-231of-231prophet-231muhammad-231saw",
        "title": "Seerah of Prophet Muhammad SAW",
        "description": "تعرف على سيرة النبي محمد ﷺ، من يوم ولادته حتى يوم وفاته، والتاريخ العربي السابق، والدروس المستفادة من الأحداث، والملخصات السريعة والمزيد من هذا التطبيق الجميل.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-12-04-172913898_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-12-04-172913898_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/us/app/seerah-of-prophet-muhammad-saw/id1523463430",
          "android": "https://play.google.com/store/apps/details?id=org.gtaf.seerah"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-232hsn-232alaslam",
        "title": "حصن الإسلام",
        "description": "تطبيق رائع جداً يحتاجه كل داعية يحتوي مايلي:",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-12-14-185329903_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "دفاع عن السنة",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-12-14-185329903_showWebsiteThumb.png",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=com.islam.hesn.myapplication"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-233gamaa-233alsn-233oshrohha",
        "title": "جامع السنة وشروحها",
        "description": "جامِعُ السُنَّة وشُروحِها\" بوابة ضخمة لخدمة السُنَّةِ النبوية المطهرة، بجمع عدد كبير من شروح كتب السُنَّةِ ، بحيث يمكن مطالعتها لنفس الحديث بحسب تخريجه من كتب السُنَّةِ.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2025-03-18-184353905_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2025-03-18-184353905_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/sa/app/hadith-portal-%D8%AC%D8%A7%D9%85%D8%B9-%D8%A7%D9%84%D8%B3%D9%86%D8%A9/id6605934911?l=ar",
          "android": "https://play.google.com/store/apps/details?id=com.Islamics.HadithPortal&hl=tr"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-235goahr-235alhdyth",
        "title": "جواهر الحديث",
        "description": "تطبيق شامل يجمع أكثر من ٨٢٠٠ حديث نبوي صحيح ومُسنَد، منتقاة بعناية من أمهات الكتب كالصحيحين والسنن الأربعة دون تكرار.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2025-11-08-190705916_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2025-11-08-190705916_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/sa/app/%D8%AC%D9%88%D8%A7%D9%87%D8%B1-%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB/id6747139606?l=ar",
          "android": "https://play.google.com/store/apps/details?id=com.jawahir.peet"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/item-236hfath-236almton",
        "title": "حفاظ المتون",
        "description": "تطبيق \"حفاظ المتون\" يعد واحدًا من مشاريع مركز تميز العلمية والتقنية، حيث يتناول المتون العلمية في مختلف فروع العلوم الشرعية. يشمل التطبيق متون العقيدة، والحديث، والفقه، واللغة العربية، والتجويد، والسيرة النبوية، ومتون طلاب العلم. هدفنا في هذا المشروع هو مساعدتك في حفظ ومراجعة هذه المتون من خلال توفير خطة فعّالة. يمكنك تخصيص أيام الحفظ وجداول الأوراد بسهولة، بالإضافة إلى ميزات علمية متقدمة مثل تنبيهات الأوراد والاختبارات والإحصائيات وسجل الإنجازات والشهادات. كما يوفر المشغل الصوتي إمكانية سماع المتون بسهولة أثناء التنقل.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2026-02-12-184638920_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2026-02-12-184638920_showWebsiteThumb.png",
        "stores": {
          "ios": "https://apps.apple.com/ee/app/%D8%AD%D9%81%D8%A7%D8%B8-%D8%A7%D9%84%D9%85%D8%AA%D9%88%D9%86/id1582827587",
          "android": "https://play.google.com/store/apps/details?id=com.tamayyuzcenter.huffazulmutoon"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/post-37531780928479",
        "title": "الصحيحان: البخاري ومسلم",
        "description": "تطبيق إسلامي مخصص للبحث في الحديث النبوي الشريف وموجه للأجهزة التي تعمل بنظام أندرويد، ضم التطبيق كتابي \"صحيح البخاري\" (7008 حديث) و\"صحيح مسلم\" (5362 حديث) كاملة بالشرح والتشكيل، ويعمل بشكل كامل بدون إنترنت.",
        "image": "https://www.guidetosunnah.com/storage/posts/c2Psm4XS7kXjIOMOc5ffNL33ymUlzAXjVfo73wI2_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/c2Psm4XS7kXjIOMOc5ffNL33ymUlzAXjVfo73wI2.png",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=mhashim6.android.thetwoauthentics&gl=us"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/post-76251781363960",
        "title": "موسوعة صحيح البخاري",
        "description": "نسخة رقمية شاملة وموثوقة لكتاب الجامع الصحيح للإمام محمد بن إسماعيل البخاري، يضم التطبيق المتن الكامل لصحيح البخاري مع الشروح الوافية والإحالات العلمية المتعلقة به، يركز التطبيق كشعار أساسي على \"الدقة والإتقان\" خلال مراحل مراجعة النصوص النبوية وتدقيقها.",
        "image": "https://www.guidetosunnah.com/storage/posts/NFrkePgcTFkDSjGpzE9bnDIPAPe4NEW4tUJsDKQf_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/NFrkePgcTFkDSjGpzE9bnDIPAPe4NEW4tUJsDKQf.png",
        "stores": {
          "ios": "https://apps.apple.com/us/app/%D9%85%D9%88%D8%B3%D9%88%D8%B9%D8%A9-%D8%B5%D8%AD%D9%8A%D8%AD-%D8%A7%D9%84%D8%A8%D8%AE%D8%A7%D8%B1%D9%8A/id1104789662",
          "android": "https://play.google.com/store/apps/details?id=com.attaat_alalam.bukhari_pedia"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/post-40491781797287",
        "title": "فذكر",
        "description": "تطبيق إسلامي شامل ومجاني صُمم ليكون رفيقاً يومياً يساعد المسلم على أداء عباداته وتطوير معرفته الدينية، يمثل مرجعاً ضخماً للحديث النبوي، حيث يضم (صحيح البخاري، صحيح مسلم، رياض الصالحين، بلوغ المرام، والأربعون النووية والقدسية) مع ميزة البحث السهل، كما يحتوي على قسم فتاوى شامل للإجابة عن الأسئلة الشرعية اليومية بناءً على فتاوى الشيخ ابن باز.",
        "image": "https://www.guidetosunnah.com/storage/posts/C6fHLAlRkmgdgv6MYxm8iZbsi3YWlHXcPZ29kLDs_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/C6fHLAlRkmgdgv6MYxm8iZbsi3YWlHXcPZ29kLDs.png",
        "stores": {
          "ios": "https://apps.apple.com/eg/app/fazakir-%D9%81%D8%B0%D9%83%D8%B1/id6741119077",
          "android": "https://play.google.com/store/apps/details?id=com.mm.fazakir"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/post-16081781797874",
        "title": "قدوتي - Qudwaty",
        "description": "تطبيق تعليمي وترفيهي تفاعلي موجه للأطفال والنشء (خاصة في الفئة العمرية بين 9 إلى 11 سنة). يهدف التطبيق إلى تعريف الأطفال بسيرة النبي محمد ﷺ بطريقة مبسطة، واستلهام الدروس والقيم منها لتنمية شخصيتهم السلوكية والدينية، يعتمد التطبيق على أسلوب مشوق وجذاب يتناسب مع لغة العصر للأطفال، بعيداً عن التلقين التقليدي الجاف.",
        "image": "https://www.guidetosunnah.com/storage/posts/MFriJeXRl8IRQxAZIb0tFX5hOyrh5YZtHFjRk0oX_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/MFriJeXRl8IRQxAZIb0tFX5hOyrh5YZtHFjRk0oX.png",
        "stores": {
          "ios": "https://apps.apple.com/us/app/%D9%82%D8%AF%D9%88%D8%AA%D9%8A-qudwaty/id6711348873",
          "android": "https://play.google.com/store/apps/details?id=net.qudwaty.app"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/post-43211781798183",
        "title": "The Daily Hadith",
        "description": "تطبيق إلكتروني مميز ومتاح لأجهزة الآيفون والآيباد، مصمم ليكون مكتبة متنقلة تجمع الأحاديث النبوية الشريفة من مصادرها الأصلية المعتمدة لخدمة المسلمين والراغبين في التعلم عن الإسلام باللغتين العربية والإنجليزية.",
        "image": "https://www.guidetosunnah.com/storage/posts/AnoP6f15MrXiODm28kwsHhPwxsmB2RFMS7PlnDOu_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/AnoP6f15MrXiODm28kwsHhPwxsmB2RFMS7PlnDOu.png",
        "stores": {
          "ios": "https://apps.apple.com/us/app/the-daily-hadith/id1596647132"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/post-36341782055593",
        "title": "Islam360",
        "description": "أحد أضخم وأشمل التطبيقات الإسلامية يُعرف التطبيق بأنه أول تطبيق محرك بحث ذكي متقدم ومخصص للقرآن الكريم والحديث النبوي الشريف ، مما يجعله وجهة أساسية لكل طالب علم أو مسلم يبحث عن التحقق من النصوص الشرعية بيسر وسهولة، يوفر التطبيق النصوص الكاملة والمنقحة لكتب الحديث السبعة الرئيسية المعتمدة لدى الأمة الإسلامية؛ كما يحتوي على مجموعات ومراجع تكميلية هامة مثل كتاب (مشكاة المصابيح، السلسلة الصحيحة، وسنن البيهقي)، و يمكنك البحث عن أي حديث بكتابة كلمة منه، والاطلاع على حكم المحدثين على صحته وسنده مع إمكانية الاستماع للأحاديث صوتيًا.",
        "image": "https://www.guidetosunnah.com/storage/posts/NJ7y2xhYMALQF00t8D5I30TTGmjYOtpkrEdZ8w9y_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/NJ7y2xhYMALQF00t8D5I30TTGmjYOtpkrEdZ8w9y.png",
        "stores": {
          "ios": "https://apps.apple.com/us/app/islam360-quran-hadith-qibla/id1006098149",
          "android": "https://play.google.com/store/apps/details?id=com.islam360&gl=us"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/post-85461782228620",
        "title": "دلائل",
        "description": "التطبيق الرسمي الجامع للمبادرات والبرامج التعليمية التابعة لمركز دلائل.",
        "image": "https://www.guidetosunnah.com/storage/posts/2QWiisnID0EEuHZ861C4BrCrrQI8JGke6LQY9zkw_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "دفاع عن السنة",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/2QWiisnID0EEuHZ861C4BrCrrQI8JGke6LQY9zkw.png",
        "stores": {
          "ios": "https://apps.apple.com/us/app/%D8%AF%D9%84%D8%A7%D8%A6%D9%84/id6748205952",
          "android": "https://play.google.com/store/apps/details?id=app.dalail.ilm"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/post-18841782228855",
        "title": "الاستشهاد الصحيح",
        "description": "تطبيق مبتكر يقدم لوحة مفاتيح ذكية مخصصة للهواتف، تهدف إلى تسهيل اقتباس نصوص الوحيين (الكتاب والسنة) بدقة وسرعة، بحيث : تتيح لك لوحة المفاتيح البحث الفوري داخل نصوص القرآن الكريم أو أحاديث الصحيحين (البخاري ومسلم)، وإدراج النتيجة مباشرة في أي تطبيق محادثة أو شبكة تواصل اجتماعي دون الحاجة للكتابة اليدوية.",
        "image": "https://www.guidetosunnah.com/storage/posts/9HazZPzCCIIVyWc4652y7TMkaulldMVm2zRBmowq_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/9HazZPzCCIIVyWc4652y7TMkaulldMVm2zRBmowq.png",
        "stores": {
          "ios": "https://apps.apple.com/sa/app/the-correct-quotation/id1557031461",
          "android": "https://play.google.com/store/apps/details?id=com.moia.qurankeyboard&gl=us"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/post-15451782230304",
        "title": "سيرة - السيرة النبوية",
        "description": "تطبيق تعليمي تفاعلي يهدف إلى تقديم السيرة النبوية بأسلوب ممتع ومشوق يعتمد على التنافس واللعب، يأخذ المستخدم في رحلة رقمية شيقة للاستماع إلى السيرة النبوية، حيث ينتقل عبر محطات ومراحل يتجاوز تحدياتها لجمع النقاط ومنافسة الأصدقاء، يتميز بدقة التفاصيل وحسن السرد القصصي عبر سلاسل صوتية أبرزها \"قصة النور\"، كما يوفر خاصية \"القبسات\" لمشاركة الفوائد عبر وسائل التواصل.",
        "image": "https://www.guidetosunnah.com/storage/posts/AreO9iR0TefXqpS6OSOnvrQCH9aaTNuocZfw3rOi_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/AreO9iR0TefXqpS6OSOnvrQCH9aaTNuocZfw3rOi.png",
        "stores": {
          "ios": "https://apps.apple.com/sa/app/%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9/id6747294522",
          "android": "https://play.google.com/store/apps/details?id=qafelah_app.qafelah_app"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/post-81451782401341",
        "title": "صحيح الإمام البخاري باللغة الروسية",
        "description": "تطبيق إسلامي مجاني مخصص لمستخدِمي هواتف الآيفون باللغة الروسية، يهدف إلى تسهيل القراءة والبحث في كتاب \"الجامع المسند الصحيح\" للإمام البخاري، بحيث يوفر التطبيق الأدوات الجوهرية التي يحتاجها القارئ، وهي تصفح الأحاديث، البحث النصي السريع، وإمكانية إضافة الأحاديث إلى قائمة \"المفضلة\" للرجوع إليها لاحقاً، كما يحتوي التطبيق على أدلة ومراجع كتابية إضافية يمكن الوصول إليها عبر القائمة الجانبية للتطبيق لتوسيع الفهم العلمى للمستخدم.",
        "image": "https://www.guidetosunnah.com/storage/posts/xJyZWu8zLVcxjBnachK3SO70Vj7Wy7gjp5mGV9rj_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/xJyZWu8zLVcxjBnachK3SO70Vj7Wy7gjp5mGV9rj.png",
        "stores": {
          "ios": "https://apps.apple.com/us/app/%D1%81%D0%B0%D1%85%D0%B8%D1%85-%D0%B8%D0%BC%D0%B0%D0%BC%D0%B0-%D0%B0%D0%BB%D1%8C-%D0%B1%D1%83%D1%85%D0%B0%D1%80%D0%B8/id1169031640"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/post-82371782831431",
        "title": "رسول الله ﷺ (السيرة - أسئلة)",
        "description": "ت طبيق يهدف إلى تعريف المستخدمين بسيرة النبي محمد ﷺ بطريقة تفاعلية ومبسطة، يقدم استعراضاً شاملاً لحياة الرسول ﷺ من الولادة حتى الوفاة دون نت، كما يحتوي على أكثر من 200 سؤال ديني متنوع بنظام الاختيار من متعدد (أربعة خيارات) ونظام ملء الفراغات.",
        "image": "https://www.guidetosunnah.com/storage/posts/PU3Gta32wsD8TrFyRHut6cQ1gUW1hTLgXIuwVY6B_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "تعريف بالنبي ﷺ",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/PU3Gta32wsD8TrFyRHut6cQ1gUW1hTLgXIuwVY6B.png",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=com.anas_mugally.rasul_allah&gl=us"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/post-80641782832757",
        "title": "Hadith حديث - Sahih Bukhari",
        "description": "مرجعا إلكترونيا مميز يجمع دواوين السنة النبوية المطهرة في مكان واحد للاستخدام اليومي والبحث، يتضمن المتن الكامل باللغة العربية لكل من: صحيح البخاري، صحيح مسلم، جامع الترمذي، سنن أبي داود، سنن النسائي، وسنن ابن ماجة، كما يد عم التطبيق ترجمة \"صحيح البخاري\" إلى اللغتين الإنجليزية والأوردية إلى جانب النص العربي الأصلي.",
        "image": "https://www.guidetosunnah.com/storage/posts/zMX0jeWmwEUPRMaa2ftvYSFbwMEsPZrBqkd4VYtJ_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "دفاع عن السنة",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/zMX0jeWmwEUPRMaa2ftvYSFbwMEsPZrBqkd4VYtJ.png",
        "stores": {
          "ios": "https://apps.apple.com/us/app/hadith-%D8%AD%D8%AF%D9%8A%D8%AB-sahih-bukhari/id578547597",
          "android": "https://play.google.com/store/apps/details?id=com.pakdata.hadith&gl=us"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/post-97851782918097",
        "title": "سنن ونصائح الرسول",
        "description": "تطبيق تعليمي خفيف يعمل بدون إنترنت ، يجمع أكثر من 100 من السنن النبوية والأذكار الصحيحة اليومية كأذكار الصباح والمساء وآداب الصيام.",
        "image": "https://www.guidetosunnah.com/storage/posts/WLOyP7bh3CIJBqOqR8yfgnvLEoagVDqT5ltKHP6Z_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "تعريف بالنبي ﷺ",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/WLOyP7bh3CIJBqOqR8yfgnvLEoagVDqT5ltKHP6Z.png",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=com.ionicframework.myapp154537&gl=us"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/post-97941783522499",
        "title": "تطبيق Hadith Pro: Sunnah, Grades",
        "description": "موسوعة رقمية شاملة ومفتوحة المصدر مصممة لخدمة السنة النبوية وتيسير دراسة الأحاديث الشريفة عبر الهواتف الذكية. تتيح المنصة للمستخدمين قراءة طيف واسع من المتون المترجمة لثماني لغات عالمية أساسية منها العربية، والإنجليزية، والفرنسية، والأردية، مع بيان درجة صحة وتخريج كل حديث وفقاً لتحقيق كبار المحدثين كالشيخين الألباني والأرنؤوط. يوفر البرنامج تجربة استخدام ميسرة وسلسة بفضل واجهته العصرية المحدثة، وتوفيره لمحرك بحث متطور بخيارات تصفية دقيقة وميزة المفضلة.",
        "image": "https://www.guidetosunnah.com/storage/posts/Ch7ZkE7BO7HJTMSe4zmzxdAToqPysN9pK9Y46chn_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/Ch7ZkE7BO7HJTMSe4zmzxdAToqPysN9pK9Y46chn.png",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=com.islamicproapps.hadithpro&gl=us"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/apps/show/post-32611783523451",
        "title": "سيرة الصحابة والتابعين بدون نت",
        "description": "موسوعة تاريخية رقمية تعمل دون الحاجة لاتصال بالإنترنت، وتقدم سرداً وثائقياً متكاملاً لقصص ومواقف رجال ونساء عاصروا النبي محمد ﷺ ونصروه في نشر الرسالة الإسلامية. يضم البرنامج محتوى متنوعاً يجمع بين السير المكتوبة والمقاطع الصوتية والمرئية التي تغطي حياة الخلفاء الراشدين، والعشرة المبشرين بالجنة، وكبار الصحابة والتابعين، بالإضافة إلى قسم خاص بالصحابيات الفضليات يستعرض نسبهن وقصة إسلامهن ودورهن التاريخي.",
        "image": "https://www.guidetosunnah.com/storage/posts/IVYNnyDqmJ1NOF3Fmu9owhhPuCz8eNqLxDP8GI7l_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/IVYNnyDqmJ1NOF3Fmu9owhhPuCz8eNqLxDP8GI7l.png",
        "stores": {
          "android": "https://play.google.com/store/apps/details?id=com.atlasdata.sirat.sahaba&gl=us"
        }
      }
    ]
  },
  "website": {
    "root": "https://www.guidetosunnah.com/ar/websites",
    "pages": 8,
    "categories": [
      {
        "url": "https://www.guidetosunnah.com/ar/websites/mwaqa-wtbyqat-lkhdmt-alsnt-taryf-balnby",
        "label": "تعريف بالنبي ﷺ"
      },
      {
        "url": "https://www.guidetosunnah.com/ar/websites/mwaqa-wtbyqat-lkhdmt-alsnt-mwswaat-wbhth-hdythy",
        "label": "موسوعات وبحث حديثي"
      },
      {
        "url": "https://www.guidetosunnah.com/ar/websites/mwaqa-wtbyqat-lkhdmt-alsnt-dfaa-an-alsnt",
        "label": "دفاع عن السنة"
      },
      {
        "url": "https://www.guidetosunnah.com/ar/websites/mwaqa-wtbyqat-lkhdmt-alsnt-alsyrt-alnbwyt",
        "label": "السيرة النبوية"
      },
      {
        "url": "https://www.guidetosunnah.com/ar/websites/mwaqa-wtbyqat-lkhdmt-alsnt-api",
        "label": "API"
      },
      {
        "url": "https://www.guidetosunnah.com/ar/websites/deaf_mute",
        "label": "الصم والبكم"
      },
      {
        "url": "https://www.guidetosunnah.com/ar/websites/blind",
        "label": "المكفوفون"
      }
    ],
    "items": [
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-37mosoaa-37alhdyth-37shbk-37aslam-37oyb",
        "title": "موسوعة الحديث (شبكة إسلام ويب)",
        "description": "تعد المكتبة الإلكترونية أحد المنتجات الرئيسية لموقع الشبكة الإسلامية، والتي تهدف إلى تحقيق رسالتها وأهدافها من خلال عرض أهم المراجع والكتب الإسلامية في شتى علوم الدين، سواء كتب التراث أو الكتب المعاصرة، والتي تعد رافدا مهما للباحثين المختصين وغير المختصين من زوار موقع الشبكة، مما يؤدي إلى نشر الوعي الديني لدى المسلمين وتعميق انتمائهم للإسلام وفهم قضاياه.",
        "image": "https://www.guidetosunnah.com/storage/posts/thumb-1920-659155396_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/thumb-1920-659155396_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://library.islamweb.net/hadith/index.php",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-39almosoaa-39alshaml-39mhrk-39bhthy",
        "title": "الموسوعة الشاملة (محرك بحثي)",
        "description": "محرك بحثي ضخم يضم عددًا من الكتب في مختلف الاختصاصات الإسلامية، بالإضافة إلى البحث عن التراجم وغيرها من الميزات.",
        "image": "https://www.guidetosunnah.com/storage/posts/2860ec2912400570395_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/2860ec2912400570395_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "http://islamport.com/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-40mokaa-40hdyth-40llthkk-40mn-40sh-40alhdyth",
        "title": "موقع حديث (للتحقق من صحة الحديث)",
        "description": "موقع حديث هو موقع يساعدك في التحقق من صحة الحديث بسرعة وسهولة ويعتمد الموقع في التحقق من صحة الأحاديث على قاعدة بيانات موقع الدرر السنية",
        "image": "https://www.guidetosunnah.com/storage/posts/alrsol-mhmd452_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/alrsol-mhmd452_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "http://hdith.com/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-45sfh-45alboahth-45alhdythy",
        "title": "صفحة البواحث الحديثية",
        "description": "صفحة إلكترونية تجمع أهم المواقع الإسلامية، كالمكتبة الشاملة، وموقع نداء الإيمان، وموقع صيد الفوائد، وغيرها من المواقع الإسلامية المفيدة.",
        "image": "https://www.guidetosunnah.com/storage/posts/wp4430570392_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/wp4430570392_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "http://www.sultan.org/h/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-46mokaa-46llbhth-46fy-46alahadyth-46alnboy-46alshryf-46ballgh-46alanglyzy",
        "title": "موقع للبحث في الأحاديث النبوية الشريفة باللغة الإنجليزية",
        "description": "موقع ديني مختص باللغة الإنجليزية، يتضمن القرآن الكريم والحديث الشريف مترجمًا، بالإضافة لقناة المدينة وقناة مكة، كما يوجد قسم لتعلم اللغة العربية.",
        "image": "https://www.guidetosunnah.com/storage/posts/almjd-llhdyth-alnboy353_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/almjd-llhdyth-alnboy353_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.searchtruth.com/searchHadith.php",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-49mokaa-49nsr-49mhmd-49rsol-49allh-49sl-49allh-49aalyh-49oslm",
        "title": "موقع نصرة محمد رسول الله – صلى الله عليه وسلم -",
        "description": "يهدف موقع نصرة رسول الله صلى الله عليه وسلم إلى التعريف برسول الله والرد علي الإفتراءات المثارة حوله ونصرة السنة النبوية والعمل على نشرها وإبرازها في المجالات العلمية، والتقنية، والإعلامية، والإجتماعية.",
        "image": "https://www.guidetosunnah.com/storage/posts/logo-252_programSliderThumb.png",
        "country": "",
        "date": "",
        "category": "دفاع عن السنة",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/logo-252_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://rasoulallah.net/ar/articles/category/29",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-50aslam-50haos",
        "title": "إسلام هاوس",
        "description": "موقع مختص بلغات منوَّعة للتعريف بالإسلام، كما ويتضمن مختلف أقسامًا من القرآن والحديث والفقه، بالإضافة للغة العربية والتاريخ والدراسات الإسلامية، مع نافذة محادثة مباشرة مع إداري الموقع.",
        "image": "https://www.guidetosunnah.com/storage/posts/i9wehkpj-400x40053_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "دفاع عن السنة",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/i9wehkpj-400x40053_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://islamhouse.com/ar//",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-51mshroaa-51alhsn",
        "title": "مشروع الحصن",
        "description": "موقع مختص بالرد على الشبهات والمشككين بالدين الإسلامي الحنيف، كما ويتضمن قسمًا خاصًّا للأسئلة والأجوبة حول الإسلام، بالإضافة لقسم من المرئيات والصوتيات.",
        "image": "https://www.guidetosunnah.com/storage/posts/capture401_programSliderThumb.png",
        "country": "",
        "date": "",
        "category": "دفاع عن السنة",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/capture401_showWebsiteThumb.png",
        "primaryAction": {
          "url": "http://www.alhesn.net",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-52shbk-52aldfaaa-52aan-52alsn",
        "title": "شبكة الدفاع عن السنة",
        "description": "موقع إخباري يتضمن قسمًا للأخبار، والمقالات، بالإضافة لقسم الصوتيات والمرئيات، يعرض آراءً ويرد على الشبهات.",
        "image": "https://www.guidetosunnah.com/storage/posts/4kghkgh457_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "دفاع عن السنة",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/4kghkgh457_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.dd-sunnah.net/records/list/id/7/frmSortBy/rec_date/frmSortOrder/ASC/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-55mokaa-55klm-55bodkast",
        "title": "موقع قلم بودكاست",
        "description": "موقع قلم بودكاست (الدفاع عن شرف النبي – صلى الله عليه وسلم -)",
        "image": "https://www.guidetosunnah.com/storage/posts/http-wwwqalaminstituteorg-wp-content-uploads-powerpress-qalam-pod-02456_programSliderThumb.png",
        "country": "",
        "date": "",
        "category": "دفاع عن السنة",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/http-wwwqalaminstituteorg-wp-content-uploads-powerpress-qalam-pod-02456_showWebsiteThumb.png",
        "primaryAction": {
          "url": "http://www.qalaminstitute.org/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-56mokaa-56maa-56alhbyb-56sl-56allh-56aalyh-56oslm-56akbr-56mokaa-56llsyr-56alnboy",
        "title": "موقع مع الحبيب – صلى الله عليه وسلم – (أكبر موقع للسيرة النبوية)",
        "description": "موقع يعرض سيرة النبي صلى الله عليه وسلم، مع إمكانية ترجمته إلى عدة لغات عالمية، هادفًا لنشر سيرته صلى الله عليه وسلم.",
        "image": "https://www.guidetosunnah.com/storage/posts/almsjd-alnboy352_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/almsjd-alnboy352_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.withprophet.com/ar",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-58mokaa-58alsrag-58llsyr-58alnboy",
        "title": "موقع السراج للسيرة النبوية",
        "description": "تطبيقًا لحديث رسول الله صلى الله عليه وسلم: (إذا ماتَ ابْنُ آدَم انقَطَع عَملُهُ إلاَّ مِنْ ثَلاثٍ: صَدقَةٍ جارية، أوْ عِلمٍ ينتفَعُ بِهِ، أوْ وَلدٍ صالحٍ يدْعُو لَهُ) أنشئ موقع السراج للسيرة النبوية، لجمع مادة علمية عن السيرة النبوية الشريفة، بالإضافة إلى أقسام منوَّعة.",
        "image": "https://www.guidetosunnah.com/storage/posts/artworks-y5wsmaeo9hokzvqt-vzptog-t500x500458_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/artworks-y5wsmaeo9hokzvqt-vzptog-t500x500458_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.alsiraj.net/sira/html/page00.html",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-59alsyr-59alnboy-59mokaa-59ks-59alaslam",
        "title": "السيرة النبوية (موقع قصة الإسلام)",
        "description": "موقع تاريخ إسلامي شامل باللغات العربية، والإنجليزية، والفرنسية، والإسبانية، والصينية، والبرتغالية، والإندونيسية، والروسية.",
        "image": "https://www.guidetosunnah.com/storage/posts/59f0aca3atext350_programSliderThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/59f0aca3atext350_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://islamstory.com/ar/cat/622/%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-60mosoaa-60alktrony-60aan-60alsyr-60alnboy",
        "title": "موسوعة إلكترونية عن السيرة النبوية",
        "description": "موسوعة الكترونية عن السيرة النبوية تشمل أبرز المؤلفات التي عنيت بسرد وتدوين سيرة النبي صلى الله وسلم وصفاته وأخلاقه، وتبلغ الكتب في الموسوعة أربعة عشر مؤلفاً.",
        "image": "https://www.guidetosunnah.com/storage/posts/various-book-books407_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/various-book-books407_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://rasoulallah.net/ar/articles/article/10942/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-62alsyr-62alnboy-62mokaa-62alshykh-62mstf-62alaadoy",
        "title": "السيرة النبوية - موقع الشيخ مصطفى العدوي",
        "description": "السيرة النبوية - موقع الشيخ مصطفى العدوي",
        "image": "https://www.guidetosunnah.com/storage/posts/shutterstock-1856140747346_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/shutterstock-1856140747346_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.mostafaaladwy.com/catsmktba-1386.html",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-66alsyr-66alnboy-66mokaa-66nbras-66alhk",
        "title": "السيرة النبوية - موقع نبراس الحق",
        "description": "صفحة خاصة من موقع نبراس الحق، يتضمن مقالات متنوعة عن السيرة النبوية الشريفة، بالإضافة إلى الغزوات وغيرها من الأحداث.",
        "image": "https://www.guidetosunnah.com/storage/posts/items-1881405_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/items-1881405_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "http://www.nebrasselhaq.com/2010-06-14-20-21-52",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-70mokaa-70nby-70alaslam-70mn-70dlyl-70alaslam",
        "title": "موقع نبي الإسلام - من دليل الإسلام",
        "description": "موقع تعريفي بالنبي صلى الله عليه وسلم، وسيرته، كما فيه تعريف عن الحضارة الإسلامية، بالإضافة إلى قسم خاص للفنون الإسلامية.",
        "image": "https://www.guidetosunnah.com/storage/posts/sfat-alnby-mhmd-alkhlky-oalkhlky388_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "تعريف بالنبي ﷺ",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/sfat-alnby-mhmd-alkhlky-oalkhlky388_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "http://theprophetofislam.org/en",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-71mokaa-71rsol-71allh-71sl-71allh-71aalyh-71oslm",
        "title": "موقع رسول الله – صلى الله عليه وسلم -",
        "description": "موقع يعرِّف بالنبي صلى الله عليه وسلم، يتضمن كتبًا وصوتيات، وخطبًا ومرئيات عن النبي، بعدِّة لغات عالمية، كما ويمكنك مشاركة محتويات الموقع عبر وسائل التواصل الاجتماعي.",
        "image": "https://www.guidetosunnah.com/storage/posts/logo-252_programSliderThumb.png",
        "country": "",
        "date": "",
        "category": "تعريف بالنبي ﷺ",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/logo-252_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://rasoulallah.net/ar/articles/category/30",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-73alnby-73mhmd-73sl-73allh-73aalyh-73oslm-73mokaa-73islamreligion",
        "title": "النبي محمد – صلى الله عليه وسلم – موقع IslamReligion",
        "description": "هذا الموقع مخصص للأشخاص من مختلف العقائد الذين يسعون إلى فهم الإسلام والمسلمين.",
        "image": "https://www.guidetosunnah.com/storage/posts/img-h387_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "تعريف بالنبي ﷺ",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/img-h387_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.islamreligion.com/ar/category/79/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-74alrsol-74mhmd-74sl-74allh-74aalyh-74oslm-74mokaa-74islamweb",
        "title": "الرسول محمد – صلى الله عليه وسلم – موقع IslamWeb",
        "description": "صفحة باللغة الإنجليزية، ضمن موقع إسلام ويب، فيه تعريف بالنبي صلى الله عليه وسلم، وبنسائه، وبجزيرة العرب، كما يوجد فيه مقالات مختلفة موجَّه لغير الناطقين بالعربية.",
        "image": "https://www.guidetosunnah.com/storage/posts/mhmd-rsol-allh-660x330386_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "تعريف بالنبي ﷺ",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/mhmd-rsol-allh-660x330386_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.islamweb.net/en/articles/74/prophet-muhammad",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-76altaaryf-76balnby-76mhmd-76sl-76allh-76aalyh-76oslm-76mokaa-76islam-76guide",
        "title": "التعريف بالنبي محمد – صلى الله عليه وسلم – موقع Islam-Guide",
        "description": "This Islamic guide is for non-Muslims who would like to understand Islam, Muslims (Moslems), and the Holy Quran (Koran). It is rich in information, references, bibliography, and illustrations.",
        "image": "https://www.guidetosunnah.com/storage/posts/aleslam330_programSliderThumb.png",
        "country": "",
        "date": "",
        "category": "تعريف بالنبي ﷺ",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/aleslam330_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.islam-guide.com/ch3-8.htm",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-103mshbat",
        "title": "مشبات",
        "description": "تصميم مشب امريكي تصميم مشب مودرن ديكور مشب رجال ديكور مشب مودرن",
        "image": "https://www.guidetosunnah.com/storage/posts/5468a00add52436b8e0f9473d1534aa9470_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/5468a00add52436b8e0f9473d1534aa9470_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "http://chemnees13.xtgem.com/index",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-104sor-104dykorat-104mshbat-104modrn",
        "title": "صور ديكورات مشبات مودرن",
        "description": "ديكورات مشبات مودرن – ديكورات مشبات",
        "image": "https://www.guidetosunnah.com/storage/posts/156216809-3801719569920497-8049210429122624113-n471_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/156216809-3801719569920497-8049210429122624113-n471_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://abjdhoaz13.wordpress.com/2015/09/07/%D8%B5%D9%88%D8%B1-%D9%85%D8%B4%D8%A8%D8%A7%D8%AA-%D9%86%D8%A7%D8%B1-%D8%A7%D9%86%D9%88%D8%A7%D8%B9-%D8%A7%D9%84%D9%85%D8%B4%D8%A8%D8%A7%D8%AA/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-107hadeeth-107pro-107ui",
        "title": "hadeeth-pro-ui",
        "description": "react hadith front-end التصنيفات: موسوعة حديثية",
        "image": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "API",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://github.com/ibrahim-sobhy/hadeeth-pro-ui",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-108hadeeth",
        "title": "hadeeth",
        "description": "angular front-end, and backend API written by Serverless Framework is a free and open-source web framework written using Node.js التصنيفات: موسوعة حديثية",
        "image": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "API",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://github.com/ibrahim-sobhy/hadeeth",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-109almuharrarfialhadeeth",
        "title": "AlMuharrarFiAlHadeeth",
        "description": "المحرر في الحديث الكتاب مكون من xml,Html, js, في صورة كتاب يتم التقليب فيه كما الكتاب المحرر في الحديث لابن عبد الهادي التركي التصنيفات: موسوعة حديثية",
        "image": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "API",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://github.com/sjcrams/AlMuharrarFiAlHadeeth",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-110get-110a-110randomly-110selected-110hadith",
        "title": "get-a-randomly-selected-hadith",
        "description": "restful API Arabic, English التصنيفات: موسوعة حديثية",
        "image": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "API",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://sunnah.api-docs.io/1.0/hadiths/get-a-randomly-selected-hadith",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-111hadith-111api",
        "title": "hadith-api",
        "description": "6 books language supported Arabic and Indonesia Translation, nodejs express framework التصنيفات: موسوعة حديثية",
        "image": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "API",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://github.com/sutanlab/hadith-api",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-112ahadith-112apiherokuapp",
        "title": "ahadith-api.herokuapp",
        "description": "The following endpoints are supported by the Hadith API. They all support the HTTP GET method and return JSON. language supported Arabic and English التصنيفات: موسوعة حديثية",
        "image": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "API",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://ahadith-api.herokuapp.com/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-113open-113hadith-113data",
        "title": "Open-Hadith-Data",
        "description": "csv books",
        "image": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "API",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://github.com/mhashim6/Open-Hadith-Data",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-114hadith-114islamware",
        "title": "hadith-islamware",
        "description": "Hadith CVS files arabic language only التصنيفات: موسوعة حديثية",
        "image": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "API",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://github.com/ceefour/hadith-islamware",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-115sunnah-115com-115api",
        "title": "sunnah-com - api",
        "description": "",
        "image": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "API",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://github.com/sunnah-com/api",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-116corrections",
        "title": "corrections",
        "description": "python front adn backend for hadith corrections التصنيفات: موسوعة حديثية",
        "image": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "API",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://github.com/sunnah-com/corrections",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-117sunnah-117com-117website",
        "title": "sunnah-com - website",
        "description": "This is the front end code for sunnah.com . It is built atop the Yii 2 MVC framework.",
        "image": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "API",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://github.com/sunnah-com/website",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-118hadithreader",
        "title": "HadithReader",
        "description": "Hadith reader generaten unique id for each word التصنيفات: موسوعة حديثية",
        "image": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "API",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://github.com/maximromanov/HadithReader",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-119ask-119hadith",
        "title": "ask-hadith",
        "description": "front and backend for search in Hadith search engine powered by Atlas Search , This a PWA . So you can install in devices, both in mobile and PC. You can also filter hadith based on different collections (Bukhari, Muslim etc). And also read mark hadiths for another level of filter, which you have read already. English only التصنيفات: موسوعة حديثية",
        "image": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "API",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://github.com/Ananto30/ask-hadith",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-120hadith-120api",
        "title": "hadith-api",
        "description": "A API for hadiths in bengali language التصنيفات: موسوعة حديثية",
        "image": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "API",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://github.com/RakibRahman/hadith-api",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-121lk-121hadith-121corpus",
        "title": "LK - Hadith - Corpus",
        "description": "python cvs files Leeds University and King Saud University (LK) Hadith Corpus",
        "image": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "API",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://github.com/ShathaTm/LK-Hadith-Corpus",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-122hadith-122graph",
        "title": "hadith-graph",
        "description": "express js (nodejs) A Frontend app for graph knowledge Hadith التصنيفات: موسوعة حديثية",
        "image": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "API",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://github.com/sajadah/hadith-graph",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-123hadithencyclopediamobile",
        "title": "HadithEncyclopediaMobile",
        "description": "mobile app ios, android obsolete date التصنيفات: موسوعة حديثية",
        "image": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "API",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://github.com/fekracomputers/HadithEncyclopediaMobile",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-124sanad-124hadith",
        "title": "sanad-hadith",
        "description": "Hadith SQL database dump for Sanad التصنيفات: موسوعة حديثية",
        "image": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "API",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://github.com/ceefour/sanad-hadith",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-125hadith-125every-125hour",
        "title": "hadith-every-hour",
        "description": "python program post hadith every time التصنيفات: موسوعة حديثية",
        "image": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "API",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://github.com/Ananto30/hadith-every-hour",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-126umma-126hadith",
        "title": "Umma1 - hadith",
        "description": "Hadith is python library that aims to help scholars of hadith to do quantitative research. التصنيفات: موسوعة حديثية",
        "image": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "API",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://github.com/Umma1/hadith",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-127hadith-127of-127the-127day",
        "title": "hadith-of-the-day",
        "description": "Firefox WebExtension that displays a hadith from a collection of ahadith التصنيفات: موسوعة حديثية",
        "image": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "API",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://github.com/TheAdnan/hadith-of-the-day",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-128hadithdb",
        "title": "HadithDB",
        "description": "c# program database (Bukhari, Musliem) التصنيفات: موسوعة حديثية",
        "image": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "API",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://github.com/WaseemKhan/HadithDB",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-129nawawi-12940-129hadith-129for-129andriod",
        "title": "nawawi-40-hadith-for-andriod",
        "description": "java old repository nawawi's 40 hadith for andriod - الاربعين النوويه اندرويد التصنيفات: موسوعة حديثية",
        "image": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "API",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://github.com/abodehq/nawawi-40-hadith-for-andriod",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-130hadithapi",
        "title": "HadithApi",
        "description": "A simple API to fetch random hadith in the Bengali Language. التصنيفات: موسوعة حديثية",
        "image": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "API",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://github.com/Pienteger/HadithApi",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-131rewayaat",
        "title": "rewayaat",
        "description": "java program welcome to the development home of the Rewayaat Hadith Database Project. التصنيفات: موسوعة حديثية",
        "image": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "API",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://github.com/rewayaat/rewayaat",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-132bangla-132hadith-132api",
        "title": "Bangla-Hadith-api",
        "description": "this is a REST API of a huge Hadith collection of different hadith books contain Hadiths in Arabic, Bangla, and English التصنيفات: موسوعة حديثية",
        "image": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "API",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://github.com/alQuranBD/Bangla-Hadith-api",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-133hadith",
        "title": "Hadith",
        "description": "Hadith App (iOS) Hadith app source code that was not released.",
        "image": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "API",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/35q5fqes66ascwws0k473_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://github.com/amrayn/Hadith",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-134ttoyr",
        "title": "تطوير",
        "description": "",
        "image": "https://www.guidetosunnah.com/storage/posts/2016-10-12474_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "دفاع عن السنة",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/2016-10-12474_showWebsiteThumb.jpg"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-135hdyth-135kard",
        "title": "حديث كارد",
        "description": "بطاقات ولوحات ترجمة معاني أحاديث صحيحة",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-4-4476_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-4-4476_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://hadithcards.com/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-136mokaa-136nsr-136alsn",
        "title": "موقع نصرة السنة",
        "description": "موقع إلكتروني - تحت إشراف وقف الإتقان لتعظيم القرآن والسنة - مخصص لتعظيم ونصرة السنة النبوية في المجالات العلمية، والتقنية، والإعلامية؛ بعمل يتحرى الإتقان والجودة.",
        "image": "https://www.guidetosunnah.com/storage/posts/nsr477_programSliderThumb.png",
        "country": "",
        "date": "",
        "category": "دفاع عن السنة",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/nsr477_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://nusrahalsunnah.com/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-158brnamg-158almosoaa-158alhdythy-158aldrr-158alsny",
        "title": "برنامج الموسوعة الحديثية - الدرر السنية",
        "description": "تمتاز هذه الموسوعة بمَيْزات عديدة؛ منها: قاعدة بيانات ضَخمة تَحتوي على مِئات الآلافِ من الأحاديث. عدَد العلماء الذين أُخذت أَحكامُهم عبْر ثلاثةَ عَشرَ قرنًا قُرابة 200 عالمِ. عدد الكتُب التي تمَّ استخراجُ أحكام محدِّثيها أكثرُ من 600 كتابٍ (أكثر من 2500 مجلدٍ). توثيق الحديثِ من مصادرِه المطبوعة برقْم الحديث، أو الجُزء والصَّفحة. إمكانية البَحث بالرَّاوي، أو المحدِّث، أو الكِتاب، أو الجميع. إمكانية البَحث عن الأحاديث القُدسيَّة، والمرفوعة، والآثار. البحث بالتصنيف الموضوعي. وميزات أخرى",
        "image": "https://www.guidetosunnah.com/storage/posts/almosoaa-alhdythy566_programSliderThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/almosoaa-alhdythy566_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.dorar.net/hadith",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-168mokaa-168mercyprophet-168nby-168alrhm",
        "title": "موقع mercyprophet - نبي الرحمة",
        "description": "موقع إسلامي عالمي تعريفيّ يهدف إلى التعريف بالرسول محمد صلى الله عليه وسلم، وتقديم سيرته وأخلاقه وإنجازاته إلى الناس كافة بصورة واضحة قائمة على الحقائق الموثقة، والأرقام المحددة، والحوار الهادف.",
        "image": "https://www.guidetosunnah.com/storage/posts/alrhm651_programSliderThumb.png",
        "country": "",
        "date": "",
        "category": "تعريف بالنبي ﷺ",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/alrhm651_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://mercyprophet.org/mul/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-169alboab-169alhdythy-169aldrr-169alsny",
        "title": "البوابة الحديثية - الدُّرَر السَّنِية",
        "description": "البوابة الحديثية (إحدى خدمات الموسوعة الحديثيَّة في موقع الدُّرَر السَّنِية الإلكتروني).",
        "image": "https://www.guidetosunnah.com/storage/posts/logo-1669_programSliderThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/logo-1669_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://dorar.net/%D8%A7%D9%84%D8%A8%D9%88%D8%A7%D8%A8%D8%A9_%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB%D9%8A%D8%A9",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-171mosoaa-171alahadyth-171alnboy-171otrgmatha",
        "title": "موسوعة الأحاديث النبوية وترجماتها",
        "description": "مشروع موسوعة الأحاديث النبوية وترجماتها: مشروع متكامل لاختيار الأحاديث النبوية المتكررة في المحتوى الإسلامي وشرحها بصورة مبسطة ووافية، ثم ترجمتها بجودة عالية وفق إجراءات دقيقة إلى اللغات الحية، وإتاحتها مجاناً بكل الوسائل المتاحة.",
        "image": "https://www.guidetosunnah.com/storage/posts/new-logo671_programSliderThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/new-logo671_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://hadeethenc.com/ar/home",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-172shbk-172alsn-172alnboy-172oaalomha",
        "title": "شبكة السنة النبوية وعُلومها",
        "description": "موقع متخصص بالسنة النبوية يحوي مصادر السنة ومراجعها وما يتعلق بالسيرة النبوية وشمائل نبينا محمد صلى الله عليه وسلم بالإضافة لعلوم الحديث (مصطلح الحديث – علم الرجال – الجرح والتعديل – التخريج – دراسة الأسانيد) وغيرها من العلوم الحديثية.",
        "image": "https://www.guidetosunnah.com/storage/posts/sunnah672_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/sunnah672_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://alssunnah.com/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-173mokaa-173albahth-173alhdythy",
        "title": "موقع الباحث الحديثي",
        "description": "محرك بحثي، يساعدك بالبحث عن أي حديث بوضع جزء من الحديث في محرك البحث، وتحصل على النتائج المطلوبة بالإضافة إلى تخريج الحديث في الكتب الوارد فيها، كما بإمكانك نسخ نتائج البحث.",
        "image": "https://www.guidetosunnah.com/storage/posts/bahthth673_programSliderThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/bahthth673_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://sunnah.one/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-174mosoaa-174alhdyth-174mn-174shrk-174fkr",
        "title": "موسوعة الحديث - من شركة فكرة",
        "description": "موسوعة الحديث من شركة فكرة، تتضمن المئات من الكتب والمؤلفين، كما وتتضمن أقسامًا للرواة وغيرها من الميزات، بالإضافة إلى إمكانية نسخ الأحاديث وطباعتها.",
        "image": "https://www.guidetosunnah.com/storage/posts/category675_programSliderThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/category675_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://hadith.islam-db.com/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-175boab-175alsyr-175alnboy",
        "title": "بوابة السيرة النبوية",
        "description": "بوابة السيرة النبوية هي بوابة إلكترونية مجانية غير ربحية، تخاطب شعوب العالم على مختلف مستوياتهم ولغاتهم باستخدام أحدث الأساليب المتاحة، لتعريفهم بالسيرة العطرة لرسول الله محمد ﷺ والإجابة عن التساؤلات ودحض الشبهات من خلال بوابة الكترونية تفاعلية، معتمدة على المصادر الشرعية الموثوقة فيما ورد عن سيرة الرسول ﷺ.",
        "image": "https://www.guidetosunnah.com/storage/posts/syr676_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/syr676_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.alsirah.com/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-176mokaa-176tkryb-176alsn-176alnboy",
        "title": "موقع تقريب السنة النبوية",
        "description": "ضمن مبادرة على خطى الرسول صلى الله عليه وسلم، إحدى المبادرات الاستراتيجية لمركز أصول، يأتي مشروع تقريب السنة النبوية مستفيدًا من أعمال الشيخ صالح بن أحمد الشامي حفظه الله في تقريب السنة النبوية، وغيرها من الأعمال العلمية، وقد وقع الاختيار على ثلاثة كتب هي خلاصة عمل الشيخ لما يربو على عقدين من الزمان، جمع فيها كنوز الحديث النبوي الشريف ورتبها ترتيبًا عصريًّا يدني فائدتها لطلابها، من مختلف المستويات العلمية، وهي:",
        "image": "https://www.guidetosunnah.com/storage/posts/whatsapp-image-2023-01-02-at-181952678_programSliderThumb.jpeg",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/whatsapp-image-2023-01-02-at-181952678_showWebsiteThumb.jpeg",
        "primaryAction": {
          "url": "https://sunnahenc.com/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-178alfoayd-178almkhtar-178mn-178fth-178albary",
        "title": "الفوائد المختارة من فتح الباري",
        "description": "فوائد فتح البارئ - سلطان العمري",
        "image": "https://www.guidetosunnah.com/storage/posts/fatholbari738_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/fatholbari738_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://s-alamri.com/article/details/17848",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-179foayd-179mn-179hdyth",
        "title": "فوائد من حديث",
        "description": "مجموعة فوائد من الأحاديث النبوية الشريفة.",
        "image": "https://www.guidetosunnah.com/storage/posts/foaed739_programSliderThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/foaed739_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://s-alamri.com/article/details/3218",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-192tkoyn-192alraskhyn",
        "title": "تكوين الراسخين",
        "description": "منهج شامل للعلوم الشرعية مع شروح ومواد أخرى.",
        "image": "https://www.guidetosunnah.com/storage/posts/app-4793_programSliderThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/app-4793_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://takw.in/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-193trath",
        "title": "تراث",
        "description": "تطبيق «تراث» مكتبة إسلامية تعمل على كافة الأجهزة (بشرط استخدام متصفح حديث). تتميز بعدة أمور، منها: سهولة التعامل والقراءة المريحة والبحث الفوري في كل نصوص المكتبة.",
        "image": "https://www.guidetosunnah.com/storage/posts/app-5794_programSliderThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/app-5794_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://app.turath.io/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-194mosoaa-194byan-194alaslam-194alalktrony-194almysr-194blghat-194alaaalm",
        "title": "موسوعة بيان الإسلام الإلكترونية الميسرة بلغات العالم",
        "description": "موسوعة إلكترونية لمواد منتقاة للتعريف بالإسلام وتعليمه باللغات، تتضمن مواد مرئية ومقروءة ومسموعة منتقاة بعناية، لبيان حقيقة الإسلام ولتعليم المسلم ما يحتاجه لإقامة دينه.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2023-07-16-213701795_programSliderThumb.png",
        "country": "",
        "date": "",
        "category": "دفاع عن السنة",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2023-07-16-213701795_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://byenah.com/ar",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/post-18791774727248",
        "title": "بوابة الصم - إسلام ويب",
        "description": "قسم خاص من موقع إسلام ويب للصم يضم مرئيات إسلامية بموضوعات مختلفة كالفقه والعقيدة والأحاديث النبوية وغيرها مشروحة بلغة الإشارة.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2023-07-19-214929797_programSliderThumb.png",
        "country": "",
        "date": "",
        "category": "الصم والبكم",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2023-07-19-214929797_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.islamweb.net/ar/deaf/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/post-49021774726993",
        "title": "مجموعة كتب بلغة الإشارة - الألوكة",
        "description": "مجموعة كتب بلغة الإشارة مقدمة من مكتبة الألوكة بمواضيع مختلفة.",
        "image": "https://www.guidetosunnah.com/storage/posts/326155791-1207628506549020-3292065372911974208-n799_programSliderThumb.png",
        "country": "",
        "date": "",
        "category": "الصم والبكم",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/326155791-1207628506549020-3292065372911974208-n799_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.alukah.net/authors/view/home/7441/%D9%85%D8%AD%D9%85%D9%88%D8%AF-%D9%85%D8%AD%D9%85%D8%AF-%D8%A3%D8%A8%D9%88-%D8%A7%D8%B2%D8%BA%D8%B1%D9%8A%D8%AA/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-197akadymy-197zad-197alaalmy",
        "title": "أكاديمية زاد العلمية",
        "description": "أكاديمية للتعليم الشرعي بمستويات أربعة، تتضمن محتوى علمي يخدم العلوم الشرعية، بشكل ميسر، بعيدًا عن الغريب والمشكل، ويمكن التسجيل فيها للأعمار فوق 15 سنة مجانًا بسهولة،",
        "image": "https://www.guidetosunnah.com/storage/posts/387156510-715284503968739-6947936707779389209-n802_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "تعريف بالنبي ﷺ",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/387156510-715284503968739-6947936707779389209-n802_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://register.zad-academy.com/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/post-72611781711764",
        "title": "منصة حفاظ التعليمية",
        "description": "جهة تعليمية غير ربحية، متخصصة بتعليم الحديث النبوي، حفظاً وتفهماً، وتحمل على عاتقها نشره، مواكبة في ذلك التقنية الحديثة.",
        "image": "https://www.guidetosunnah.com/storage/posts/347833827-1323058111956068-3336656884807265514-n804_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/347833827-1323058111956068-3336656884807265514-n804_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://sonann.org/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-203mokaa-203mktb-203alshykh-203saayd-203bn-203aaly-203bn-203ohf-203alkhtany",
        "title": "موقع مكتبة الشيخ سعيد بن علي بن وهف القحطاني",
        "description": "مكتبة وقفية خاصة بكتب وخطب ومرئيات الشيخ سعيد بن علي بن وهف القحطاني.",
        "image": "https://www.guidetosunnah.com/storage/posts/nn811_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/nn811_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.binwahaf.com/portal/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-205mokaa-205ndaaa-205alaslam",
        "title": "موقع نداء الإسلام",
        "description": "موقع مخصص للصوتيات الإسلامية، يعتبر بمثابة خزانة تحتوي على الآلاف من الصوتيات التي تتميز بجودتها العالية، وذلك في المجالات التالية: التلاوات القرآنية: 688 مصحفًا مرتلاً، الدروس والخطب: 23200 درس وخطبة، الأناشيد: 589 ألبوماً و 3132 أنشودة، كما يتميز بالفهرسة الواضحة وبأناقة الترتيب، إضافة إلى قائمة بأسماء أصحاب هذه الصوتيات، مع ذكر الصوتيات المتعلقة بكل منهم.",
        "image": "https://www.guidetosunnah.com/storage/posts/twitter1-400x400813_programSliderThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/twitter1-400x400813_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.islam-call.com/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-206mokaa-206shyh-206aldaaaaa-206oalthnaaa-206aal-206allh-206taaal",
        "title": "موقع صحيح الدعاء والثناء على الله تعالى",
        "description": "بوابة إلكترونية لنشر محتوى كتاب صحيح الدعاء والثناء على الله تعالى، لفضيلة الدكتور عبدالله بن حمود الفريح، بـ 50 لغة، تهدف إلى نشر جوامع الدعاء، وتبيين أهميته وآدابه، بمختلف لغات العالم، وتحوي الصيغ الصحيحة للثناء على الله، والأدعية الصحيحة التي يعتني بها المسلم وتهمُّه طوال يومه.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-06-29-195637814_programSliderThumb.png",
        "country": "",
        "date": "",
        "category": "تعريف بالنبي ﷺ",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2024-06-29-195637814_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://doa.eqtidaa.com/ar",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-209mbr-209alal-209oalashab",
        "title": "مبرة الآل والأصحاب",
        "description": "قامت مؤسسة قاف بتصميم وتطوير موقع مبرة الآل والأصحاب في الكويت، الذي يقدم جميع إصدارات المبرة المقروءة والمسموعة والمرئية، وغيرها من مخرجات المبرة، إضافةً إلى إعداد تطبيق خاص بكتب المبرة على أبل وأندرويد.",
        "image": "https://www.guidetosunnah.com/storage/posts/298443837-483724680423672-2184279793658383585-n817_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "دفاع عن السنة",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/298443837-483724680423672-2184279793658383585-n817_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://almabarrah.net/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-222almns-222alhdythy",
        "title": "المنصة الحديثية",
        "description": "المنصة الحديثية هي منصة رائدة في علم الحديث، تأتي ضمن المشاريع التقنية والعلمية لمركز تميز، وتهدف إلى خدمة الحديث النبوي دراية ورواية، مستخدمة أحدث وسائل التكنولوجيا؛ وتضم أهم المصنفات الحديثية وشروحها وعللها وأحكامها وغريبها بالإضافة لكتب الجرح والتعديل، وتقدم المنصة للمستخدمين كل المعلومات بأحدث التقنيات، بداية من تيسير البحث عن الأحاديث النبوية بنصوصها ومعانيها، مرورًا بتشجير طرق الحديث المتعددة، وصولًا إلى عرض هذه المعلومات بطريقة عصرية منظمة تفيد الباحثين والمهتمين في مجال الحديث النبوي الشريف.",
        "image": "https://www.guidetosunnah.com/storage/posts/454041362-122100048164459444-3460006086115914139-n857_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/454041362-122100048164459444-3460006086115914139-n857_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://alminasa.ai/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/item-234maahd-234alsn-234lltaalym-234aan-234baad",
        "title": "معهد السنة للتعليم عن بُعد",
        "description": "موقع يقدم دورات إسلامية مجانية في مختلف المواضيع الإسلامية بإشراف الشيخ هيثم سرحان.",
        "image": "https://www.guidetosunnah.com/storage/posts/transparent-02915_programSliderThumb.png",
        "country": "",
        "date": "",
        "category": "دفاع عن السنة",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/transparent-02915_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://mahadsunnah.com/ar/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/post-14791781099032",
        "title": "موسوعة رواة الحديث",
        "description": "محرك بحث ومشروع رقمي ضخم يهدف إلى بناء أكبر قاعدة بيانات جغرافية وتاريخية لرواة الحديث النبوي الشريف في العالم، يحتوي على 135068 موضوع أُخذ من 62 كتاب من كتب الجرح والتعديل والطبقات.",
        "image": "https://www.guidetosunnah.com/storage/posts/qqfk7BDrfV1diuxprqlQTsXPft4KAkS6XOG7saJe_programSliderThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/qqfk7BDrfV1diuxprqlQTsXPft4KAkS6XOG7saJe.png",
        "primaryAction": {
          "url": "https://hadithtransmitters.hawramani.com/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/post-65641781101761",
        "title": "موسوعة الحديث",
        "description": "بوابة رقمية ومحرك بحث متكامل متخصص في خدمة السنة النبوية المطهرة، وعلوم الحديث الشريف، وتراجم الرواة والعلماء، تضم الموسوعة ما يزيد عن 753 ألف حديث نبوي مخرّج ومفهرس، موزعة على أكثر من 176 ألف موضوع لغوي وفقهي، إلى جانب احتوائها على أكثر من 40 ألف حديث مشروح تفصيليًا، تشتمل على 1400 كتاب حديثي وتراثي مقسمة إلى 18 موضوعًا علميًا مختلفًا، تشمل الأجزاء والفوائد، الأخلاق، السير والشمائل، السنن والموطآت، والصحاح والمستخرجات.",
        "image": "https://www.guidetosunnah.com/storage/posts/ToDrTv7F0NZ9R8T2mwSacWf4LTq3RiQJJtlA3sNJ_programSliderThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/ToDrTv7F0NZ9R8T2mwSacWf4LTq3RiQJJtlA3sNJ.png",
        "primaryAction": {
          "url": "https://hadith.islam-db.com/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/post-15271781192082",
        "title": "حدّثنا",
        "description": "محرك بحث ذكي ومدعوم بتقنيات الذكاء الاصطناعي متخصّص في خدمة وتسهيل البحث في التراث الحديثي وسلاسل الأسانيد. يهدف الموقع بشكل أساسي إلى مساعدة الباحثين وطلاب العلم الشرعي عبر توفير أدوات بصرية وتفاعلية متطورة للوصول إلى الحديث ونقده، تعتمد المنصة حاليًا على قاعدة بيانات ضخمة ومستخرجة من كتب الحديث المعتمدة، تضم ما يزيد عن 7000 حديث من صحيح البخاري، وتراجم لأكثر من 1700 راوٍ.، كما تتيح للمستخدم تصفّح سلاسل الإسناد بشكل مرئي وتفاعلي (مع ميزة سحب الشجرة وتدويرها) لمعرفة كيفية وصول طرق الحديث وتشعّباتها.",
        "image": "https://www.guidetosunnah.com/storage/posts/rg2KQLB1nHrWZ7oyPyR3HToB7hnKhBydrrG8n1gs_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/rg2KQLB1nHrWZ7oyPyR3HToB7hnKhBydrrG8n1gs.jpg",
        "primaryAction": {
          "url": "https://www.hadathana.app/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/post-38321781192667",
        "title": "جامع السنة وشُروحِها",
        "description": "منصة إلكترونية إسلامية ضخمة وموسوعية متخصصة بالكامل في خدمة السُنَّة النبوية وتوثيقها، تهدف المنصة إلى جمع أمهات كتب الحديث وشروحاتها المعتمدة في مكان واحد، مما يتيح للمستخدمين تصفح شروح متعددة ومقارنتها لنفس الحديث بناءً على تخريجه الفقهي والعلمي، يضم الموقع ما يقارب 246 كتابًا من أهم مصادر التراث الحديثي والأثر، كما يحتوي الموقع على قاعدة بيانات تراجم لـ 26,000 راوٍ من رواة الأسانيد .",
        "image": "https://www.guidetosunnah.com/storage/posts/sb8vqXRZArmRy8jtNQbTDc9WFt5lGatjFD6EY3V5_programSliderThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/sb8vqXRZArmRy8jtNQbTDc9WFt5lGatjFD6EY3V5.png",
        "primaryAction": {
          "url": "https://hadithportal.com/index.php",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/post-26011781364293",
        "title": "سنن",
        "description": "منصة إلكترونية إسلامية متخصصة في نشر وإحياء السنن النبوية اليومية والأذكار المأثورة عن النبي محمد ﷺ لدعم المسلم في طاعته اليومية، تركز على السنن والأذكار المرتبطة بأوقات محددة خلال اليوم والليل؛ مثل أذكار الصباح والمساء، وأذكار النوم والاستيقاظ، يتميز الموقع بتقديم محتواه بلغات عالمية متعددة (مثل الإنجليزية، التركية، الفرنسية، الأوردية، الإندونيسية وغيرها) لخدمة المسلمين غير الناطقين بالعربية حول العالم.",
        "image": "https://www.guidetosunnah.com/storage/posts/CiCbh1UsBxKjrEWGlqqi8v8FOmT5OPyR6jbBqO0H_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "تعريف بالنبي ﷺ",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/CiCbh1UsBxKjrEWGlqqi8v8FOmT5OPyR6jbBqO0H.jpg",
        "primaryAction": {
          "url": "https://sonan.org/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/post-30481782229945",
        "title": "Sunnah.com",
        "description": "منصة رقمية عالمية تُعد من أكبر وأشهر مراجع الأحاديث النبوية عبر الإنترنت، تجمع \"الكتب التسعة\" الرئيسية (البخاري ومسلم والسنن والمسانيد)، ومصادر أصيلة أخرى (ابن حبان والحاكم)، ومختارات شهيرة كرياض الصالحين وحصن المسلم، تتيح ميزات بحث ذكية مثل البحث بالعبارات الكاملة، الكلمات التقريبية، والمعاملات المنطقية لتسهيل الوصول للحديث، كما يدعم الموقع عدة لغات رئيسية لخدمة المسلمين والباحثين حول العالم، وهي: العربية، الإنجليزية، الأوردية، والبنغالية.",
        "image": "https://www.guidetosunnah.com/storage/posts/xEuUP0upjTmVBQVRdxtcU7pt4txCAwqDDTAuHVAJ_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/xEuUP0upjTmVBQVRdxtcU7pt4txCAwqDDTAuHVAJ.jpg",
        "primaryAction": {
          "url": "https://sunnah.com/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/post-53521782315786",
        "title": "حدثنا",
        "description": "محرك بحث ذكي وتفاعلي مدعوم بتقنيات الذكاء الاصطناعي، تم تصميمه خصيصاً لمساعدة طلبة العلم والباحثين في الوصول إلى التراث الحديثي وتحليله بأحدث التقنيات الرقمية. يركز الموقع حالياً على خدمة أحاديث صحيح البخاري، حيث يضم أكثر من 7,000 حديث، بالإضافة إلى تراجم وسير أكثر من 1,700 راوٍ.",
        "image": "https://www.guidetosunnah.com/storage/posts/5bvimIrykFtnqZycoDrrI9rgpbHgKLySXiOcVsn9_programSliderThumb.jpg",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/5bvimIrykFtnqZycoDrrI9rgpbHgKLySXiOcVsn9.jpg",
        "primaryAction": {
          "url": "https://www.hadathana.app/",
          "label": "زيارة الموقع"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/websites/show/post-89491782402359",
        "title": "حديث",
        "description": "منصة رقمية إسلامية متخصصة ومبتكرة، تُعد بمثابة المحرك الأسرع والأسهل للتحقق من صحة الأحاديث النبوية الشريفة عبر الإنترنت، يهدف الموق ع إلى حماية السنة النبوية وتوعية المسلمين عبر توفير وسيلة فورية تتيح لأي مستخدم التمييز بين الأحاديث الصحيحة والثابتة عن النبي ﷺ والأحاديث الضعيفة أو المكذوبة المنتشرة في وسائل التواصل الاجتماعي، كما يوفر أدوات علمية لتتبع سلاسل الرواة (الرجال) الموصلة لمتن الحديث لمعرفة طرق الحديث ومخارج ه.",
        "image": "https://www.guidetosunnah.com/storage/posts/Z6ZjnSBfcxriZ0AYIbZD3MPIlpwokfyaJAfHRlWi_programSliderThumb.png",
        "country": "",
        "date": "",
        "category": "موسوعات وبحث حديثي",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/Z6ZjnSBfcxriZ0AYIbZD3MPIlpwokfyaJAfHRlWi.png",
        "primaryAction": {
          "url": "https://hdith.com/",
          "label": "زيارة الموقع"
        }
      }
    ]
  },
  "software": {
    "root": "https://www.guidetosunnah.com/ar/extensions-programs",
    "pages": 2,
    "categories": [
      {
        "url": "https://www.guidetosunnah.com/ar/extensions-programs/windows",
        "label": "ويندوز"
      },
      {
        "url": "https://www.guidetosunnah.com/ar/extensions-programs/mac",
        "label": "ماك"
      },
      {
        "url": "https://www.guidetosunnah.com/ar/extensions-programs/chrome_extension",
        "label": "امتداد لجوجل كروم"
      },
      {
        "url": "https://www.guidetosunnah.com/ar/extensions-programs/deaf_mute",
        "label": "الصم والبكم"
      },
      {
        "url": "https://www.guidetosunnah.com/ar/extensions-programs/blind",
        "label": "المكفوفون"
      }
    ],
    "items": [
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/extensions-programs/show/post-54841774729763",
        "title": "برنامج موسوعة الحديث الشريف - المكتبة الوقفية",
        "description": "من جمعية المكنز الإسلامي (موسوعة الحديث الشريف) على موقعها الإلكتروني مجانًا؛ خدمةً ونشرًا لسنة النبي صلى الله عليه وسلم، يحتوي القرص المدمج الجديد من موسوعة الحديث الشريف على نصوص الكتب الستة وغيرها، كما بإمكان الباحث البحث وطباعة الأحاديث والكثير من المزايا.",
        "image": "https://www.guidetosunnah.com/storage/posts/unnamed-3355_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "ويندوز",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/unnamed-3355_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://waqfeya.net/book.php?bid=11746",
          "label": "تحميل البرنامج (ويندوز)"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/extensions-programs/show/post-65311774729751",
        "title": "برنامج جامع الحديث النبوي (من موقع شبكة المدارس الإسلامية)",
        "description": "برنامج موسوعي خيري يضم في قاعدة بياناته أكثر من 400 كتاب مسند من حديث رسول الله صلى الله عليه وسلم، ويحمل بين طياته أكثر من 522 ألف حديث وأثر مسند، بدءا من الصحاح والسنن والمسانيد ومرورا بالمستدركات والمعاجم والمشيخات وانتهاء بالمنتخبات والأجزاء.",
        "image": "https://www.guidetosunnah.com/storage/posts/aljam127_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "ويندوز",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/aljam127_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.madarisweb.com/ar/files/2526",
          "label": "تحميل البرنامج (ويندوز)"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/extensions-programs/show/post-75541774728292",
        "title": "برنامج موسوعة الحديث النبوي الشريف",
        "description": "أكثر من خمسين مجلدا وعشرات الآلاف من الصفحات في علم الحديث النبوي بين يديك.",
        "image": "https://www.guidetosunnah.com/storage/posts/3177-alhdyth-alshryf128_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "ماك",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/3177-alhdyth-alshryf128_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://apps.apple.com/us/app/%D9%85%D9%88%D8%B3%D9%88%D8%B9%D8%A9-%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A-%D8%A7%D9%84%D8%B4%D8%B1%D9%8A%D9%81/id891525423?m",
          "label": "تحميل البرنامج (ماك)"
        },
        "stores": {
          "ios": "https://apps.apple.com/us/app/%D9%85%D9%88%D8%B3%D9%88%D8%B9%D8%A9-%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A-%D8%A7%D9%84%D8%B4%D8%B1%D9%8A%D9%81/id891525423?m"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/extensions-programs/show/post-78601774728257",
        "title": "Hadith & Prayer times",
        "description": "يحتوي هذا الملحق لجوجل كروم علی آلاف من الأحاديث النبوية وأحاديث الأئمة الاطهار عليهم السلام ايضا یحتوي علی مواقيت الصلاة - لشهر رمضان",
        "image": "https://www.guidetosunnah.com/storage/posts/46356448_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "امتداد لجوجل كروم",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/46356448_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://chrome.google.com/webstore/detail/hadith-prayer-times/eilelkhemecanbelneelickmdjafgpci?hl=ar",
          "label": "تحميل البرنامج (امتداد لجوجل كروم)"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/extensions-programs/show/post-86571774729725",
        "title": "برنامج موسوعة الحديث الشريف - إسلام ويب",
        "description": "الموسوعة مقدمة من موقع إسلام ويب، وعرض مفهرس من الكتب الستة، مع شروحها، كما يوجد تفسير لكامل الآيات في الأحاديث، وكما يوجد تراجم للعلماء، كما يمكن للمستخدم التعليق على النصوص في الموسوعة، كما يمكنك تصفح صفحة محددة.",
        "image": "https://www.guidetosunnah.com/storage/posts/mws2131_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "ويندوز",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/mws2131_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.islamweb.net/mw2.php",
          "label": "تحميل البرنامج (ويندوز)"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/extensions-programs/show/post-50801774729710",
        "title": "برنامج الحديث النبوي الشريف",
        "description": "الإصدار الثالث لبرنامج الحديث النبوي الشريف، ويضم صحيح البخاري ومسلم، كما يتيح لك خيارات النسخ والطباعة.",
        "image": "https://www.guidetosunnah.com/storage/posts/908427026-22132_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "ويندوز",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/908427026-22132_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.bramjfreee.com/2014/06/hadith-2014.html",
          "label": "تحميل البرنامج (ويندوز)"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/extensions-programs/show/post-71221774729689",
        "title": "موسوعة الحديث النبوي الشريف - الإصدار الثالث",
        "description": "موسوعة الحديث النبوي الشريف - الإصدار الثالث [محدث] برنامج موسوعي يعتني بكتب الحديث النبوي الشريف، ويضم عشرات الكتب والمصنفات من مشاهير الصحاح والسنن والمسانيد التي صنفها أئمة الإسلام الأعلام لحفظ وتدوين سنة النبي صلى الله عليه وسلم.",
        "image": "https://www.guidetosunnah.com/storage/posts/capture380_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "ويندوز",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/capture380_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.islamspirit.com/islamspirit_ency_002.php",
          "label": "تحميل البرنامج (ويندوز)"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/extensions-programs/show/post-83581774729678",
        "title": "برنامج السيرة النبوية، والأحاديث النبوية الشريفة",
        "description": "أهم وأروع كتب في السيرة والحديث النبويّ الشريـف، تتكلم عن سيرة النبي صلى الله عليه وسلم وعن موسوعة الحديث النبوي الشريف، حيث تحتوي الموسوعة على جميع الأحاديث الصحيحه.",
        "image": "https://www.guidetosunnah.com/storage/posts/shutterstock-1705387420121_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "ويندوز",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/shutterstock-1705387420121_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.paldf.net/forum/showthread.php?t=601276",
          "label": "تحميل البرنامج (ويندوز)"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/extensions-programs/show/post-35551774729669",
        "title": "برنامج مكتبة الشيخ الألباني",
        "description": "برنامج مكتبة الألباني يجمع كل ما يهم طالب العلم والمثقف العادي من كتب في برنامج واحد . وبإمكان الباحث التصفح ضمن فهارس البرنامج بيسر وسهولة.",
        "image": "https://www.guidetosunnah.com/storage/posts/maktabat-alalbany-v2-pic01000000136_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "ويندوز",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/maktabat-alalbany-v2-pic01000000136_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "http://www.saaid.net/book/open.php?cat=95&book=2119",
          "label": "تحميل البرنامج (ويندوز)"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/extensions-programs/show/post-39771774729651",
        "title": "برنامج الكتب التسعة ( شركة حرف )",
        "description": "موسوعة الحديث الشريف، والذي يضم كتب الحديث التسعة: صحيحي البخاري ومسلم، وسنن الدارمي والنسائي والترمذي وأبي داود وابن ماجه، وموطأ مالك، ومسند الإمام أحمد بن حنبل ويزيد عدد هذه الأحاديث عن 62 ألف حديث للنبي صلى الله عليه وسلم ويناهز عدد صفحاتها نحو 25 ألف صفحة بالإضافة إلى شروحها.",
        "image": "https://www.guidetosunnah.com/storage/posts/harf-logo445_relatedServiceThumb.gif",
        "country": "",
        "date": "",
        "category": "ويندوز",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/harf-logo445_showWebsiteThumb.gif",
        "primaryAction": {
          "url": "https://www.almeshkat.net/book/2293",
          "label": "تحميل البرنامج (ويندوز)"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/extensions-programs/show/post-56341774729639",
        "title": "البرنامج الصوتي اللؤلؤ والمرجان فيما اتفق عليه الشيخان للحاسب",
        "description": "برنامج على شكل كتاب حقيقي تقلب صفحاته وتستمع إلى أبواب الكتاب للتيسير على من يجدون صعوبة في القراءة وذوي الاحتياجات الخاصة ومن يفضلون السماع على القراءة.",
        "image": "https://www.guidetosunnah.com/storage/posts/2478_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "ويندوز",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/2478_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.ansarsunna.com/vb/showthread.php?t=98165",
          "label": "تحميل البرنامج (ويندوز)"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/extensions-programs/show/post-83691774729623",
        "title": "المكتبة الألفية للسنة النبوية",
        "description": "برنامج \"المكتبة الألفية للسنة النبوية 1.5\"، يحتوي على الكثير من كتب السنة والتراجم والسيرة والتاريخ والرجال والمصطلح والفقه والأصول وغيره .",
        "image": "https://www.guidetosunnah.com/storage/posts/970559193444_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "ويندوز",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/970559193444_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://vb.tafsir.net/tafsir13775/#.XTiXmPIzZdg",
          "label": "تحميل البرنامج (ويندوز)"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/extensions-programs/show/post-40751774729610",
        "title": "الموسوعة الذهبية للحديث النبوي الشريف وعلومه",
        "description": "من إصدار مركز التراث لأبحاث الحاسب الآلي.",
        "image": "https://www.guidetosunnah.com/storage/posts/astoan-mosoaa-alhdyth-alshryf-mn-jmaay-almknz-aleslamy-1139_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "ويندوز",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/astoan-mosoaa-alhdyth-alshryf-mn-jmaay-almknz-aleslamy-1139_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://shamela.ws/page/download",
          "label": "تحميل البرنامج (ويندوز)"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/extensions-programs/show/post-46851774729598",
        "title": "برنامج موسوعة السيرة النبوية",
        "description": "موسوعة إلكترونية عن السيرة النبوية تشمل أبرز المصنفات التي عنيت بسرد وتدوين سيرة النبي صلى الله عليه وسلم وصفاته وأخلاقه",
        "image": "https://www.guidetosunnah.com/storage/posts/sera565_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "ويندوز",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/sera565_showWebsiteThumb.png",
        "primaryAction": {
          "url": "http://www.al-eman.com/%D8%A8%D8%B1%D8%A7%D9%85%D8%AC+%D9%85%D8%AC%D8%A7%D9%86%D9%8A%D8%A9/%D9%85%D9%88%D8%B3%D9%88%D8%B9%D8%A9%20%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9%20%D8%A7%D9%84%D9%86%D8%",
          "label": "تحميل البرنامج (ويندوز)"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/extensions-programs/show/post-15701774729586",
        "title": "برنامج جامع خادم الحرمين الشريفين الملك عبد الله بن عبد العزيز للسنة النبوية المطهرة",
        "description": "يحتوي هذا البرنامج على: (33) كتابا من أمهات كتب السنة الشريفة، ويصحبها (55) كتابا من الكتب الخدمية المتعلقة بعلوم السنة وكتب أخرى",
        "image": "https://www.guidetosunnah.com/storage/posts/alsn-almthr568_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "ويندوز",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/alsn-almthr568_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://waqfeya.net/book.php?bid=12488#google_vignette",
          "label": "تحميل البرنامج (ويندوز)"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/extensions-programs/show/post-56751774729571",
        "title": "برنامج جوامع الكلم",
        "description": "موسوعة حديثية شاملة تضم بين جنباتها 1400 مصدراً حديثياً، منها 543 مخطوطاً لم يسبق طبعها أو تحقيقها، إضافة إلى تراجم سبعين ألف راو للحديث الشريف، يتميزبتحقيق وتدقيق المصادر، وتشكيلها ووضع علامات الترقيم، وحصر عدد الأحاديث المسندة في كل مصدر.",
        "image": "https://www.guidetosunnah.com/storage/posts/joamaa569_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "ويندوز",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/joamaa569_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://ar.islamway.net/book/29707/-4-%D8%AC%D9%88%D8%A7%D9%85%D8%B9-%D8%A7%D9%84%D9%83%D9%84%D9%85",
          "label": "تحميل البرنامج (ويندوز)"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/extensions-programs/show/post-59831774728511",
        "title": "موسوعة الدفاع عن السنة النبوية - الإصدار الأول",
        "description": "برنامج موسوعي يعتني بالمؤلفات التي تدافع عن السنة النبوية المطهرة، وتبين مكانتها وحجيتها، وتدحض الشبهات حول توثيقها وتدوينها.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2022-12-13-212721650_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "ويندوز",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2022-12-13-212721650_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.islamspirit.com/islamspirit_ency_342.php",
          "label": "تحميل البرنامج (ويندوز)"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/extensions-programs/show/post-40911774728486",
        "title": "صحيح البخاري mp3",
        "description": "برنامج ينقسم إلى 93 كتاب و93 مقطع صوتي، لأحاديث الإمام البخاري (رحمه الله).",
        "image": "https://www.guidetosunnah.com/storage/posts/shyh-albkhary-mp3807_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "ويندوز",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/shyh-albkhary-mp3807_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.bramjfreee.com/2014/09/Sahih-bukhari-mp3.html",
          "label": "تحميل البرنامج (ويندوز)"
        }
      }
    ]
  },
  "product": {
    "root": "https://www.guidetosunnah.com/ar/services/main-categories-mntjat-lkhdmt-alsnt",
    "pages": 1,
    "categories": [],
    "items": [
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%AC%D9%87%D8%A7%D8%B2-%D8%A7%D9%84%D8%A3%D8%B0%D9%83%D8%A7%D8%B1-%D9%84%D8%A8%D8%A7%D8%A8-%D8%A7%D9%84%D8%B3%D9%8A%D8%A7%D8%B1%D8%A9-1",
        "title": "جهاز الأذكار لباب السيارة",
        "description": "جهاز إلكتروني يوضع عند الأبواب، وهو عبارة عن قطعتين، أثناء مروركم من خلاله يذكركم بذكر الله، مقدم من شركة آل الحرمين.",
        "image": "https://www.guidetosunnah.com/storage/posts/41kyej2-gil-ac-sy400295_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/41kyej2-gil-ac-sy400295_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.amazon.eg/dp/B09237S3H4?ref_=cm_sw_r_cp_ud_dp_M5YSJ1PADW1Z283JK9PZ",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%84%D9%88%D8%AD%D8%A9-%D9%88%D8%B3%D8%A7%D8%A6%D8%B7-%D8%AA%D8%B9%D9%84%D9%8A%D9%85-%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-110",
        "title": "لوحة وسائط تعليم السيرة النبوية",
        "description": "لعبة إلكترونية تعليمية، مفيدة وممتعة للأطفال، مزوَّدة برسومات ملونة، تتضمن حياة الرسول صلى الله وعليه وسلم، بالإضافة لهجرته وأهم عزواته.",
        "image": "https://www.guidetosunnah.com/storage/posts/51j2nljykjl-ac460_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/51j2nljykjl-ac460_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://amzn.eu/d/3NEbBUH",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A8%D8%B3%D8%AA-%D8%AA%D9%88%D9%8A-%D8%AC%D9%87%D8%A7%D8%B2-%D8%A5%D9%84%D9%83%D8%AA%D8%B1%D9%88%D9%86%D9%8A-%D9%84%D8%AA%D8%B9%D9%84%D9%8A%D9%85-%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-111",
        "title": "(بست توي) جهاز إلكتروني لتعليم السيرة النبوية",
        "description": "جهاز إلكتروني لتعليم السيرة النبوية من عمر ثلاث سنوات وأكثر، متوفر في متجر أمازون.",
        "image": "https://www.guidetosunnah.com/storage/posts/51vz-whvuyl-ac461_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/51vz-whvuyl-ac461_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.amazon.sa/%D8%A8%D8%B3%D8%AA-%D8%AA%D9%88%D9%8A-%D8%AA%D8%B9%D9%84%D9%8A%D9%85%D9%8A-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-23-999-4/dp/B0871T5937/ref=sr_1_2?dchild=1&keywords",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B3%D9%84%D8%B3%D9%84%D8%A9-%D8%A7%D9%84%D9%83%D8%AA%D8%A8-%D8%A7%D9%84%D8%A5%D8%B3%D9%84%D8%A7%D9%85%D9%8A%D8%A9-%D8%A7%D9%84%D8%AA%D8%B9%D9%84%D9%8A%D9%85%D9%8A%D8%A9-%D9%84%D9%84%D8%A3%D8%B7%D9%81%D8%A7%D9%84-%D8%A8%D8%A7%D9%84%D9%82%D9%84%D9%85-%D8%A7%D9%84%D9%86%D8%A7%D8%B7%D9%82-116",
        "title": "سلسلة الكتب الإسلامية التعليمية للأطفال بالقلم الناطق",
        "description": "المناهج مقسمة إلى كتيبات إسلامية لتعلم أركان الإسلام والوضوء والصلاة وإلى كتيبات لتعلم ثلاثة لغات العربية والانجليزية والفرنسية",
        "image": "https://www.guidetosunnah.com/storage/posts/alklm584_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/alklm584_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://amzn.eu/d/5EAiOaA",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%AC%D9%87%D8%A7%D8%B2-%D8%A3%D8%B0%D9%83%D8%A7%D8%B1-%D8%A5%D8%B3%D9%84%D8%A7%D9%85%D9%8A%D8%A9-%D9%84%D9%84%D8%A7%D8%B3%D8%AA%D8%AE%D8%AF%D8%A7%D9%85-%D9%81%D9%8A-%D8%A7%D9%84%D8%B3%D9%8A%D8%A7%D8%B1%D8%A9-117",
        "title": "جهاز أذكار إسلامية للاستخدام في السيارة",
        "description": "رفيق جيد يذكرك بالله كل 7 دقائق مع دعاء السفر",
        "image": "https://www.guidetosunnah.com/storage/posts/syar585_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/syar585_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://amzn.eu/d/e8RbccL",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%AC%D9%87%D8%A7%D8%B2-%D8%AA%D8%B9%D9%84%D9%8A%D9%85-%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-118",
        "title": "جهاز تعليم السيرة النبوية",
        "description": "دع طفلك يبدأ برحلته بتعلم السيرة النبوية بطريقة عصرية مميزة وحديثة.",
        "image": "https://www.guidetosunnah.com/storage/posts/taalym586_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/taalym586_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://famjoy.com/product/%D8%AC%D9%87%D8%A7%D8%B2-%D8%AA%D8%B9%D9%84%D9%8A%D9%85%D9%8A-%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D9%81%D8%A7%D9%85-%D8",
          "label": "مشاهدة"
        }
      }
    ]
  },
  "media": {
    "root": "https://www.guidetosunnah.com/ar/services/main-categories-asdarat-mryt-wswtyt",
    "pages": 8,
    "categories": [
      {
        "url": "https://www.guidetosunnah.com/ar/services/asdarat-mryt-wswtyt/main-categories-asdarat-mryt-wswtyt-ktb-alhdyth-wshrwhatha",
        "label": "كتب الحديث وشروحاتها"
      },
      {
        "url": "https://www.guidetosunnah.com/ar/services/asdarat-mryt-wswtyt/main-categories-asdarat-mryt-wswtyt-alsnn-alnbwyt-mswrt",
        "label": "السنن النبوية مصوّرة"
      },
      {
        "url": "https://www.guidetosunnah.com/ar/services/asdarat-mryt-wswtyt/main-categories-asdarat-mryt-wswtyt-alsyrt-alnbwyt",
        "label": "السيرة النبوية"
      }
    ],
    "items": [
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%83%D8%AA%D8%A7%D8%A8-%D8%B5%D8%AD%D9%8A%D8%AD-%D8%A7%D9%84%D8%A8%D8%AE%D8%A7%D8%B1%D9%8A-2-5",
        "title": "كتاب صحيح البخاري 2",
        "description": "من قناة الكتب المسموعة في موقع اليوتيوب، كتاب صوتي مسموع لصحيح البخاري، مقدَّم بأسلوب سهل ورائع.",
        "image": "https://www.guidetosunnah.com/storage/posts/shutterstock-669202981363_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/shutterstock-669202981363_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=RKZo2Mzmpcc&list=PLkCzrrLCxca0bnaPUYaDd-Nwgkybf1K1A",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%82%D8%B1%D8%A7%D8%A1%D8%A9-%D8%B5%D9%88%D8%AA%D9%8A%D8%A9-%D9%84%D9%83%D8%AA%D8%A7%D8%A8-%D8%B5%D8%AD%D9%8A%D8%AD-%D8%A7%D9%84%D8%A5%D9%85%D8%A7%D9%85-%D8%A7%D9%84%D8%A8%D8%AE%D8%A7%D8%B1%D9%8A-%D9%83%D8%A7%D9%85%D9%84%D8%A7-6",
        "title": "قراءة صوتية لكتاب صحيح الإمام البخاري كاملاً",
        "description": "من قناة Droos Mp3 في موقع يوتيوب، صحيح البخاري كتاب صوتي مسموع، بأسلوب رائع ومشوق.",
        "image": "https://www.guidetosunnah.com/storage/posts/ktb-soty426_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/ktb-soty426_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=PuuTHJ28O0Y&list=PLbo5aBDk2EuhCaqdjDwCUsjyJ9si6owdk",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%83%D8%AA%D8%A7%D8%A8-%D8%B5%D8%AD%D9%8A%D8%AD-%D9%85%D8%B3%D9%84%D9%85-7",
        "title": "كتاب صحيح مسلم",
        "description": "صحيح مسلم كتاب صوتي مسموع بصوت الدكتور أحمد كلحى في قناته في موقع اليوتيوب، بأسلوب رائع ومشوق.",
        "image": "https://www.guidetosunnah.com/storage/posts/shutterstock-135114548364_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/shutterstock-135114548364_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=Gopo-Lp0Qyo&list=PLTAMhu2e0NliYkl0gLRHyS7mGEjR51XAv",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B3%D9%86%D9%86-%D8%A7%D9%84%D9%86%D8%B3%D8%A7%D8%A6%D9%8A-8",
        "title": "سنن النسائي",
        "description": "من قناة الكتب المسموعة في موقع اليوتيوب، كتاب صوتي مسموع لسنن النسائي ، مقدَّم بأسلوب سهل ورائع.",
        "image": "https://www.guidetosunnah.com/storage/posts/audiobook-3106986-1280425_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/audiobook-3106986-1280425_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=y74GrH-VGk8&list=PLNbeOy36C9Dhp8wqTtjvOMZ48iI4g1bac",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%83%D8%AA%D8%A7%D8%A8-%D8%B3%D9%86%D9%86-%D8%A7%D9%84%D8%AA%D8%B1%D9%85%D8%B0%D9%8A-9",
        "title": "كتاب سنن الترمذي",
        "description": "سنن الترمذي كتاب صوتي مسموع بصوت الدكتور أحمد كلحى في قناته في موقع اليوتيوب، بصوتٍ واضح، وبأسلوب ممتع.",
        "image": "https://www.guidetosunnah.com/storage/posts/reserve-na-biblioteca-com-livro-aberto-1150-5923424_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/reserve-na-biblioteca-com-livro-aberto-1150-5923424_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=gT9Jwfqh_v0&list=PLTAMhu2e0NljhWv6A14TrMc2Quh34lVpS",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%83%D8%AA%D8%A7%D8%A8-%D8%B3%D9%86%D9%86-%D8%A3%D8%A8%D9%8A-%D8%AF%D8%A7%D9%88%D8%AF-10",
        "title": "كتاب سنن أبي داود",
        "description": "سنن أبي داود مسجَّل بصوت الدكتور أحمد كلحى في قناته في موقع اليوتيوب، بصوتٍ واضح، وبأسلوب ممتع.",
        "image": "https://www.guidetosunnah.com/storage/posts/book-library-with-open-textbook-1150-5921423_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/book-library-with-open-textbook-1150-5921423_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=QitNTKClVJA&list=PLTAMhu2e0Nlg2ZsIoXHozcpHja132bkTb",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%83%D8%AA%D8%A7%D8%A8-%D8%B3%D9%86%D9%86-%D8%A7%D8%A8%D9%86-%D9%85%D8%A7%D8%AC%D8%A9-11",
        "title": "كتاب سنن ابن ماجة",
        "description": "سنن ابن ماجة مسجَّل بصوت الدكتور أحمد كلحى في قناته في موقع اليوتيوب، بصوتٍ واضح، وبأسلوب ممتع.",
        "image": "https://www.guidetosunnah.com/storage/posts/1097249422_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/1097249422_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=s2g1YFpAgPc&list=PLTAMhu2e0NljJ6j1YNVds3VCxLFgF2C3T",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%83%D8%AA%D8%A7%D8%A8-%D9%85%D8%B3%D9%86%D8%AF-%D8%A3%D8%AD%D9%85%D8%AF-12",
        "title": "كتاب مسند أحمد",
        "description": "مسند الإمام أحمد مسجَّل بصوت الدكتور أحمد كلحى في قناته في موقع اليوتيوب، بصوتٍ واضح، وبأسلوب ممتع.",
        "image": "https://www.guidetosunnah.com/storage/posts/wp4430539421_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/wp4430539421_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=H26C2Bq-2NQ&list=PLTAMhu2e0NlhmA85EbsPZ3u_J7uJQLD5z",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%83%D8%AA%D8%A7%D8%A8-%D8%AA%D9%86%D8%A8%D9%8A%D9%87-%D8%A7%D9%84%D8%A3%D9%81%D9%87%D8%A7%D9%85-%D8%A8%D8%B4%D8%B1%D8%AD-%D8%B9%D9%85%D8%AF%D8%A9-%D8%A7%D9%84%D8%A3%D8%AD%D9%83%D8%A7%D9%85-13",
        "title": "كتاب تنبيه الأفهام بشرح عمدة الأحكام",
        "description": "كتاب تنبيه الأفهام بشرح عمدة الأحكام للشيخ محمد بن صالح العثيمين ،بصوت الدكتور أحمد كلحى في قناته.",
        "image": "https://www.guidetosunnah.com/storage/posts/shutterstock-535938397369_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/shutterstock-535938397369_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=FkxIlwUwJ4w&list=PLa4mJMjmoqQ8hMTLE1UfHjuov28zHZP2m",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%83%D8%AA%D8%A8-%D8%AD%D8%AF%D9%8A%D8%AB-%D9%85%D9%86%D9%88%D8%B9%D8%A9-14",
        "title": "كتب حديث منوعة",
        "description": "كتب الحديث صوتيًا مقدمة من قناة الكتب المسموعة على موقع اليوتيوب، مقروءة بأسلوب واضح.",
        "image": "https://www.guidetosunnah.com/storage/posts/fine-books-01-hd-picture-166599420_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/fine-books-01-hd-picture-166599420_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=o7oVLEbJ-tk&list=PL74fZBVc4VtvkkJnZd2trUhVCSmNE7VSf",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B4%D8%B1%D8%AD-%D8%B5%D8%AD%D9%8A%D8%AD-%D8%A7%D9%84%D8%A8%D8%AE%D8%A7%D8%B1%D9%8A-%D9%81%D8%B6%D9%8A%D9%84%D8%A9-%D8%A7%D9%84%D8%B4%D9%8A%D8%AE-%D8%A7%D9%84%D8%B9%D8%AB%D9%8A%D9%85%D9%8A%D9%86-16",
        "title": "شرح صحيح البخاري - فضيلة الشيخ العُثيمين",
        "description": "في قناة فضيلة الشيخ محمد بن صالح العيثمين في موقع يوتيوب، يشرح فضيلة الشيخ صحيح البخاري عبر حلقات متتالية، بأسلوب رائع وممتع.",
        "image": "https://www.guidetosunnah.com/storage/posts/shutterstock-1444506608370_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/shutterstock-1444506608370_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=1GI8d_iYSN4&list=PLXS0usquloW8vk6FwSeWfR9ES9pcZ_BNI",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B4%D8%B1%D8%AD-%D9%83%D8%AA%D8%A7%D8%A8-%D8%A7%D9%84%D8%B1%D9%82%D8%A7%D9%82-%D8%B5%D8%AD%D9%8A%D8%AD-%D8%A7%D9%84%D8%A8%D8%AE%D8%A7%D8%B1%D9%8A-18",
        "title": "شرح كتاب الرقاق (صحيح البخاري)",
        "description": "شرح كناب الرقاق من صحيح الإمام البخاري للشيخ حجازي محمد شريف المشهور بأبي اسحق الحويني، في قناته الخاصة في موقع اليوتيوب.",
        "image": "https://www.guidetosunnah.com/storage/posts/o3lop59212730393416_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/o3lop59212730393416_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=xqChdb6ykak&list=PLZbyN8Td38Xi06mPmQTiowu3aqsI3yVqB&index=2",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B4%D8%B1%D8%AD-%D8%B5%D8%AD%D9%8A%D8%AD-%D9%85%D8%B3%D9%84%D9%85-19",
        "title": "شرح صحيح مسلم",
        "description": "شرح صحيح مسلم للشيخ محمد بن صالح العيثمين بصوت الشيخ، مع إمكانية متابعة الكتاب في الشاشة، مقدَّم من قناة فضيلة الشيخ محمد بن صالح العيثمين",
        "image": "https://www.guidetosunnah.com/storage/posts/61ajw0fdowl415_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/61ajw0fdowl415_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=ukscTKOCcYE&list=PLXS0usquloW8W_I5fJKfrVbl8DO4FD9iZ",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B4%D8%B1%D8%AD-%D9%85%D8%B3%D9%86%D8%AF-%D8%A7%D9%84%D8%B4%D8%A7%D9%81%D8%B9%D9%8A-21",
        "title": "شرح مسند الشافعي",
        "description": "شرح مسند الإمام الشافعي بصوت الدكتور ماهر ياسين الفحل في قناته الخاصة في موقع اليوتيوب، مع متابعة الكتاب في الشاشة.",
        "image": "https://www.guidetosunnah.com/storage/posts/shutterstock-673649734372_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/shutterstock-673649734372_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=QKXErNpWw6M&list=PL-TIj0g_zChxefgmlbu74XZQ824o3CMtd",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B4%D8%B1%D8%AD-%D8%A7%D9%84%D8%A3%D8%B1%D8%A8%D8%B9%D9%8A%D9%86-%D8%A7%D9%84%D9%86%D9%88%D9%88%D9%8A%D8%A9-22",
        "title": "شرح الأربعين النووية",
        "description": "كتاب شرح الأربعين النووية للشيخ محمد بن صالح العيثمين بصوت الشيخ، مع إمكانية متابعة الكتاب في الشاشة، مقدَّم من قناة فضيلة الشيخ محمد بن صالح العيثمين",
        "image": "https://www.guidetosunnah.com/storage/posts/ktb414_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/ktb414_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=LS3DsGsNQ-Q&list=PLXS0usquloW_VC2gPb6nu1FFQTxWc1Ww_",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B4%D8%B1%D8%AD-%D8%B5%D8%AD%D9%8A%D8%AD-%D8%A7%D8%A8%D9%86-%D8%AE%D8%B2%D9%8A%D9%85%D8%A9-23",
        "title": "شرح صحيح ابن خزيمة",
        "description": "شرح الكتب التسعة في قناة الدكتور ماهر ياسين الفحل في موقع اليوتيوب، مع متابعة الكتاب في الشاشة.",
        "image": "https://www.guidetosunnah.com/storage/posts/thumb-1920-346199413_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/thumb-1920-346199413_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=cREjDeI635k&list=PL-TIj0g_zChx4f7vYnJS-vaZgA-hrzX6n",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%AF%D9%88%D8%B1%D8%A9-%D9%85%D9%86%D8%A7%D9%87%D8%AC-%D8%A7%D9%84%D9%83%D8%AA%D8%A8-%D8%A7%D9%84%D8%B3%D8%AA%D8%A9-24",
        "title": "دورة مناهج الكتب الستة",
        "description": "مقاطع مرئية للدكتور أحمد معبد عبد الكريم ضمن قناة الأزهر الشريف على قناة اليوتيوب شارحًا منهج الكتب الستة.",
        "image": "https://www.guidetosunnah.com/storage/posts/shutterstock-1718050696376_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/shutterstock-1718050696376_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=TDPJPpXxvJs&list=PL8S7WK9TPug7vZA4Lu6VRnrsYJklxjSi2",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A8%D8%B1%D9%86%D8%A7%D9%85%D8%AC-%D8%B9%D9%84%D9%88%D9%85-%D8%A7%D9%84%D9%82%D8%B1%D8%A2%D9%86-%D9%81%D9%8A-%D9%83%D8%AA%D8%A8-%D8%A7%D9%84%D8%B3%D9%86%D8%A9-25",
        "title": "برنامج علوم القرآن في كتب السنة",
        "description": "من قناة (إذاعة القرآن الكريم من المملكة العربية السعودية في يوتيوب)، يقدم الدكتور بدر البدر برنامج علوم القرآن في كتب السنة بأسلوب رائع ومشوق.",
        "image": "https://www.guidetosunnah.com/storage/posts/almshf-ballon-aldhb59_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/almshf-ballon-aldhb59_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=GhzBJYrUWvY&list=PLa13pg2_v0pF3g7VU_J__CirwKKSygiSw",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%85%D9%86%D9%87%D8%A7%D8%AC-%D8%A7%D9%84%D8%B3%D9%86%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D9%84%D8%B4%D9%8A%D8%AE-%D8%A7%D9%84%D8%A5%D8%B3%D9%84%D8%A7%D9%85-%D8%A7%D8%A8%D9%86-%D8%AA%D9%8A%D9%85%D9%8A%D8%A9-26",
        "title": "منهاج السنة النبوية لشيخ الإسلام ابن تيمية",
        "description": "سلسلة مقاطع مرئية للشيخ عثمان الخميس، قارئًا ومعلِّقًا على كتاب منهاج السنة النبوية لابن تيمية، بأسلوب مشوق.",
        "image": "https://www.guidetosunnah.com/storage/posts/33844810412_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/33844810412_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=EAPGA5TImUg&list=PL53OpcXU3KnA-vKoKsbRTvnWpLo9iY-qS",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%83%D8%AA%D8%A7%D8%A8-%D9%85%D8%B9%D8%A7%D9%84%D9%85-%D8%A7%D9%84%D8%B3%D9%86%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-27",
        "title": "كتاب معالم السنة النبوية",
        "description": "سلسلة مقاطع مرئية للشيخ نواف السالم، قارئًا ومعلِّقًا على كتاب معالم السنة النبوية لصالح أحمد الشامي.",
        "image": "https://www.guidetosunnah.com/storage/posts/almsjd-alnboy61_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/almsjd-alnboy61_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=ZpRsSpSDm8Q&list=PL3J-6WdyyjfuZqDR_d-VWlZ6ZR52vq-IS",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A7%D9%84%D8%A3%D8%B1%D8%A8%D8%B9%D9%88%D9%86-%D8%A7%D9%84%D9%86%D9%88%D9%88%D9%8A%D8%A9-28",
        "title": "الأربعون النووية",
        "description": "قراءة رائعة وهادئة بصوت حمد الدريهم، لمتن الأربعين النووية للشيخ النووي رحمه الله..",
        "image": "https://www.guidetosunnah.com/storage/posts/unnamed-14411_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/unnamed-14411_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=f-EtKefljoI",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A3%D8%AD%D8%A7%D8%AF%D9%8A%D8%AB-%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D9%85%D8%B5%D9%88%D8%B1%D8%A9-31",
        "title": "أحاديث نبوية مصورة",
        "description": "مشاهد تمثيلية لأحاديث نبوية، تسهل على المشاهد فهم الأحاديث النبوية الشريفة وحفظها.",
        "image": "https://www.guidetosunnah.com/storage/posts/twasulinfo65_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "السنن النبوية مصوّرة",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/twasulinfo65_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=0hmkWJROvc8&list=PLqOJLgE47P4ndkiPawGeSS4FjgJX8fJCA",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A3%D8%AD%D8%A7%D8%AF%D9%8A%D8%AB-%D9%85%D8%B5%D9%88%D8%B1%D8%A9-32",
        "title": "أحاديث مصورة",
        "description": "بطريقة الرَّسم تقدم لكم قناة (قرآني جناتي) سلسلة أحاديث نبوية شريفة، مقدمة بطريقة سهلة ورائعة.",
        "image": "https://www.guidetosunnah.com/storage/posts/kutubhadeethsittah428_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "السنن النبوية مصوّرة",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/kutubhadeethsittah428_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=Re3GQJcUrfY&list=PLqz-ZN1RK_phg9ufo14XdEQsayd4g2tx4",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A3%D8%AD%D8%A7%D8%AF%D9%8A%D8%AB-%D8%A7%D9%84%D8%A3%D8%AD%D9%83%D8%A7%D9%85-%D8%A7%D9%84%D9%85%D8%B5%D9%88%D8%B1%D8%A9-34",
        "title": "أحاديث الأحكام المصورة",
        "description": "بإشراق قناة ينابيع العلم الفضائية في اليوتيوب، سلسلة أحاديث نبوية معروضة بطريقة رائعة وممتعة.",
        "image": "https://www.guidetosunnah.com/storage/posts/msjd-alslymanyh427_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "السنن النبوية مصوّرة",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/msjd-alslymanyh427_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=g7QDt99mTSc&list=PL2syWUMCjVfZtIhDRHI5MX-7CHgCnWGLl&index=2",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%81%D9%8A%D9%84%D9%85-%D9%88%D8%AB%D8%A7%D8%A6%D9%82%D9%8A-%D8%B9%D9%86-%D8%AD%D9%8A%D8%A7%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%8A-%D8%B5%D9%84%D9%89-%D8%A7%D9%84%D9%84%D9%87-%D8%B9%D9%84%D9%8A%D9%87-%D9%88%D8%B3%D9%84%D9%85-37",
        "title": "فيلم وثائقي عن حياة النبي صلى الله عليه وسلم",
        "description": "فيلم مصور يعرض سيرته صلى الله عليه وسلم منذ ولادته حتى وفاته، بأسلوب مشوق ورائع.",
        "image": "https://www.guidetosunnah.com/storage/posts/6d09cfc2620273fa914b1a4887d09aaf69_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/6d09cfc2620273fa914b1a4887d09aaf69_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=skJyLZ1bC78",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D9%86%D8%A8%D9%8A%D9%84-%D8%A7%D9%84%D8%B9%D9%88%D8%B6%D9%8A-38",
        "title": "السيرة النبوية - نبيل العوضي",
        "description": "تعرض قناة Muslim Not Terrorist دروس السيرة النبوية للشيخ نبيل العوضي، التي يقدمها بأسلوبه الرائع والمتميز.",
        "image": "https://www.guidetosunnah.com/storage/posts/195902-194765773897675-100000927621269-499739-3593621-n462_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/195902-194765773897675-100000927621269-499739-3593621-n462_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=05yU3VekToU&list=PL0E1AE0018C87AA4A",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B4%D8%B1%D8%AD-%D9%83%D8%AA%D8%A7%D8%A8-%D9%86%D9%88%D8%B1-%D8%A7%D9%84%D9%8A%D9%82%D9%8A%D9%86-%D9%81%D9%8A-%D8%B3%D9%8A%D8%B1%D8%A9-%D8%B3%D9%8A%D8%AF-%D8%A7%D9%84%D9%85%D8%B1%D8%B3%D9%84%D9%8A%D9%86-99",
        "title": "شرح كتاب نور اليقين في سيرة سيد المرسلين",
        "description": "في المجالس العطرة بذكر النبي صلى الله عليه وسلم ، يعرض الدكتور يسري جبر، سيرة النبي صلى الله عليه وسلم ، على حلقات في قناته الخاصة في يوتيوب.",
        "image": "https://www.guidetosunnah.com/storage/posts/582ec37137ed347a5be3f91972f033f2570875e6178_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/582ec37137ed347a5be3f91972f033f2570875e6178_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=OoNlD7NNNW4&list=PLEkQk5xrP-tl2t4NQx1IhKnAJCMzF0Nli",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A3%D8%B9%D8%B8%D9%85-%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D8%B4%D9%8A%D8%AE-%D9%86%D8%A7%D8%B5%D8%B1-%D8%A7%D9%84%D8%A3%D8%AD%D9%85%D8%AF-100",
        "title": "أعظم سيرة – الشيخ ناصر الأحمد",
        "description": "الشيخ ناصر الأحمد يعرض سيرته صلى الله عليه وسلم ، في قناة صقر على اليوتيوب، بأسلوب مشوق وممتع.",
        "image": "https://www.guidetosunnah.com/storage/posts/hqdefault-3179_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/hqdefault-3179_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=bC5W13p5hRs&list=PLjeqsF_1vK36xtao6N1oEIMAxOrcCXEw9",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D8%B9%D9%88%D8%A7%D8%AF-%D8%A7%D9%84%D8%B2%D8%A7%D9%8A%D8%AF-101",
        "title": "السيرة النبوية - عواد الزايد",
        "description": "في قناة عواد الزايد على اليوتيوب، وبأسلوب واضح وسهل، يعرض لكم السيرة النبوية الشريفة ضمن مقاطع مرئية.",
        "image": "https://www.guidetosunnah.com/storage/posts/maxresdefault-9433_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/maxresdefault-9433_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=JbZQ_MUTqUo&list=PLQCMZ0mRPEz8PBXUefIzXlEHm-1qUMO9x",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D8%B1%D8%A7%D8%BA%D8%A8-%D8%A7%D9%84%D8%B3%D8%B1%D8%AC%D8%A7%D9%86%D9%8A-102",
        "title": "السيرة النبوية - راغب السرجاني",
        "description": "السيرة النبوية للدكتور راغب السرجاني في قناة (إسلامنا عزنا ومجدنا)",
        "image": "https://www.guidetosunnah.com/storage/posts/klam-aan-almold-alnboy-alshryf431_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/klam-aan-almold-alnboy-alshryf431_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=oYfDQsk10a0&list=PL3dTnGoUVhi9B_cPSR1Cl4hnvLFgFCxtr",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D8%B7%D8%A7%D8%B1%D9%82-%D8%B3%D9%88%D9%8A%D8%AF%D8%A7%D9%86-103",
        "title": "السيرة النبوية - طارق سويدان",
        "description": "في قناة fikir فكرة يقدم الدكتور طارق سويدان سيرة الرسول محمد صلى الله عليه وسلم بأسلوب رائع.",
        "image": "https://www.guidetosunnah.com/storage/posts/untitled735_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/untitled735_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=8wKyQdxs0mM&list=PL3ZlihP55ZA55SHPaFgcVhGisDmvYRKLc",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D9%82%D9%86%D8%A7%D8%A9-islamistseries-106",
        "title": "السيرة النبوية - قناة Islamistseries",
        "description": "من قناة Islamistseries في يوتيوب، يقدم الشيخ نواف السالم دروسَ السيرة النبوية الشريفة.",
        "image": "https://www.guidetosunnah.com/storage/posts/bhth-aan-alsn-alnboy429_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/bhth-aan-alsn-alnboy429_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=044dhO-r-4M&list=PLHUyaeW2rzQFtAteWgjaAxW3dFHzJlCJN",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%83%D8%AA%D8%A7%D8%A8-%D8%A7%D9%84%D8%B4%D9%85%D8%A7%D8%A6%D9%84-%D8%A7%D9%84%D9%85%D8%AD%D9%85%D8%AF%D9%8A%D8%A9-%D9%85%D9%82%D8%B1%D9%88%D8%A1-107",
        "title": "كتاب الشمائل المحمدية مقروء",
        "description": "كتاب الشمائل المحمدية ، مقروء صوتيًا مقدم من السيد كمال فتحي في قناته على موقع يوتيوب.",
        "image": "https://www.guidetosunnah.com/storage/posts/unnamed-434_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/unnamed-434_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=axWeUJLZ188&list=PLQ4hRnAEEBAUSiQyESsn51eMo4QZR__zO",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B4%D8%B1%D8%AD-%D8%A7%D9%84%D8%A3%D8%B1%D8%A8%D8%B9%D9%88%D9%86-%D8%A7%D9%84%D9%86%D9%88%D9%88%D9%8A%D8%A9-%D8%A8%D9%84%D8%BA%D8%A9-%D8%A7%D9%84%D8%A5%D8%B4%D8%A7%D8%B1%D8%A9-%D8%A7%D9%84%D8%AF%D8%A7%D8%B9%D9%8A%D8%A9-%D8%B9%D9%85%D8%B1%D9%88-%D8%B9%D8%A8%D8%A7%D8%B3-109",
        "title": "شرح الأربعون النووية بلغة الإشارة - الداعية عمرو عباس",
        "description": "من قناة نصرة محمد صلى الله عليه وسلم في يوتيوب، يطلُّ عليكم الداعية عمرو موسى، لشرح الأربعين النووية بلغة الإشارة.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2022-12-03-190940480_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2022-12-03-190940480_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=3SQaRMUcC7M&list=PLe2CIyE27iWBPX24MhRx7BOmvvcbFZA6u",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%81%D9%88%D8%A7%D8%A6%D8%AF-%D8%A7%D9%84%D8%B3%D8%B1%D8%AF-%D8%A7%D9%84%D9%85%D8%AC%D9%88%D8%AF-%D9%84%D8%B5%D8%AD%D9%8A%D8%AD-%D8%A7%D9%84%D8%A8%D8%AE%D8%A7%D8%B1%D9%8A-112",
        "title": "فوائد السرد المجود لصحيح البخاري",
        "description": "في قناة فضيلة الشيخ صالح العصيمي، في اليوتيوب، يقدِّم الشيخ في حلقات وبأسلوب رائع وممتع فوائد السرد المجود لصحيح البخاري.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2022-12-03-184922479-showwebsitethumb734_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2022-12-03-184922479-showwebsitethumb734_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=XQgimxIqQrI&list=PLMESC_UFcDHImKorXWhCTCYdXxMO26q1J",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%AF%D8%B1%D9%88%D8%B3-%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-119",
        "title": "دروس السيرة النبوية",
        "description": "دروس في السيرة النبوية يلقيها على مسامعكم فضيلة الشيخ أدهم العاسمي .",
        "image": "https://www.guidetosunnah.com/storage/posts/dros587_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/dros587_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=1TkDHH0h3_E&list=PL9nkZtQYDOGsT3Pf3ILhy9TB-ur2Ve2LW",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D9%82%D8%B5%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%8A-%EF%B7%BA-%D9%85%D9%86-%D9%88%D9%84%D8%A7%D8%AF%D8%AA%D9%87-%D8%A5%D9%84%D9%89-%D8%A8%D8%B9%D8%AB%D8%AA%D9%87-120",
        "title": "السيرة النبوية، قصة النبي ﷺ من ولادته إلى بعثته",
        "description": "قصة النبي ﷺ من ولادته إلى بعثته بتفاصيل رائعة (مقطع مجمع) من قناة هاشتاق على اليوتيوب",
        "image": "https://www.guidetosunnah.com/storage/posts/hashtak588_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/hashtak588_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=nyBgFkoJL5s",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D9%82%D9%86%D8%A7%D8%A9-ahmed-amer-121",
        "title": "السيرة النبوية - قناة Ahmed Amer",
        "description": "",
        "image": "https://www.guidetosunnah.com/storage/posts/ns-fkrtk589_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%AD%D9%8A%D8%A7%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%8A-%D8%A7%D9%84%D8%AD%D8%A8%D9%8A%D8%A8-%D9%85%D8%AD%D9%85%D8%AF-%EF%B7%BA-%D9%85%D9%86-%D9%88%D9%84%D8%A7%D8%AF%D8%AA%D9%87-%D8%A7%D9%84%D9%89-%D8%A8%D8%B9%D8%AB%D8%AA%D9%87-122",
        "title": "حياة النبي الحبيب محمد ﷺ من ولادته الى بعثته",
        "description": "السيرة النبوية العطرة يلقيها على مسامعكم الشيخ بدر المشاري",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2022-12-08-211308590_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2022-12-08-211308590_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=Ppahd-tfZd4",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D8%AD%D8%A8%D9%8A%D8%A8-%D8%B3%D8%B9%D9%8A%D8%AF-%D8%A7%D9%84%D9%83%D9%85%D9%84%D9%8A-123",
        "title": "سيرة الحبيب - سعيد الكملي",
        "description": "دروس في السيرة النبوية يلقيها الشيخ سعيد الكملي .",
        "image": "https://www.guidetosunnah.com/storage/posts/syr-alhbyb591-showwebsitethumb733_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/syr-alhbyb591-showwebsitethumb733_showWebsiteThumb.png",
        "primaryAction": {
          "url": "youtube.com/watch?v=Pv0HjFCsTpw&list=PLFkuO76ICjPkxCbn7PrDvMpio4oHlT2om",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A7%D9%84%D9%82%D9%8A%D9%85-%D8%A7%D9%84%D8%AA%D8%B1%D8%A8%D9%88%D9%8A%D8%A9-%D9%81%D9%8A-%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-124",
        "title": "القيم التربوية في السيرة النبوية",
        "description": "دروس في القيم التربوية في السيرة النبوية للأستاذ طه نايف",
        "image": "https://www.guidetosunnah.com/storage/posts/kym592-showwebsitethumb732_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/kym592-showwebsitethumb732_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=h4CRIr6aWVg",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B3%D9%84%D8%B3%D9%84%D8%A9-%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D8%A3%D8%AD%D9%85%D8%AF-%D8%A7%D9%84%D8%B9%D8%B2%D8%A8-125",
        "title": "سلسلة السيرة النبوية - أحمد العزب",
        "description": "سلسلة السيرة النبوية يلقيها على مسامعكم الشيخ أحمد العزب",
        "image": "https://www.guidetosunnah.com/storage/posts/slsl-alsyr-alnboy593_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/slsl-alsyr-alnboy593_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=7XEww_ureHA&list=PLD-tRLG3gV233KG4QN07LgYvLndB-s0gr",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D8%B9%D8%A8%D8%AF-%D8%A7%D9%84%D8%B1%D8%B2%D8%A7%D9%82-%D8%A7%D9%84%D8%A8%D8%AF%D8%B1-126",
        "title": "السيرة النبوية - عبد الرزاق البدر",
        "description": "شرح كتاب الأصول في سيرة الرسول لمؤلفه الإمام ابن كثير رحمه الله، يشرحه الشيخ عبد الرزاق بن عبد المحسن البدر",
        "image": "https://www.guidetosunnah.com/storage/posts/alsyr1731_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/alsyr1731_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=kLCa3BI19KU&list=PLLuEQQBfYhlj8SBh84Ppq_5zX-DoekjhB",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A7%D9%84%D9%85%D9%86%D8%B8%D9%88%D9%85%D8%A9-%D8%A7%D9%84%D8%AD%D8%B3%D9%86%D9%8A%D8%A9-%D9%81%D9%8A-%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-127",
        "title": "المنظومة الحسنية في السيرة النبوية",
        "description": "المنظومة الحسنية في السيرة النبوية | نظم / طاهر غالب احمد الحسني | أداء : ظفر النتيفات",
        "image": "https://www.guidetosunnah.com/storage/posts/mnthom730_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/mnthom730_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=Ky4uvO2nGLc",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%AF%D8%B1%D9%88%D8%B3-%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D8%BA%D9%8A%D8%A7%D8%AB-%D8%BA%D8%B2%D8%A7%D9%84-128",
        "title": "دروس السيرة النبوية - غياث غزال",
        "description": "دروس في السيرة النبوية الشريفة يلقيها على مسامعكم الدكتور غياث غزال.",
        "image": "https://www.guidetosunnah.com/storage/posts/dros729_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/dros729_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=Yjid01aCOSk&list=PLd0BQqadixzVNsiv0Tzgpx_DQTZkZQG_R&index=2",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A3%D9%86%D8%A7%D8%B4%D9%8A%D8%AF-%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-129",
        "title": "أناشيد السيرة النبوية",
        "description": "",
        "image": "https://www.guidetosunnah.com/storage/posts/anashid597_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D9%85%D8%AD%D9%85%D8%AF-%D8%B3%D9%8A%D8%AF-%D8%AD%D8%A7%D8%AC-130",
        "title": "السيرة النبوية - محمد سيد حاج",
        "description": "السيرة النبوية الشريفة يلقيها على مسامعكم الشيخ محمد سيد حاج رحمه الله.",
        "image": "https://www.guidetosunnah.com/storage/posts/alsyr728_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/alsyr728_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=PnEuqpwAZh0&list=PL2o-K7db4maNu-c1N_YHq0mSeYG8NKHP-",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B3%D9%84%D8%B3%D9%84%D8%A9-%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D8%B9%D8%A7%D8%AF%D9%84-%D8%B4%D9%81%D9%8A%D9%82-131",
        "title": "سلسلة السيرة النبوية - عادل شفيق",
        "description": "سلسلة السيرة النبوية نتعلم من خلالها أن دراسة السيرة ليست مجرد سرد تاريخي لحياة النبي صلي الله عليه وسلم، ولكنها عمل تطبيقي يراد منه تجسيد الحقيقة الإسلامية كاملة في مثلها الأعلى محمد صلي الله عليه وسلم.",
        "image": "https://www.guidetosunnah.com/storage/posts/slsl-alsyr-alnboy1599_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/slsl-alsyr-alnboy1599_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=K4k_qwHa13s&list=PLpfwlgHPbf1UcT8LOViFictj_zaphJLSr",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A7%D9%84%D9%85%D8%AE%D8%AA%D8%B5%D8%B1-%D9%81%D9%8A-%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-132",
        "title": "المختصر في السيرة النبوية",
        "description": "المختصر في السيرة النبوية، تأليف : موسى بن راشد العازمي إنتاج : جمعية مودة",
        "image": "https://www.guidetosunnah.com/storage/posts/mkhtsr724_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/mkhtsr724_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=Os3LM17vxcA&list=PLCp8pahoEhI6cjnB552h0vWIWjuPaY03O&index=1",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%81%D9%8A-%D8%B1%D9%8A%D8%A7%D8%B6-%D8%A7%D9%84%D8%B3%D9%86%D8%A9-133",
        "title": "في رياض السنة",
        "description": "برنامج من إنتاج قناة المجد العلمية وهو برنامج تلفزيوني يشارك في تقديمه كلا من د. عمر المقبل، و د. عبدالرحمن العقل ، و د. صالح البهلال.",
        "image": "https://www.guidetosunnah.com/storage/posts/ryad601_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/ryad601_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=jpeZ7EcmAUA&list=PLAk7YKeYLNr7T-VyJgKQYunyuzCWrL3BR&index=1",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B9%D9%84%D9%88%D9%85-%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB-%D8%A7%D9%84%D8%B4%D8%B1%D9%8A%D9%81-134",
        "title": "علوم الحديث الشريف",
        "description": "دروس في علوم الحديث الشريف يقدمها لكم الدكتور محمد غالب هاشم",
        "image": "https://www.guidetosunnah.com/storage/posts/aalom723_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/aalom723_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=1Z7Mo-bpw44&list=PLmqU1u6kbhxK-xbaW94lHl1icK5VQl8Bg",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%AA%D8%A7%D8%B1%D9%8A%D8%AE-%D8%AA%D8%AF%D9%88%D9%8A%D9%86-%D8%A7%D9%84%D8%B3%D9%86%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-135",
        "title": "تاريخ تدوين السنة النبوية",
        "description": "دروس في تاريخ تدوين السنة النبوية تقدمة الشيخ سعد الحميّ د",
        "image": "https://www.guidetosunnah.com/storage/posts/nbras603_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/nbras603_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=kXNbS9DWtHU&list=PL9LhdwtGvkd-4_SwnEeTbhUcb08PQ_gy7",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B1%D9%8A%D8%A7%D8%B6-%D8%A7%D9%84%D8%B5%D8%A7%D9%84%D8%AD%D9%8A%D9%86-136",
        "title": "رياض الصالحين",
        "description": "قراءة صوتية لأحاديث رياض الصاحين على قناة السنة النبوية المطهرة في اليوتيوب",
        "image": "https://www.guidetosunnah.com/storage/posts/riyad604_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/riyad604_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=3WZnyQol5TY&list=PLuIRI4Ogrvm3Pgo22yFcq2iFqoBPYY5ji&index=1",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%85%D8%B4%D8%B1%D9%88%D8%B9-%D9%82%D8%B1%D8%A7%D8%A1%D8%A9-%D8%A7%D9%84%D8%B3%D9%86%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-137",
        "title": "مشروع قراءة السنة النبوية",
        "description": "قراءة في كتب السنة النبوية من قناة العلم والحياة",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2022-12-10-204547605-showwebsitethumb687_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2022-12-10-204547605-showwebsitethumb687_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=kFkuvkF-TKU&list=PLNhOu9GRHUAWRSzsRcRNmRXeu1OUsyBTW",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A7%D9%84%D8%AA%D8%B9%D9%84%D9%8A%D9%82-%D8%B9%D9%84%D9%89-%D9%85%D9%88%D8%B7%D8%A3-%D8%A7%D9%84%D8%A5%D9%85%D8%A7%D9%85-%D9%85%D8%A7%D9%84%D9%83-138",
        "title": "التعليق على موطأ الإمام مالك",
        "description": "التعليق على موطأ الإمام مالك تقديم الدكتور تركي بن فهد الغميز على قناة مركز إحسان لدراسات السنة النبوية",
        "image": "https://www.guidetosunnah.com/storage/posts/taalyk606_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/taalyk606_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=ZhI6FQW56l4&list=PLtMBY9jnYFAAWYip-bRODErcPrxg_2_zp&index=94",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B4%D8%B1%D8%AD-%D9%83%D8%AA%D8%A7%D8%A8-%D8%AA%D8%A7%D8%B1%D9%8A%D8%AE-%D8%A7%D9%84%D8%B3%D9%86%D8%A9-139",
        "title": "شرح كتاب تاريخ السنة",
        "description": "يقدم هذا الشرح ضمن سلسلة شروح مقررات مركز إحسان لدراسات السنة النبوية تفضل بشرحه فضيلة أ.د. بكر بن محمد البخاري حفظه الله.",
        "image": "https://www.guidetosunnah.com/storage/posts/shrh607_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/shrh607_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=iMt7YvqHpJE&list=PLtMBY9jnYFABu0YO1XZYV9-rReTnsH196",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B4%D8%B1%D8%AD-%D9%83%D8%AA%D8%A7%D8%A8-%D9%85%D8%B5%D8%B7%D9%84%D8%AD-%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB-1-140",
        "title": "شرح كتاب مصطلح الحديث -1-",
        "description": "يقدم هذا الشرح ضمن سلسلة شروح مقررات مركز إحسان لدراسات السنة النبوية تفضل بشرحه فضيلة أ.د. تركي بن فهد الغميز",
        "image": "https://www.guidetosunnah.com/storage/posts/mstlh721_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/mstlh721_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=5Wm0caY8Y_w&list=PLtMBY9jnYFAD16lJm74Rp81T9wprlkYyU&index=35",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B4%D8%B1%D8%AD-%D9%83%D8%AA%D8%A7%D8%A8-%D9%85%D8%B5%D8%B7%D9%84%D8%AD-%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB-2-141",
        "title": "شرح كتاب مصطلح الحديث -2-",
        "description": "يقدم هذا الشرح ضمن سلسلة شروح مقررات مركز إحسان لدراسات السنة النبوية تفضل بشرحه فضيلة أ.د. تركي بن فهد الغميز",
        "image": "https://www.guidetosunnah.com/storage/posts/msth-2722_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/msth-2722_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=072ejM8osyQ&list=PLtMBY9jnYFAC5i-gbMcix7Pzktx7PQb9f&index=1",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A7%D9%84%D8%B3%D9%86%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D9%88%D8%A7%D9%84%D8%AA%D8%AD%D8%AF%D9%8A%D8%A7%D8%AA-%D8%A7%D9%84%D9%85%D8%B9%D8%A7%D8%B5%D8%B1%D8%A9-142",
        "title": "السنة النبوية والتحديات المعاصرة",
        "description": "محاضرة بعنوان السنة النبوية والتحديات المعاصرة على قناة يقين",
        "image": "https://www.guidetosunnah.com/storage/posts/althdyat703_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/althdyat703_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=qK05SexZlQ8&list=PLWOqmrqD6va-Wa3PIBcPtUkghQ7m7om8O",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A7%D9%84%D9%88%D8%AC%D9%8A%D8%B2-%D9%81%D9%8A-%D8%A7%D9%84%D8%B3%D9%86%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-143",
        "title": "الوجيز في السنة النبوية",
        "description": "كتاب الوجيز في السنة النبوية للشيخ صالح الشامي بصوت الشيخ عمرو البساطي",
        "image": "https://www.guidetosunnah.com/storage/posts/ojyz611_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/ojyz611_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=qwN3mUxQQGQ&list=PLBOng7CIGmTpBO9sXbdYTPc3i-J3APqCg",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B5%D8%AD%D9%8A%D8%AD-%D9%85%D8%B3%D9%84%D9%85-144",
        "title": "صحيح مسلم",
        "description": "تعلم كل يوم حديث نبوي من السنة المطهرة من كتاب صحيح مسلم على قناة السنة النبوية المطهرة",
        "image": "https://www.guidetosunnah.com/storage/posts/mslm727_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/mslm727_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=zcvU_vGH0ns&list=PLuIRI4Ogrvm0jLYvc-1M-FdI-z3kszHhb",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B5%D8%AD%D9%8A%D8%AD-%D8%A7%D9%84%D8%A8%D8%AE%D8%A7%D8%B1%D9%8A-145",
        "title": "صحيح البخاري",
        "description": "تعلم كل يوم حديث نبوي من السنة المطهرة من كتاب صحيح البخاري على قناة السنة النبوية المطهرة",
        "image": "https://www.guidetosunnah.com/storage/posts/bkhary726_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/bkhary726_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=c-zWLUx0oik&list=PLuIRI4Ogrvm2rFwpM4G3DBxZKG_d1LCI-&index=1",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B5%D8%AD%D9%8A%D8%AD-%D8%B3%D9%86%D9%86-%D8%A7%D8%A8%D9%86-%D9%85%D8%A7%D8%AC%D9%87-146",
        "title": "صحيح سنن ابن ماجه",
        "description": "تعلم كل يوم حديث نبوي من السنة المطهرة من كتاب صحيح سنن ابن ماجه على قناة السنة النبوية المطهرة",
        "image": "https://www.guidetosunnah.com/storage/posts/maj614_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/maj614_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=t63oDB9pMCs&list=PLuIRI4Ogrvm0Wdh8FYB3d-NTkOKfoc7eT",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B5%D8%AD%D9%8A%D8%AD-%D9%85%D8%B3%D9%86%D8%AF-%D8%A7%D9%84%D8%A5%D9%85%D8%A7%D9%85-%D8%A3%D8%AD%D9%85%D8%AF-147",
        "title": "صحيح مسند الإمام أحمد",
        "description": "تعلم كل يوم حديث نبوي من السنة المطهرة من كتاب صحيح مسند الإمام أحمد على قناة السنة النبوية المطهرة",
        "image": "https://www.guidetosunnah.com/storage/posts/ahmd725_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/ahmd725_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=drnpk_WdyQA&list=PLuIRI4Ogrvm2LcrCz9NtYyCPaOZRXJRJD&index=2",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A7%D9%84%D8%B4%D9%85%D8%A7%D8%A6%D9%84-%D8%A7%D9%84%D9%85%D8%AD%D9%85%D8%AF%D9%8A%D8%A9-148",
        "title": "الشمائل المحمدية",
        "description": "48 حديث صحيح في وصف رسول الله صلى الله عليه وسلم وبعض سننه على قناة السنة النبوية المطهرة",
        "image": "https://www.guidetosunnah.com/storage/posts/shmael616_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/shmael616_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=qUg-7T_APT8&list=PLuIRI4Ogrvm1C3TTXiZhn7Clc29LofwCF",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A3%D8%AD%D8%A7%D8%AF%D9%8A%D8%AB-%D9%85%D8%B4%D8%B1%D9%88%D8%AD%D8%A9-149",
        "title": "أحاديث مشروحة",
        "description": "مجموعة من الأحاديث المشروحة للشيخ سليمان الرحيلي على قناة السنة سفينة النجاة",
        "image": "https://www.guidetosunnah.com/storage/posts/mshroh702_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/mshroh702_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=ROxNSmP2bYw&list=PLKTfp9WC6ZIm1q4ELLDb567TxUuh7S4Xs&index=1",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B4%D8%B1%D8%AD-%D9%83%D8%AA%D8%A7%D8%A8-%D8%A7%D9%84%D8%A3%D8%B1%D8%A8%D8%B9%D9%88%D9%86-%D8%A7%D9%84%D9%86%D9%88%D9%88%D9%8A%D8%A9-%D8%B9%D8%AB%D9%85%D8%A7%D9%86-%D8%A7%D9%84%D8%AE%D9%85%D9%8A%D8%B3-150",
        "title": "شرح كتاب الأربعون النووية - عثمان الخميس",
        "description": "كتاب الأربعين للإمام النووي رحمه الله كتابٌ عظيمٌ، نفع الله به العباد في مشارق الأرض ومغاربها، وقد زاد الكتاب نفعًا بما زاده الحافظ ابن رجب الحنبلي رحمه الله، من تتمة لهذه الأحاديث.",
        "image": "https://www.guidetosunnah.com/storage/posts/nooy618_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/nooy618_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=K-uY26YzaIs&list=PLx3Fh1kiMbrf11L0q1rZ3-pOc74c3nCSp",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%85%D8%AD%D8%A7%D8%B6%D8%B1%D8%A9-%D8%A3%D8%AD%D8%A7%D8%AF%D9%8A%D8%AB-%D8%A7%D9%84%D8%A2%D8%AD%D8%A7%D8%AF-%D8%B9%D8%AB%D9%85%D8%A7%D9%86-%D8%A7%D9%84%D8%AE%D9%85%D9%8A%D8%B3-151",
        "title": "محاضرة أحاديث الآحاد - عثمان الخميس",
        "description": "محاضرة للشيخ عثمان الخميس يتكلم فيها عن أحاديث الآحاد والفوائد المستخرجة منها",
        "image": "https://www.guidetosunnah.com/storage/posts/ahad619_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/ahad619_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=77VUMxponJY&list=PLx3Fh1kiMbrc190bmoe3Ot-RgjZUt8OCG",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A7%D9%84%D9%85%D8%B4%D9%83%D8%A7%D8%A9-%D9%85%D9%86-%D8%A3%D8%AD%D8%A7%D8%AF%D9%8A%D8%AB-%D8%A7%D9%84%D8%A3%D8%AD%D9%83%D8%A7%D9%85-152",
        "title": "المشكاة من أحاديث الأحكام",
        "description": "المشكاة من أحاديث الأحكام للشيخ د. محمد ضاوي العصيمي",
        "image": "https://www.guidetosunnah.com/storage/posts/mshka620_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/mshka620_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=NFqkA1HJMvM&list=PL9LhdwtGvkd80xGe0qNp3jSy0R4Cf01da",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%85%D9%82%D8%AF%D9%85%D8%A7%D8%AA-%D9%81%D9%8A-%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB-%D9%88%D8%B9%D9%84%D9%88%D9%85%D9%87-153",
        "title": "مقدمات في الحديث وعلومه",
        "description": "مقدمات في الحديث وعلومه للأستاذ الدكتور / عمر بن عبدالله المقبل أستاذ الحديث في جامعة القصيم",
        "image": "https://www.guidetosunnah.com/storage/posts/mkdmat-fy-alhdyth700_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/mkdmat-fy-alhdyth700_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=H9qZZXstNOA&list=PLAk7YKeYLNr6YGpneRVCtD9T-UdBVCGbM",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A7%D9%84%D8%AA%D8%B9%D9%84%D9%8A%D9%82-%D8%B9%D9%84%D9%89-%D8%A7%D9%84%D9%81%D8%B5%D9%88%D9%84-%D9%81%D9%8A-%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D8%B1%D8%B3%D9%88%D9%84-154",
        "title": "التعليق على الفصول في سيرة الرسول",
        "description": "التعليق على الفصول في سيرة الرسول للأستاذ الدكتور / عمر بن عبدالله المقبل أستاذ الحديث في جامعة القصيم",
        "image": "https://www.guidetosunnah.com/storage/posts/fsol622-quranproductthumb695_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/fsol622-quranproductthumb695_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=Y0JUSeCDdM8&list=PLAk7YKeYLNr5vMtlCY1EvF4ndEdoaDyST&index=1",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A7%D9%84%D8%AA%D8%B9%D9%84%D9%8A%D9%82-%D8%B9%D9%84%D9%89-%D8%B1%D9%8A%D8%A7%D8%B6-%D8%A7%D9%84%D8%B5%D8%A7%D9%84%D8%AD%D9%8A%D9%86-155",
        "title": "التعليق على رياض الصالحين",
        "description": "التعليق على كتاب رياض الصالحين للدكتور / عمر بن عبدالله المقبل",
        "image": "https://www.guidetosunnah.com/storage/posts/alsalhyn623_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/alsalhyn623_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=ZxlAof4UvNE&list=PLAk7YKeYLNr6nJNbrR4RLEBFTY377u5j6&index=8",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A7%D9%84%D9%87%D8%AF%D9%8A-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A-%D9%81%D9%8A-%D8%B1%D9%85%D8%B6%D8%A7%D9%86-156",
        "title": "الهدي النبوي في رمضان",
        "description": "برنامج رمضاني يتناول شيئًا من دلالات أحاديث النبي صلى الله عليه وسلم القولية، وشيئًا من دلالات أفعاله النبوية؛ لنقتبس من هديها، فإن الله جل وعلا أمرنا أن نتأسى به في قوله: (لقد كان لكم في رسول الله).",
        "image": "https://www.guidetosunnah.com/storage/posts/rmdan624_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/rmdan624_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=gUtkihM7yoM&list=PL5365B18918CD2232",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%85%D8%B5%D8%A7%D8%A8%D9%8A%D8%AD-%D8%A7%D9%84%D8%B3%D9%86%D8%A9-157",
        "title": "مصابيح السنة",
        "description": "برنامج مصابيح السنة، (رمضان 1433) للشيخ د.عمر بن عبدالله المقبل - أستاذ الحديث المشارك في كلية الشريعة بجامعة القصيم - نائب رئيس الهيئة العالمية لتدبر القرآن، مع أ.عبدالرحمن العمري",
        "image": "https://www.guidetosunnah.com/storage/posts/msabyh625_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/msabyh625_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=NnFiVpH1hnQ&list=PL6C76B1CEF20EA85F",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D8%B9%D8%AB%D9%85%D8%A7%D9%86-%D8%A7%D9%84%D8%AE%D9%85%D9%8A%D8%B3-158",
        "title": "السيرة النبوية - عثمان الخميس",
        "description": "السيرة النبوية الشريفة للشيخ عثمان الخميس",
        "image": "https://www.guidetosunnah.com/storage/posts/sraj626_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/sraj626_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=de2jEjVv6Cg&list=PLtJrl_Gv4anMmCfYRgX_I2FIuI1Be5t6c",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%86%D8%B8%D9%85-%D8%A7%D9%84%D8%AF%D8%B1%D8%B1-%D8%A7%D9%84%D8%B3%D9%86%D9%8A%D8%A9-%D9%81%D9%8A-%D8%A7%D9%84%D8%B3%D9%8A%D8%B1-%D8%A7%D9%84%D8%B2%D9%83%D9%8A%D8%A9-%D8%A3%D9%84%D9%81%D9%8A%D8%A9-%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-159",
        "title": "نظم الدرر السنية في السير الزكية - ألفية السيرة النبوية",
        "description": "نظم الإمام الحافظ زين الدين عبدالرحيم بن الحسين العراقي - رحمه الله",
        "image": "https://www.guidetosunnah.com/storage/posts/alfy-alsyr-alnboy-nthm-aldrr-alsny-alzky-0001691_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/alfy-alsyr-alnboy-nthm-aldrr-alsny-alzky-0001691_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=Mo-mT0eSALs&list=PLtJrl_Gv4anPaIcXM4Nv1LSpPd4gJM2SO",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A7%D9%84%D9%84%D8%A4%D9%84%D8%A4-%D9%88%D8%A7%D9%84%D9%85%D8%B1%D8%AC%D8%A7%D9%86-%D9%81%D9%8A%D9%85%D8%A7-%D8%A7%D8%AA%D9%81%D9%82-%D8%B9%D9%84%D9%8A%D9%87-%D8%A7%D9%84%D8%B4%D9%8A%D8%AE%D8%A7%D9%86-%D9%83%D8%AA%D8%A7%D8%A8-%D8%A7%D9%84%D8%B5%D9%8A%D8%A7%D9%85-160",
        "title": "اللؤلؤ والمرجان فيما اتفق عليه الشيخان - كتاب الصيام",
        "description": "كتاب اللؤلؤ والمرجان فيما اتفق عليه الشيخان. بصوت د. محمود رشاد خليفة - أستاذ الحديث النبوى وعلوم السنة المساعد بجامعة الأزهر مراجعة د. على عبد المنعم عبد الحميد - أستاذ الدراسات الأدبية والعربية",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2022-12-12-204735628_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2022-12-12-204735628_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=lUbcNXWcOyQ&list=PLtJrl_Gv4anM3jGYnNHKbtUjz0JkACqc0&index=1",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B4%D8%B1%D8%AD-%D8%B5%D9%81%D8%A9-%D8%B5%D9%84%D8%A7%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%8A-%D8%B5%D9%84%D9%89-%D8%A7%D9%84%D9%84%D9%87-%D8%B9%D9%84%D9%8A%D9%87-%D9%88%D8%B3%D9%84%D9%85-161",
        "title": "شرح صفة صلاة النبي صلى الله عليه وسلم",
        "description": "شرح صفة صلاة النبي صلى الله عليه وسلم لفضيلة الشيخ . عبدالرحمن بن فهد الودعان",
        "image": "https://www.guidetosunnah.com/storage/posts/sf629_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/sf629_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=cWZK3YZqavY&list=PL3V5p_vYEKUMuSntyQ8-nLF-p7rKv1nDx",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B4%D8%B1%D8%AD-%D8%B3%D9%86%D9%86-%D8%A3%D8%A8%D9%8A-%D8%AF%D8%A7%D9%88%D8%AF-162",
        "title": "شرح سُنن أبي داود",
        "description": "شرح سُنن أبي داود لفضيلة الشيخ . عبدالعزيز الراجحي",
        "image": "https://www.guidetosunnah.com/storage/posts/daod631_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/daod631_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=qL2q6xx9z38&list=PL3V5p_vYEKUM_mNQwOdcPlysnKyCxUoPV",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B4%D8%B1%D8%AD-%D9%85%D8%AE%D8%AA%D8%B5%D8%B1-%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-163",
        "title": "شرح مختصر السيرة النبوية",
        "description": "شرح مختصر السيرة النبوية لابن كثير للشيخ د. عبد الله بن عبد المحسن التويجري",
        "image": "https://www.guidetosunnah.com/storage/posts/mkhtsr632_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/mkhtsr632_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=DLUt9xoFM5Y&list=PL3V5p_vYEKUNzY1RJ-m6QBfQrEIVZ_5e2",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B4%D8%B1%D8%AD-%D9%83%D8%AA%D8%A7%D8%A8-%D8%A7%D9%84%D8%B3%D9%86%D8%A9-164",
        "title": "شرح كتاب السنة",
        "description": "شرح كتاب السنة للإمام عبد الله بن أحمد بن حنبل - فضيلة الشيخ د علي بن عبد العزيز الشبل",
        "image": "https://www.guidetosunnah.com/storage/posts/sunnah633_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/sunnah633_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=-s5FMqClp1I&list=PL3V5p_vYEKUMNqX8VhnfUID5ksODn-frL",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%88%D8%B5%D8%A7%D9%8A%D8%A7-%D9%86%D8%A8%D9%88%D9%8A%D8%A9-165",
        "title": "وصايا نبوية",
        "description": "يمكنكم مشاهدة سلسلة وصايا نبوية على قناة ينابيع العلم",
        "image": "https://www.guidetosunnah.com/storage/posts/osaya648-showcenterthumb690_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "السنن النبوية مصوّرة",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/osaya648-showcenterthumb690_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=KWjn44jQHYI&list=PL2syWUMCjVfal2vyqqmbBC2kegUPeKaeh",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A3%D8%AD%D8%A7%D8%AF%D9%8A%D8%AB-%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D8%A8%D9%84%D8%BA%D8%A9-%D8%A7%D9%84%D8%A5%D8%B4%D8%A7%D8%B1%D8%A9-%D8%A5%D8%B3%D9%84%D8%A7%D9%85-%D9%88%D9%8A%D8%A8-167",
        "title": "أحاديث نبوية بلغة الإشارة - إسلام ويب",
        "description": "مجموعة من الأحاديث النبوية الشريفة بلغة الإشارة مقدمة من إسلام ويب.",
        "image": "https://www.guidetosunnah.com/storage/posts/ashar652-websitethumb685_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/ashar652-websitethumb685_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=CrZGmkiGOuQ&list=PLP3ke6jz11_Bej-DbS2yJ-I4Ap00HFlqw",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%82%D8%B5%D8%B5-%D9%85%D9%86-%D8%AD%D9%8A%D8%A7%D8%A9-%D8%A7%D9%84%D8%B1%D8%B3%D9%88%D9%84-%D8%B5%D9%84%D9%89-%D8%A7%D9%84%D9%84%D9%87-%D8%B9%D9%84%D9%8A%D9%87-%D9%88%D8%B3%D9%84%D9%85-%D8%A8%D9%84%D8%BA%D8%A9-%D8%A7%D9%84%D8%A5%D8%B4%D8%A7%D8%B1%D8%A9-168",
        "title": "قصص من حياة الرسول صلى الله عليه وسلم بلغة الإشارة",
        "description": "قصص من حياة النبي والسيرة النبوية بلغة الإشارة للصم من إسلام ويب",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2023-01-16-180538688_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2023-01-16-180538688_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=OAHemp7OCUU&list=PLP3ke6jz11_C3XTNntCbgb3aFrQckRUp2",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B4%D8%B1%D8%AD-%D9%83%D8%AA%D8%A7%D8%A8-%D8%A3%D8%B5%D9%88%D9%84-%D8%A7%D9%84%D8%B3%D9%86%D8%A9-177",
        "title": "شرح كتاب أصول السنة",
        "description": "شرح أصول السنة للإمام أحمد بن حنبل - الشيخ د عبدالله العنقري",
        "image": "https://www.guidetosunnah.com/storage/posts/asol667-simmilarappthumb682_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/asol667-simmilarappthumb682_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=zYa2_ihI7kQ&list=PL914QhoC1BhtH704zP2yElAS3cWW0BYnW",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B4%D8%B1%D8%AD-%D9%85%D9%88%D8%B7%D8%A3-%D8%A7%D9%84%D8%A5%D9%85%D8%A7%D9%85-%D9%85%D8%A7%D9%84%D9%83-%D8%A8%D9%86-%D8%A3%D9%86%D8%B3-178",
        "title": "شرح موطأ الإمام مالك بن أنس",
        "description": "شرح موطأ الإمام مالك بن أنس للشيخ د عبدالكريم الخضير على قناة الراية.",
        "image": "https://www.guidetosunnah.com/storage/posts/malk668-websitethumb686_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/malk668-websitethumb686_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=38Buxyf3p80&list=PL914QhoC1BhuOp9nUmQguc28vxY7ojoFE",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B9%D9%84%D9%89-%D8%AE%D8%B7%D9%89-%D8%A7%D9%84%D8%B1%D8%B3%D9%88%D9%84-%EF%B7%BA-188",
        "title": "على خطى الرسول ﷺ",
        "description": "بوابة جامعة لعدد من المشاريع والمنتجات، تهدف إلى تقريب السنة النبوية إلى جمهور الناس بأنواع من المحتويات والقوالب المختلفة.",
        "image": "https://www.guidetosunnah.com/storage/posts/photo-4-5-5913_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/photo-4-5-5913_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://telegram.me/sunnahsteps",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B9%D9%84%D9%8A%D9%83%D9%85-%D8%A8%D8%B3%D9%86%D8%AA%D9%8A-189",
        "title": "عليكم بسنتي",
        "description": "قناة على التلجرام تهدف إلى تقريب السنة لعموم الأمة.",
        "image": "https://www.guidetosunnah.com/storage/posts/photo-6-5914_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/photo-6-5914_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://telegram.me/AlaykomSunnati",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/post-83101781622748",
        "title": "الكتب التسعة",
        "description": "قناة على منصة تيليجرام تُعنى بتقديم قراءات صوتية كاملة ومسجلة لأمهات كتب الحديث النبوي الشريف، تركز القناة حصرياً على الأرشيف الصوتي المسموع لـ \"الكتب التسعة\" المعتمدة في السنة النبوية.",
        "image": "https://www.guidetosunnah.com/storage/posts/8YuE5uGzO8rTU4vBK9BIhKN4g8qbBGj5rwOqVa3H_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب الحديث وشروحاتها",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/8YuE5uGzO8rTU4vBK9BIhKN4g8qbBGj5rwOqVa3H.jpg",
        "primaryAction": {
          "url": "https://t.me/nnmgd",
          "label": "مشاهدة"
        }
      }
    ]
  },
  "broadcast": {
    "root": "https://www.guidetosunnah.com/ar/sunna-radios/channels",
    "pages": 1,
    "categories": [
      {
        "url": "https://www.guidetosunnah.com/ar/sunna-radios/channels",
        "label": "قنوات فضائية"
      },
      {
        "url": "https://www.guidetosunnah.com/ar/sunna-radios/broadcasts",
        "label": "محطات إذاعية"
      }
    ],
    "items": [
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/sunna-radios/show/item-1kna-1alsn-1alnboy",
        "title": "قناة السنة النبوية",
        "description": "هي قناة تلفزيونية سعودية تبث باللغة العربية من المدينة المنورة بث حي مباشر 24 ساعة للمسجد النبوي الشريف",
        "image": "https://www.guidetosunnah.com/storage/posts/unnamed-2318_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "قنوات فضائية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/unnamed-2318_showWebsiteThumb.jpg"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/sunna-radios/show/item-2kna-2almgd-2llsn-2alnboy",
        "title": "قناة المجد للسنة النبوية",
        "description": "تقدم للمشاهدين السيرة النبوية الشريفة، والأحاديث الصحيحة الثابتة في السنة المطهرة، وتبرز جوانب الرحمة التي بعث بها نبينا ( محمد صلى الله عليه وسلم) كما قال تعالى: { وما أرسلناك إلا رحمة للعالمين } [ الأنبياء: 107]",
        "image": "https://www.guidetosunnah.com/storage/posts/almjd-llhdyth-alnboy316_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "قنوات فضائية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/almjd-llhdyth-alnboy316_showWebsiteThumb.jpg"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/sunna-radios/show/post-7581781451466",
        "title": "خير",
        "description": "قناة دعوية على التلجرام متخصصة في خدمة السنة النبوية المطهرة ونشرها على نطاق عالمي، حيث تدير القناة ، وتركز على تقديم الأحاديث الثابتة في قوالب وتصاميم بصرية مميزة وسهلة القراءة، لا يقتصر محتوى القناة على اللغة العربية، بل تسعى لنشر الأحاديث النبوية بعدة لغات لضمان وصول رسالة الإسلام والسنة إلى غير الناطقين بالعربية",
        "image": "https://www.guidetosunnah.com/storage/posts/RfZKw3qjDWXAv2kg9yBbGnVWdEijayg4DdvBRhbe_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "قنوات فضائية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/RfZKw3qjDWXAv2kg9yBbGnVWdEijayg4DdvBRhbe.jpg"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/sunna-radios/show/post-44801781537350",
        "title": "قال: {حدثنا}",
        "description": "قناة على تيليجرام تُعنى بجمع ونشر كتب ورسائل وأبحاث علم الحديث وشروحه المعتمدة، تركز القناة على توفير التراث الحديثي رقمياً، حيث تضم مكتبتها أكثر من 17,000 عنوان تشمل كتب الأحاديث المشروحة، الرسائل العلمية، الأبحاث الأكاديمية، ومخرجات المؤتمرات الحديثية المتخصصة.",
        "image": "https://www.guidetosunnah.com/storage/posts/1JulXnsQtF21xuoTvEhkqgUwNRpulyOmz4ZuAIji_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "قنوات فضائية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/1JulXnsQtF21xuoTvEhkqgUwNRpulyOmz4ZuAIji.jpg"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/sunna-radios/show/item-3athaaa-3alsn",
        "title": "إذاعة السنة",
        "description": "إذاعة إسلامية سلفية من مكة",
        "image": "https://www.guidetosunnah.com/storage/posts/almsjd-alnboy317_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "محطات إذاعية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/almsjd-alnboy317_showWebsiteThumb.jpg"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/sunna-radios/show/item-4athaaa-4alsn-4alnboy",
        "title": "إذاعة السنة النبوية",
        "description": "خير الهدي هدي محمد",
        "image": "https://www.guidetosunnah.com/storage/posts/unnamed187_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "محطات إذاعية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/unnamed187_showWebsiteThumb.png"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/sunna-radios/show/item-5bodkast-5shrh-5alarbaayn-5alnooy",
        "title": "بودكاست شرح الأربعين النووية",
        "description": "للذهاب إلى البودكاست اضغط هنا ← شرح الأربعين النووية - محمد صالح العثيمين",
        "image": "https://www.guidetosunnah.com/storage/posts/shrh-alarbaayn-alnooy-dar-almstf487_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "محطات إذاعية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/shrh-alarbaayn-alnooy-dar-almstf487_showWebsiteThumb.jpg"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/sunna-radios/show/item-10bodkast-10kss-10alanbyaaa-10aathman-10alkhmys",
        "title": "بودكاست قصص الأنبياء - عثمان الخميس",
        "description": "للذهاب إلى صفحة البودكاست اضغط هنا ← سلسلة قصص الأنبياء - الشيخ عثمان الخميس",
        "image": "https://www.guidetosunnah.com/storage/posts/apps6189513510798887039515e772f8e0-296e-48f2-a0d5-80c6da62425a319_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "محطات إذاعية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/apps6189513510798887039515e772f8e0-296e-48f2-a0d5-80c6da62425a319_showWebsiteThumb.jpg"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/sunna-radios/show/item-13athaaa-13myrath-13alanbyaaa",
        "title": "إذاعة ميراث الأنبياء",
        "description": "حملة هذا الدين",
        "image": "https://www.guidetosunnah.com/storage/posts/kisspng-podcast-computer-icons-microphone-youtube-5af8bf420f0b328321946315262513300616196_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "محطات إذاعية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/kisspng-podcast-computer-icons-microphone-youtube-5af8bf420f0b328321946315262513300616196_showWebsiteThumb.jpg"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/sunna-radios/show/item-14athaaa-14almgd-14llhdyth-14alshryf",
        "title": "إذاعة المجد للحديث الشريف",
        "description": "استمع لأقوال رسول الله صلى الله عليه وسلم",
        "image": "https://www.guidetosunnah.com/storage/posts/ethaaa-almjd-llhdyth-alshryf634_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "محطات إذاعية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/ethaaa-almjd-llhdyth-alshryf634_showWebsiteThumb.png"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/sunna-radios/show/item-15athaaa-15alhdyth-15oaalomh",
        "title": "إذاعة الحديث وعلومه",
        "description": "إذاعة الحديث وعلومه",
        "image": "https://www.guidetosunnah.com/storage/posts/ethaaa-alhdyth-oaalomh635_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "محطات إذاعية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/ethaaa-alhdyth-oaalomh635_showWebsiteThumb.png"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/sunna-radios/show/item-16athaaa-16alsyr-16alnboy-16okss-16alkran",
        "title": "إذاعة السيرة النبوية وقصص القرآن",
        "description": "إذاعة السيرة النبوية وقصص القرآن والأنبياء والصحابة",
        "image": "https://www.guidetosunnah.com/storage/posts/ethaaa-alsyr-alnboy-okss-alkraan636_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "محطات إذاعية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/ethaaa-alsyr-alnboy-okss-alkraan636_showWebsiteThumb.png"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/sunna-radios/show/item-17bodkast-17mkhtsr-17albkhary-17llshykh-17saad-17alshthry",
        "title": "بودكاست مختصر البخاري للشيخ سعد الشثري",
        "description": "للذهاب إلى البودكاست اضغط هنا ← بودكاست مختصر البخاري للشيخ سعد الشثري",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2022-11-16-2017261438-bigthumb637_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "محطات إذاعية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2022-11-16-2017261438-bigthumb637_showWebsiteThumb.png"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/sunna-radios/show/item-18bodkast-18alsyr-18alnboy-18llshykh-18aby-18gabr-18aabdalhlym-18tomyat",
        "title": "بودكاست السيرة النبوية للشيخ أبي جابر عبدالحليم توميات",
        "description": "للذهاب إلى البودكاست اضغط هنا ← بودكاست السيرة النبوية للشيخ أبي جابر عبدالحليم توميات",
        "image": "https://www.guidetosunnah.com/storage/posts/tomiye1436-bigthumb638_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "محطات إذاعية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/tomiye1436-bigthumb638_showWebsiteThumb.png"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/sunna-radios/show/item-19bodkast-19alsyr-19alnboy-19alaatr-19aathman-19alkhmys",
        "title": "بودكاست السيرة النبوية العطرة - عثمان الخميس",
        "description": "للذهاب إلى البودكاست اضغط هنا ← بودكاست السيرة النبوية العطرة",
        "image": "https://www.guidetosunnah.com/storage/posts/alsyr-alnboy-alaatr-aathman-alkhmys-p35omwqql7y-zfxf0kkejgb1400x14001205-bigthumb639_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "محطات إذاعية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/alsyr-alnboy-alaatr-aathman-alkhmys-p35omwqql7y-zfxf0kkejgb1400x14001205-bigthumb639_showWebsiteThumb.jpg"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/sunna-radios/show/item-20bodkast-20shrh-20ryad-20alsalhyn-20mhmd-20bn-20salh-20bn-20aathymyn",
        "title": "بودكاست شرح رياض الصالحين - محمد بن صالح بن عثيمين",
        "description": "للذهاب إلى البودكاست اضغط هنا ← بودكاست شرح رياض الصالحين",
        "image": "https://www.guidetosunnah.com/storage/posts/ryad640_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "محطات إذاعية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/ryad640_showWebsiteThumb.png"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/sunna-radios/show/item-21bodkast-21shrh-21shyh-21albkhary-21alaathymyn",
        "title": "بودكاست شرح صحيح البخاري - العثيمين",
        "description": "للذهاب إلى البودكاست اضغط هنا ← بودكاست شرح صحيح البخاري",
        "image": "https://www.guidetosunnah.com/storage/posts/albkharyy641_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "محطات إذاعية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/albkharyy641_showWebsiteThumb.png"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/sunna-radios/show/item-22bodkast-22alshrh-22almmtaa-22aal-22zad-22almstknaa-22alaathymyn",
        "title": "بودكاست الشرح الممتع على زاد المستقنع - العثيمين",
        "description": "للذهاب إلى البودكاست اضغط هنا ← بودكاست الشرح الممتع على زاد المستقنع",
        "image": "https://www.guidetosunnah.com/storage/posts/mmtaa642_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "محطات إذاعية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/mmtaa642_showWebsiteThumb.png"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/sunna-radios/show/item-23bodkast-23alsyr-23alnboy-23aslam-23haos",
        "title": "بودكاست السيرة النبوية - إسلام هاوس",
        "description": "للذهاب إلى البودكاست اضغط هنا ← السيرة النبوية",
        "image": "https://www.guidetosunnah.com/storage/posts/alsyr643_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "محطات إذاعية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/alsyr643_showWebsiteThumb.png"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/sunna-radios/show/item-24bodkast-24kraaa-24ktab-24shyh-24mslm-24aslam-24haos",
        "title": "بودكاست قراءة كتاب صحيح مسلم - إسلام هاوس",
        "description": "للذهاب إلى البودكاست اضغط هنا ← قراءة كتاب صحيح مسلم",
        "image": "https://www.guidetosunnah.com/storage/posts/shyh-mslm644_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "محطات إذاعية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/shyh-mslm644_showWebsiteThumb.png"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/sunna-radios/show/item-25bodkast-25shrh-25shyh-25mslm-25aslam-25haos",
        "title": "بودكاست شرح صحيح مسلم - إسلام هاوس",
        "description": "للذهاب إلى البودكاست اضغط هنا ← شرح صحيح مسلم",
        "image": "https://www.guidetosunnah.com/storage/posts/shrh-mslm645_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "محطات إذاعية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/shrh-mslm645_showWebsiteThumb.png"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/sunna-radios/show/item-26bodkast-26shrh-26snn-26altrmthy-26aslam-26haos",
        "title": "بودكاست شرح سنن الترمذي - إسلام هاوس",
        "description": "للذهاب إلى البودكاست اضغط هنا ← شرح سنن الترمذي",
        "image": "https://www.guidetosunnah.com/storage/posts/altrmthy646_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "محطات إذاعية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/altrmthy646_showWebsiteThumb.png"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/sunna-radios/show/item-27bodkast-27shrh-27snn-27alnsayy-27aslam-27haos",
        "title": "بودكاست شرح سنن النسائي - إسلام هاوس",
        "description": "للذهاب إلى البودكاست اضغط هنا ← شرح سنن النسائي",
        "image": "https://www.guidetosunnah.com/storage/posts/alnsaey647_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "محطات إذاعية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/alnsaey647_showWebsiteThumb.png"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/sunna-radios/show/item-28bodkast-28gamaa-28alsn-28aslam-28haos",
        "title": "بودكاست جامع السنة - إسلام هاوس",
        "description": "للذهاب إلى البودكاست اضغط هنا ← بودكاست جامع السنة",
        "image": "https://www.guidetosunnah.com/storage/posts/jamaa-alsn663_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "محطات إذاعية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/jamaa-alsn663_showWebsiteThumb.png"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/sunna-radios/show/item-29bodkast-29shrh-29snn-29abn-29magh-29aslam-29haos",
        "title": "بودكاست شرح سنن ابن ماجه - إسلام هاوس",
        "description": "للذهاب إلى البودكاست اضغط هنا ← شرح سنن ابن ماجه",
        "image": "https://www.guidetosunnah.com/storage/posts/majh664_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "محطات إذاعية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/majh664_showWebsiteThumb.png"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/sunna-radios/show/item-30bodkast-30fy-30thlal-30alsyr-30ndaaa-30alaslam",
        "title": "بودكاست في ظلال السيرة - نداء الإسلام",
        "description": "للذهاب إلى البودكاست اضغط هنا ← في ظلال السيرة",
        "image": "https://www.guidetosunnah.com/storage/posts/thlal665_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "محطات إذاعية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/thlal665_showWebsiteThumb.png"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/sunna-radios/show/item-31bodkast-31mhmd-31rsol-31allh-31aslam-31haos",
        "title": "بودكاست محمد رسول الله - إسلام هاوس",
        "description": "للذهاب إلى البودكاست اضغط هنا ← محمد رسول الله [ خلاصة سيرته، ومقالات نادرة فيها ]",
        "image": "https://www.guidetosunnah.com/storage/posts/mhmd666_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "محطات إذاعية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/mhmd666_showWebsiteThumb.png"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/sunna-radios/show/item-32bodkast-32anoar-32alsyr",
        "title": "بودكاست أنوار السيرة",
        "description": "للذهاب إلى صفحة البودكاست اضغط هنا ← بودكاست أنوار السيرة",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2022-11-28-184251679_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "محطات إذاعية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2022-11-28-184251679_showWebsiteThumb.png"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/sunna-radios/show/post-91491782661458",
        "title": "زادُ الحُفَّاظ | القناة الرسمية",
        "description": "القناة الرسمية لمشروع تعليمي وشرعي متخصص في تحفيظ وتدريس المتون الشرعية وحفظ السُنّة النبوية، وتنشط بشكل رئيسي عبر منصة تليجرام.",
        "image": "https://www.guidetosunnah.com/storage/posts/v4z5f8FZciwzHjZ6xqvp0vSx3T5pbtrbL2rEEIfT_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "محطات إذاعية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/v4z5f8FZciwzHjZ6xqvp0vSx3T5pbtrbL2rEEIfT.jpg"
      }
    ]
  },
  "research": {
    "root": "https://www.guidetosunnah.com/ar/services/main-categories-bhwth-fy-alsnt",
    "pages": 3,
    "categories": [
      {
        "url": "https://www.guidetosunnah.com/ar/services/bhwth-fy-alsnt/main-categories-bhwth-fy-alsnt-ktb-wbhwth",
        "label": "كتب وبحوث"
      },
      {
        "url": "https://www.guidetosunnah.com/ar/services/bhwth-fy-alsnt/main-categories-bhwth-fy-alsnt-rsal-almyt",
        "label": "رسائل علمية"
      }
    ],
    "items": [
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B9%D9%84%D9%88%D9%85-%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB-%D9%85%D9%86-%D9%85%D9%88%D9%82%D8%B9-%D8%A7%D9%84%D9%85%D9%83%D8%AA%D8%A8%D8%A9-%D8%A7%D9%84%D8%B4%D8%A7%D9%85%D9%84%D8%A9-53",
        "title": "علوم الحديث من موقع المكتبة الشاملة",
        "description": "تم رفع الإصدار الرسمي الثاني من الشاملة، يحتوي على 6111 كتابا هي كل الكتب المختومة المتاحة حتى غرة رجب 1433 هـ، ورقم التحديث البرمجي به هو 3.48.",
        "image": "https://www.guidetosunnah.com/storage/posts/162410418_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب وبحوث",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/162410418_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://shamela.ws/index.php/category/126",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A7%D9%84%D8%AA%D8%AE%D8%B1%D9%8A%D8%AC-%D9%88%D8%A7%D9%84%D8%B2%D9%88%D8%A7%D8%A6%D8%AF-%D9%85%D9%86-%D9%85%D9%88%D9%82%D8%B9-%D8%A7%D9%84%D9%85%D9%83%D8%AA%D8%A8%D8%A9-%D8%A7%D9%84%D8%B4%D8%A7%D9%85%D9%84%D8%A9-54",
        "title": "التخريج والزوائد من موقع المكتبة الشاملة",
        "description": "تم رفع الإصدار الرسمي الثاني من الشاملة، يحتوي على 6111 كتابا هي كل الكتب المختومة المتاحة حتى غرة رجب 1433 هـ، ورقم التحديث البرمجي به هو 3.48 تنبيه: من كان قد حمل الإصدار الرسمي الأول، فلا يلزمه تحميل الإصدار الثاني، يكفيه فقط (بعد تحميل الإصدار الأول)",
        "image": "https://www.guidetosunnah.com/storage/posts/bck-4314_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب وبحوث",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/bck-4314_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://shamela.ws/index.php/category/130",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%83%D8%AA%D8%A8-%D9%85%D8%AA%D9%88%D9%86-%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB-%D9%85%D9%86-%D9%85%D9%88%D9%82%D8%B9-%D8%A7%D9%84%D9%85%D9%83%D8%AA%D8%A8%D8%A9-%D8%A7%D9%84%D8%B4%D8%A7%D9%85%D9%84%D8%A9-%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB%D8%A9-55",
        "title": "كتب متون الحديث من موقع المكتبة الشاملة الحديثة",
        "description": "مشروع تقني يهدف لتوفير قالب تقني أنيق وحديث يليق بالمحتوى الثري للمكتبة الشاملة، وقد تم التركيز على توفير محرك بحث سريع ودقيق لكافة أجزاء المحتوى، وأيضا توفير تصفح سلس لمحتوى المكتبة ومتوافق مع أجهزة الجوال",
        "image": "https://www.guidetosunnah.com/storage/posts/screen-4142_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب وبحوث",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screen-4142_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://al-maktaba.org/category/125",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%83%D8%AA%D8%A8-%D8%B4%D8%B1%D9%88%D8%AD-%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB-%D9%85%D9%86-%D9%85%D9%88%D9%82%D8%B9-%D8%A7%D9%84%D9%85%D9%83%D8%AA%D8%A8%D8%A9-%D8%A7%D9%84%D8%B4%D8%A7%D9%85%D9%84%D8%A9-%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB%D8%A9-56",
        "title": "كتب شروح الحديث من موقع المكتبة الشاملة الحديثة",
        "description": "مشروع تقني يهدف لتوفير قالب تقني أنيق وحديث يليق بالمحتوى الثري للمكتبة الشاملة، وقد تم التركيز على توفير محرك بحث سريع ودقيق لكافة أجزاء المحتوى، وأيضا توفير تصفح سلس وسهل لمحتوى المكتبة ومتوافق تماما مع أجهزة الجوال",
        "image": "https://www.guidetosunnah.com/storage/posts/shutterstock-472787539299_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب وبحوث",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/shutterstock-472787539299_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://al-maktaba.org/category/108",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%83%D8%AA%D8%A8-%D8%A7%D9%84%D8%AA%D8%AE%D8%B1%D9%8A%D8%AC-%D9%85%D9%88%D9%82%D8%B9-%D8%A7%D9%84%D9%85%D9%88%D8%B3%D9%88%D8%B9%D8%A9-%D8%A7%D9%84%D8%B4%D8%A7%D9%85%D9%84%D8%A9-57",
        "title": "كتب التخريج - موقع الموسوعة الشاملة",
        "description": "عبارة عن محرك بحث ضخم مدمج مع مكتبة علمية إلكترونية خيرية ضخمة جداً حيث تضم في جنباتها آلاف الكتب والأبحاث الإسلامية والعربية وغير العربية القديمة والحديثة، وهو موقع خيري يهدف إلى نشر العلم والمعرفة للجميع وتذليل سبل البحث العلمي النافع.",
        "image": "https://www.guidetosunnah.com/storage/posts/fine-books-01-hd-picture-166599420_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب وبحوث",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/fine-books-01-hd-picture-166599420_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "http://www.islamport.com/isp_eBooks/krj/",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/219-%D9%83%D8%AA%D8%A7%D8%A8-%D9%81%D9%8A-%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D9%85%D9%88%D9%82%D8%B9-%D8%A7%D9%84%D9%85%D9%83%D8%AA%D8%A8%D8%A9-%D8%A7%D9%84%D9%88%D9%82%D9%81%D9%8A%D8%A9-58",
        "title": "219 كتاب في السيرة النبوية - موقع المكتبة الوقفية",
        "description": "من المكتبة الوقفية مجموعة كتب في السيرة النبوية، مع إمكانية قراءة الكتاب أون لاين، مرفوع بصيغة pdf ، مما يسهل على الباحث توثيق اقتباساتهم.",
        "image": "https://www.guidetosunnah.com/storage/posts/shutterstock-1546376072300_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب وبحوث",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/shutterstock-1546376072300_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://waqfeya.com/category.php?cid=24",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/213-%D9%83%D8%AA%D8%A7%D8%A8-%D9%81%D9%8A-%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB-%D8%A7%D9%84%D8%B4%D8%B1%D9%8A%D9%81-%D9%88%D8%B9%D9%84%D9%88%D9%85%D9%87-%D9%85%D9%88%D9%82%D8%B9-%D8%A7%D9%84%D9%85%D9%83%D8%AA%D8%A8%D8%A9-%D8%A7%D9%84%D9%88%D9%82%D9%81%D9%8A%D8%A9-59",
        "title": "213 كتاب في الحديث الشريف وعلومه - موقع المكتبة الوقفية",
        "description": "مجموعة كتب في الحديث النبوي الشريف وكتب الأسانيد، بالإضافة إلى مجموعة من الكتب للمختصين والمهتمين تساعدهم في بحوثهم ورسائلهم.",
        "image": "https://www.guidetosunnah.com/storage/posts/untitled-design706_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب وبحوث",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/untitled-design706_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://waqfeya.com/category.php?cid=68",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%85%D8%B5%D8%B7%D9%84%D8%AD-%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB-%D9%85%D9%86-%D8%A7%D9%84%D9%85%D9%83%D8%AA%D8%A8%D8%A9-%D8%A7%D9%84%D8%A5%D8%B3%D9%84%D8%A7%D9%85%D9%8A%D8%A9-%D8%A5%D8%B3%D9%84%D8%A7%D9%85-%D9%88%D9%8A%D8%A8-60",
        "title": "مصطلح الحديث من المكتبة الإسلامية (إسلام ويب)",
        "description": "تغطي المكتبة الإسلامية بالشبكة أمهات العلوم الشرعية بفروعها المختلفة, من عبادات ومعاملات وآداب شرعية بالإضافة إلى أصول الفقه وتفسير القرآن الكريم ومصطلح الحديث والسيرة والعقيدة والتاريخ.",
        "image": "https://www.guidetosunnah.com/storage/posts/shutterstock-738539749308_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب وبحوث",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/shutterstock-738539749308_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://islamweb.net/ar/library/index.php?page=TreeCategory&ID=30128",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%85%D9%83%D8%AA%D8%A8%D8%A9-%D8%A7%D9%84%D8%B3%D9%86%D8%A9-%D9%85%D9%88%D9%82%D8%B9-%D8%A5%D8%B3%D9%84%D8%A7%D9%85-%D9%88%D9%8A%D8%A8-61",
        "title": "مكتبة السنة - موقع إسلام ويب",
        "description": "مجموعة كتب في الحديث النبوي الشريف وعلومه، مقدمة من موقع إسلام ويب، بالإضافة إلى كتب التراجم، وكتب مصطلح الحديث وغريبه، وكتب أخرى، يحتاجها الباحث في الحديث الشريف.",
        "image": "https://www.guidetosunnah.com/storage/posts/11313_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب وبحوث",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/11313_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.islamweb.net/ar/articles/414/%D9%85%D9%83%D8%AA%D8%A8%D8%A9-%D8%A7%D9%84%D8%B3%D9%86%D8%A9",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB-%D9%88%D9%83%D8%AA%D8%A8-%D8%A7%D9%84%D8%B3%D9%86%D8%A9-%D8%B4%D8%A8%D9%83%D8%A9-%D9%85%D8%B4%D9%83%D8%A7%D8%A9-%D8%A7%D9%84%D8%A5%D8%B3%D9%84%D8%A7%D9%85%D9%8A%D8%A9-62",
        "title": "الحديث وكتب السنة - شبكة مشكاة الإسلامية",
        "description": "الحديث وكتب السنة، بالإضافة إلى العديد من كتب الحديث المشهورة مقدمة من شبكة مشكاة الإسلامية، تفيد المهتمين مجموعة بشكل يسهل على الباحث الوصول إلى مراده.",
        "image": "https://www.guidetosunnah.com/storage/posts/497757817-0799512001534082996312_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب وبحوث",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/497757817-0799512001534082996312_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.almeshkat.net/library/",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A3%D9%81%D8%B6%D9%84-100-%D9%83%D8%AA%D8%A7%D8%A8-%D9%81%D9%8A-%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB-%D8%A7%D9%84%D8%B4%D8%B1%D9%8A%D9%81-%D9%85%D9%83%D8%AA%D8%A8%D8%A9-%D8%A7%D9%84%D9%83%D8%AA%D8%A8-63",
        "title": "أفضل 100 كتاب في الحديث الشريف - مكتبة الكتب",
        "description": "من الكتب المهمة في الحديث الشريف مجموعة بأسلوب جذاب ومقدمة من مكتبة الكتب، مع إمكانية تحميل الكتاب بصيغة PDF، وإمكانية مشاركته مع الباحثين والمختصين.",
        "image": "https://www.guidetosunnah.com/storage/posts/logo-books146-showwebsitethumb713_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب وبحوث",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/logo-books146-showwebsitethumb713_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://books-library.online/t-2798-best-download",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%83%D8%AA%D8%A8-%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB-%D9%88%D8%B9%D9%84%D9%88%D9%85%D9%87-%D9%85%D9%83%D8%AA%D8%A8%D8%A9-%D8%A7%D9%84%D8%A3%D9%84%D9%88%D9%83%D8%A9-64",
        "title": "كتب الحديث وعلومه - مكتبة الألوكة",
        "description": "مكتبة الألوكة تقدم للباحثين والقرَّاء ولمختصين، مجموعة كتب في علوم الحديث، وتضعها بين أيديهم، مع إمكانية اقتراح كتب جديدة من قبل الباحثين.",
        "image": "https://www.guidetosunnah.com/storage/posts/unnamed-3122-showwebsitethumb712_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب وبحوث",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/unnamed-3122-showwebsitethumb712_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.alukah.net/library/9006/",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB-%D9%88%D8%B9%D9%84%D9%88%D9%85%D9%87-%D8%A7%D9%84%D9%85%D9%83%D8%AA%D8%A8%D8%A9-%D8%A7%D9%84%D8%A5%D8%B3%D9%84%D8%A7%D9%85%D9%8A%D8%A9-66",
        "title": "الحديث وعلومه - المكتبة الإسلامية",
        "description": "مجموعة كتب في الحديث النبوي الشريف مقدمة من المكتبة الإسلامية الإلكترونية، مع إمكانية قراءة الكتاب أون لاين، أو تحميله إلى الجهاز الإلكتروني الخاص بالباحث.",
        "image": "https://www.guidetosunnah.com/storage/posts/library-header311_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب وبحوث",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/library-header311_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.muslim-library.com/category/arabic/%D8%A7%D9%84%D8%A5%D8%B3%D9%84%D8%A7%D9%85/%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB-%D9%88%D8%B9%D9%84%D9%88%D9%85%D9%87/",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%83%D8%AA%D8%A8-%D8%A7%D9%84%D8%B3%D9%86%D8%A9-%D9%88%D8%B9%D9%84%D9%88%D9%85%D9%87%D8%A7-%D9%85%D9%88%D9%82%D8%B9-%D9%86%D8%AF%D8%A7%D8%A1-%D8%A7%D9%84%D8%A5%D9%8A%D9%85%D8%A7%D9%86-68",
        "title": "كتب السنة وعلومها - موقع نداء الإيمان",
        "description": "مجموعة من أمهات الكتب في الحديث النبوي الشريف وعلومه، تساعد الباحثين والمختصين، مقدمة من موقع نداء الإيمان، مع إمكانية البحث عن جملة ضمن الكتاب بالإضافة إلى ميزات أخرى.",
        "image": "https://www.guidetosunnah.com/storage/posts/shutterstock-418483579310_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب وبحوث",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/shutterstock-418483579310_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "http://www.al-eman.com/%D8%A7%D9%84%D9%83%D8%AA%D8%A8/%D8%A7%D9%84%D8%B3%D9%86%D8%A9+%D9%88%D8%B9%D9%84%D9%88%D9%85%D9%87%D8%A7/c702&h&p4",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%83%D8%AA%D8%A8-%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB-%D9%85%D9%88%D9%82%D8%B9-%D9%85%D9%88%D8%B3%D9%88%D8%B9%D8%A9-%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB-69",
        "title": "كتب الحديث - موقع موسوعة الحديث",
        "description": "المئات من الكتب المختصة في علوم الحديث، في كافة المواضيع التي تهم الباحث العلمي، مقدمة من شركة فكرة للبرمجيات، تساعد وتسهل عمل الباحثين والمختصين.",
        "image": "https://www.guidetosunnah.com/storage/posts/shutterstock-1551061133309_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب وبحوث",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/shutterstock-1551061133309_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://hadith.islam-db.com/",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B1%D8%B3%D8%A7%D8%A6%D9%84-%D9%81%D9%8A-%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB-%D9%88%D8%B9%D9%84%D9%88%D9%85%D9%87-%D9%84%D9%84%D8%AA%D8%AD%D9%85%D9%8A%D9%84-%D9%85%D9%88%D9%82%D8%B9-%D8%AC%D8%A7%D9%85%D8%B9%D8%A9-%D8%A7%D9%84%D9%85%D9%84%D9%83-%D8%B3%D8%B9%D9%88%D8%AF-70",
        "title": "رسائل في الحديث وعلومه للتحميل - موقع جامعة الملك سعود",
        "description": "مجموعة رسائل وأبحاث علمية، مقدمة من موقع جامعة الملك سعود، لإفادة الباحثين والمختصين في كافة التخصصات والمجالات، وخصوصًا في الحديث النبوي الشريف.",
        "image": "https://www.guidetosunnah.com/storage/posts/ksu-logo-colored-pngp-24307-showwebsitethumb711_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "رسائل علمية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/ksu-logo-colored-pngp-24307-showwebsitethumb711_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://fac.ksu.edu.sa/alturki/blog/87927",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B1%D8%B3%D8%A7%D8%A6%D9%84-%D9%81%D9%8A-%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB-%D9%84%D9%84%D8%AA%D8%AD%D9%85%D9%8A%D9%84-pdf-%D9%85%D9%88%D9%82%D8%B9-%D9%85%D9%83%D8%AA%D8%A8%D8%A9-%D9%85%D8%A8%D8%AA%D8%B9%D8%AB-71",
        "title": "رسائل في الحديث للتحميل pdf - موقع مكتبة مبتعث",
        "description": "رسائل علمية في مختلف المجالات مقدمة من موقع مبتعث للدراسات والاستشارات الأكاديمية مقدمة للباحثين والأكاديميين لمساعدتهم في ما يبحثون",
        "image": "https://www.guidetosunnah.com/storage/posts/lqw4wky9306_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "رسائل علمية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/lqw4wky9306_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.mobt3ath.com/book.php?id=1&sup=%D8%B1%D8%B3%D8%A7%D8%A6%D9%84_%D9%85%D8%A7%D8%AC%D8%B3%D8%AA%D9%8A%D8%B1_%D9%88%D8%AF%D9%83%D8%AA%D9%88%D8%B1%D8%A7_PDF&page=89&title=%D8%B1%D8%B3%",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%85%D8%AC%D9%85%D9%88%D8%B9%D8%A9-%D8%B1%D8%B3%D8%A7%D8%A6%D9%84-%D9%81%D9%8A-%D8%B9%D9%84%D9%88%D9%85-%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB-%D9%85%D9%88%D9%82%D8%B9-%D8%A7%D9%84%D9%85%D9%83%D8%AA%D8%A8%D8%A9-%D8%A7%D9%84%D9%88%D9%82%D9%81%D9%8A%D8%A9-73",
        "title": "مجموعة رسائل في علوم الحديث - موقع المكتبة الوقفية",
        "description": "لإفادة طلاب العلم، قاعدة بيانات في جميع التخصصات والعلوم، مقدَّمة من المكتبة الوقفية.",
        "image": "https://www.guidetosunnah.com/storage/posts/untitled-design704_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "رسائل علمية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/untitled-design704_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://waqfeya.com/book.php?bid=1702",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B1%D8%B3%D8%A7%D8%A6%D9%84-%D8%AD%D8%AF%D9%8A%D8%AB%D9%8A%D8%A9-%D9%85%D9%86-%D9%85%D9%88%D9%82%D8%B9-%D8%B1%D9%8A%D8%A7%D8%B6-%D8%A7%D9%84%D8%B9%D9%84%D9%85-74",
        "title": "رسائل حديثية من موقع رياض العلم",
        "description": "مشروع يتطلع للمساهمة في خدمة المتصفح المسلم وطلبة العلم الشرعي عبر الشبكة العنكبوتية ويسعى لذلك بمواكبة التقدم التكنلوجي الكبير وتسخيره لخدمة المسلمين.",
        "image": "https://www.guidetosunnah.com/storage/posts/7410305_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "رسائل علمية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/7410305_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.riyadhalelm.com/catsmktba-267.html",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B1%D8%B3%D8%A7%D8%A6%D9%84-%D8%B9%D9%84%D9%85%D9%8A%D8%A9-%D9%85%D9%88%D9%82%D8%B9-%D8%AF%D8%A7%D8%B1-%D8%A7%D9%84%D9%85%D9%86%D8%B8%D9%88%D9%85%D8%A9-75",
        "title": "رسائل علمية - موقع دار المنظومة",
        "description": "مرجع أساسي للباحث العربي في جميع العلوم والتخصصات الأكاديمية، وتعد من قواعد البيانات الضخمة الأضخم حيث يصل العدد من رسائل الماجستير والدكتوراه إلى أكثر من (150.000) رسالة علمية من مختلف الجامعات العربية وغير العربية.",
        "image": "https://www.guidetosunnah.com/storage/posts/dar-almnthom304_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "رسائل علمية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/dar-almnthom304_showWebsiteThumb.png",
        "primaryAction": {
          "url": "http://www.mandumah.com/Dissertation",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B1%D8%B3%D8%A7%D8%A6%D9%84-%D8%B9%D9%84%D9%85%D9%8A%D8%A9-%D9%85%D9%88%D9%82%D8%B9-%D9%86%D8%AF%D8%A7%D8%A1-%D8%A7%D9%84%D8%A5%D9%8A%D9%85%D8%A7%D9%86-76",
        "title": "رسائل علمية - موقع نداء الإيمان",
        "description": "رسائل علمية في كافة التخصصات، وفي علوم السنة النبوية الشريفة، مع إمكانية البحث عن الرسالة المطلوبة، وإمكانية تنزيلها وحفظها إلى الجهاز.",
        "image": "https://www.guidetosunnah.com/storage/posts/1280x960303_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "رسائل علمية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/1280x960303_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "http://www.al-eman.com/%D8%A7%D9%84%D8%B1%D8%B3%D8%A7%D8%A6%D9%84+%D8%A7%D9%84%D8%B9%D9%84%D9%85%D9%8A%D8%A9/p41?d-3374106-p=1",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%83%D8%AA%D8%A8-%D8%B9%D9%84%D9%88%D9%85-%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB-%D8%A7%D9%84%D8%B4%D8%B1%D9%8A%D9%81-%D9%85%D9%83%D8%AA%D8%A8%D8%A9-%D9%86%D9%88%D8%B1-166",
        "title": "كتب علوم الحديث الشريف - مكتبة نور",
        "description": "مجموعة من الكتب في علم الحديث من موقع مكتبة نور",
        "image": "https://www.guidetosunnah.com/storage/posts/noor649_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب وبحوث",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/noor649_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.noor-book.com/tag/%D8%B9%D9%84%D9%88%D9%85-%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB-%D8%A7%D9%84%D8%B4%D8%B1%D9%8A%D9%81",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%85%D8%AC%D9%85%D9%88%D8%B9%D8%A9-%D8%A3%D8%A8%D8%AD%D8%A7%D8%AB-%D9%88%D8%B1%D8%B3%D8%A7%D8%A6%D9%84-%D8%AD%D8%AF%D9%8A%D8%AB%D9%8A%D8%A9-174",
        "title": "مجموعة أبحاث ورسائل حديثية",
        "description": "مجموعة أبحاث ورسائل حديثية من مدونة محمد بن تركي التركي أستاذ الحديث وعلومه في جامعة الملك سعود",
        "image": "https://www.guidetosunnah.com/storage/posts/untitled-design660_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "رسائل علمية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/untitled-design660_showWebsiteThumb.png",
        "primaryAction": {
          "url": "http://m-alturki.blogspot.com/2017/01/35.html",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%83%D8%AA%D8%A8-%D9%88%D8%A3%D8%A8%D8%AD%D8%A7%D8%AB-%D9%81%D9%8A-%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB-%D8%A7%D9%84%D8%B4%D8%B1%D9%8A%D9%81-%D9%88%D8%B9%D9%84%D9%88%D9%85%D9%87-176",
        "title": "كتب وأبحاث في الحديث الشريف وعلومه",
        "description": "مجموعة كتب وأبحاث في الحديث الشريف وعلومه من موقع الحلول البحثية",
        "image": "https://www.guidetosunnah.com/storage/posts/untitled-design710_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب وبحوث",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/untitled-design710_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://research-solution.com/book.php?id=2&sup=%D8%A7%D9%84%D9%83%D8%AA%D8%A8_%D8%A7%D9%84%D8%A7%D9%84%D9%83%D8%AA%D8%B1%D9%88%D9%86%D9%8A%D8%A9_-_%D9%83%D8%AA%D8%A8.PDF&page=96&title=%D8%A7",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%AF%D9%88%D8%B1%D8%A9-%D8%AA%D8%A3%D8%B5%D9%8A%D9%84%D9%8A%D8%A9-%D9%81%D9%8A-%D8%B9%D9%84%D9%85-%D8%AA%D8%AE%D8%B1%D9%8A%D8%AC-%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB-%D8%A7%D9%84%D8%B4%D8%B1%D9%8A%D9%81-185",
        "title": "دورة تأصيلية في علم تخريج الحديث الشريف.",
        "description": "ملف بي دي اف يحتوي على مجموعة روابط فيديوهات تعليمية ضمن دورة تأصيلية في علم تخريج الحديث الشريف، تقيمها الجامعة الإسلامية في المدينة المنورة.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2023-03-20-212305750_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب وبحوث",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2023-03-20-212305750_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://drive.google.com/file/d/1_uLS-DeGWVNaIw8syUwwHolWogp4qSy3/view",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%85%D9%86-%D8%A7%D9%84%D8%AF%D8%B1%D9%88%D8%B3-%D8%A7%D9%84%D8%B9%D9%84%D9%85%D9%8A%D8%A9-%D9%88%D8%A7%D9%84%D9%85%D9%86%D9%87%D8%AC%D9%8A%D8%A9-%D8%A8%D9%83%D9%84%D9%8A%D8%A9-%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB-186",
        "title": "من الدروس العلمية والمنهجية بكلية الحديث",
        "description": "ملف بي دي اف يحتوي على روابط لاثنان وأربعون درسًا من دروس علوم الحديث الشريف، بكافة فروعه وأقسامه، مقدمة من كلية الحديث الشريف بالجامعة الإسلامية في المدينة المنورة.",
        "image": "https://www.guidetosunnah.com/storage/posts/275806774-294506246148321-6100988001484542241-n751_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "category": "كتب وبحوث",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/275806774-294506246148321-6100988001484542241-n751_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://drive.google.com/file/d/1FfiyXla7257T5e2VH_TPkHY-gXcujFG5/view?usp=share_link",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A3%D8%B3%D9%85%D8%A7%D8%A1-%D8%A7%D9%84%D9%84%D9%87-%D8%A7%D9%84%D9%88%D8%A7%D8%B1%D8%AF%D8%A9-%D9%81%D9%8A-%D8%A7%D9%84%D8%B3%D9%86%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D8%A8%D9%84%D8%BA%D8%A9-%D8%A7%D9%84%D8%A5%D8%B4%D8%A7%D8%B1%D8%A9-187",
        "title": "أسماء الله الواردة في السنة النبوية - بلغة الإشارة",
        "description": "التعريف بأسماء الله الواردة في كتب السنة النبوية، وفضلها، والمراد منها؛ والتي يحتاج الإلمام بها كل مسلم موحد بالله، كل ذلك في أسلوب سلس طيب يؤدي الغرض من الرسالة.",
        "image": "https://www.guidetosunnah.com/storage/posts/cover-1798_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب وبحوث",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/cover-1798_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.alukah.net/library/0/53987/%D8%A3%D8%B3%D9%85%D8%A7%D8%A1-%D8%A7%D9%84%D9%84%D9%87-%D8%A7%D9%84%D9%88%D8%A7%D8%B1%D8%AF%D8%A9-%D9%81%D9%8A-%D8%A7%D9%84%D8%B3%D9%86%D8%A9-%D8%A7%D9",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/post-51811781624529",
        "title": "مكتبة أهل الحديث",
        "description": "مكتبة رقمية على منصة تيليجرام تُعنى بجمع وأرشفة التراث الحديثي وكل ما يتعلق بالسنة النبوية وعلومها، تحتوي المكتبة على كتب الأحاديث المشروحة، الرسائل العلمية، الأبحاث الأكاديمية، ومخرجات المؤتمرات الحديثية المتخصصة، بالإضافة إلى علوم الرجال، الجرح والتعديل، ومصطلح الحديث.",
        "image": "https://www.guidetosunnah.com/storage/posts/5k8xnKIQf1fawu2O803fSeMscPEDTGXXdw6hR3AJ_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "كتب وبحوث",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/5k8xnKIQf1fawu2O803fSeMscPEDTGXXdw6hR3AJ.jpg",
        "primaryAction": {
          "url": "https://t.me/Al_Hadeeth",
          "label": "مشاهدة"
        }
      }
    ]
  },
  "center": {
    "root": "https://www.guidetosunnah.com/ar/centers",
    "pages": 3,
    "categories": [
      {
        "url": "https://www.guidetosunnah.com/ar/centers/mjals-smaa-alsnt",
        "label": "مجالس سماع السنة"
      },
      {
        "url": "https://www.guidetosunnah.com/ar/centers/hyat-wmrakz-lnshr-alsnt",
        "label": "هيئات ومراكز لنشر السنة"
      }
    ],
    "items": [
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/centers/show/item-mgals-smaaa-alhdyth-balgamaa-alazhr-msr",
        "title": "مجالس سماع الحديث بالجامع الأزهر – مصر",
        "description": "دروس ومجالس سماع الحديث بالجامع الأزهر - الدكتور/ أحمد معبد عبد الكريم.",
        "image": "https://www.guidetosunnah.com/storage/posts/16196018-687117361448861-8348950144281741297-n93_centerThumb.jpg",
        "country": "مصر",
        "date": "",
        "category": "مجالس سماع السنة"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/centers/show/item-mgals-smaaa-alhdyth-balryas-alaaam-lshoon-almsgd-alhram-oalmsgd-alnboy",
        "title": "مجالس سماع الحديث بالرئاسة العامة لشؤون المسجد الحرام والمسجد النبوي",
        "description": "حلقات تعلمية افتراضية عن طريق الإنترنت، يسمع فيها الطلاب المتون العملية في غرف صوتية خلال ساعات دراسية معينة.تهدف إلى إخراج جيل مسلم حافظ للمتون...",
        "image": "https://www.guidetosunnah.com/storage/posts/902392-372346463_centerThumb.jpg",
        "country": "السعودية",
        "date": "",
        "category": "مجالس سماع السنة"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/centers/show/item-almgals-alalfy-fy-kraaa-osmaaa-alsn-alnboy",
        "title": "المجالس الألفية في قراءة وسماع السنة النبوية",
        "description": "مجالس لسماع وقراءة كتب السنة النبوية في مسجد البخاري، في مدينة الإسكندرية، في مصر.",
        "image": "https://www.guidetosunnah.com/storage/posts/wp4430539421_centerThumb.jpg",
        "country": "مصر",
        "date": "",
        "category": "مجالس سماع السنة"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/centers/show/item-mgals-smaaa-msnd-alshafaay-d-aabd-allh-alaabyd",
        "title": "مجالس سماع مسند الشافعي – د/ عبد الله العبيد",
        "description": "مجالس سماع لمسند الإمام الشافعي أحمد في المملكة العربية السعودية، مع تعليق من فضيلة الدكتور عبد الله العبيد.",
        "image": "https://www.guidetosunnah.com/storage/posts/kimrcaaj96_centerThumb.jpg",
        "country": "السعودية",
        "date": ""
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/centers/show/item-mgals-smaaa-mota-malk-gmaay-aldaao-llkran-oalsn-alshykh-mhmd-zghyr",
        "title": "مجالس سماع موطأ مالك - جمعية الدعوة للقرآن والسنة – الشيخ محمد زغير",
        "description": "من جمعية الدعوة للقرآن والسنة مجالس سماع موطَّأ الإمام مالك للشيخ محمد زغير.",
        "image": "https://www.guidetosunnah.com/storage/posts/shutterstock-535938397369_centerThumb.jpg",
        "country": "السعودية",
        "date": "",
        "category": "مجالس سماع السنة"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/centers/show/item-mgals-smaaa-alsn-tnthmha-ozar-alshoon-alaslamy-oalaokaf-oaldaao-oalarshad-alkoyt",
        "title": "مجالس سماع السنة تنظمها وزارة الشؤون الإسلامية والأوقاف والدعوة والإرشاد – الكويت",
        "description": "مجالس سماع السنة من تنظيم وزارة الشؤون الإسلامية والأوقاف في دولة الكويت.",
        "image": "https://www.guidetosunnah.com/storage/posts/maxresdefault-9433_centerThumb.jpg",
        "country": "الكويت",
        "date": "",
        "category": "مجالس سماع السنة"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/centers/show/item-mgals-smaaa-shyh-mslm-d-mhmd-hsham-tahry",
        "title": "مجالس سماع صحيح مسلم – د/ محمد هشام طاهري",
        "description": "مجلس سماع صحيح مسلم لفضيلة الشيخ الدكتور محمد هشام طاهري.",
        "image": "https://www.guidetosunnah.com/storage/posts/maxresdefault186_centerThumb.jpg",
        "country": "السعودية",
        "date": "",
        "category": "مجالس سماع السنة"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/centers/show/item-mgals-alsmaaa-lsnn-alnsayy-bkna-oah-alsn-alnboy-lnshr-alaalom-alshraay",
        "title": "مجالس السماع لسنن النسائي بقناة واحة السنة النبوية لنشر العلوم الشرعية",
        "description": "مجالس السماع لسنن النسائي، في قناة واحة السنة النبوية لنشر العلوم الشرعية.",
        "image": "https://www.guidetosunnah.com/storage/posts/avatars-000496315575-afmjte-t500x500100_centerThumb.jpg",
        "country": "السعودية",
        "date": "",
        "category": "مجالس سماع السنة"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/centers/show/item-aladar-alaaam-lkhdm-alktab-oalsn",
        "title": "الإدارة العامة لخدمة الكتاب والسنة",
        "description": "الإدارة العامة لخدمة الكتاب والسنة في رابطة العالم الإسلامي، تقدم مقالات ودروس ونشاطات في خدمة الكتاب والسنة.",
        "image": "https://www.guidetosunnah.com/storage/posts/cd582463-22e7-4592-974e-3ac80abb09d2464_centerThumb.jpeg",
        "country": "السعودية",
        "date": "",
        "category": "هيئات ومراكز لنشر السنة"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/centers/show/item-moss-alshark-llkran-alkrym-oalsn-alnboy",
        "title": "مؤسسة الشارقة للقرآن الكريم والسنة النبوية",
        "description": "مؤسسة إسلامية حكومية أسسها صاحب السمو الشيخ الدكتور / سلطان بن محمد القاسمي حاكم الشارقة سنة 1422هـ الموافق 2001م . مقرها ومركزها الرئ...",
        "image": "https://www.guidetosunnah.com/storage/posts/unnamed465_centerThumb.png",
        "country": "الإمارات العربية المتحدة",
        "date": "",
        "category": "هيئات ومراكز لنشر السنة"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/centers/show/item-alhyy-alaaalmy-llsn-alnboy-almgls-alaslamy-alaaalmy-lldaao-oalaghath",
        "title": "الهيئة العالمية للسنة النبوية – المجلس الإسلامي العالمي للدعوة والإغاثة",
        "description": "هيئة إسلامية عالمية تقوم بالتنسيق بين أنشطة الهيئات والمنظمات الإسلامية الشعبية والرسمية في العالم. ويرأسه فضيلة الإمام الأكبر أ.د، أحمد ال...",
        "image": "https://www.guidetosunnah.com/storage/posts/rylkweiw104_centerThumb.jpg",
        "country": "النمسا",
        "date": "",
        "category": "هيئات ومراكز لنشر السنة"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/centers/show/item-lgn-bhoth-alsn-oalsyr-alnboy-bmgmaa-albhoth-alaslamy",
        "title": "لجنة بحوث السنة والسيرة النبوية بمجمع البحوث الإسلامية",
        "description": "لجنة بحوث السنة والسيرة النبوية في مجمع البحوث الإسلامية في الأزهر الشريف في مصر.",
        "image": "https://www.guidetosunnah.com/storage/posts/al-azhar-1105_centerThumb.png",
        "country": "مصر",
        "date": "",
        "category": "هيئات ومراكز لنشر السنة"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/centers/show/item-gmaay-alhdyth-alshryf-oahyaaa-altrath",
        "title": "جمعية الحديث الشريف وإحياء التراث",
        "description": "جمعية علمية متخصصة، أنشئت لخدمة الحديث النبوي وعلومه ونشر السنة المطهرة وتحقيق كتب التراث.",
        "image": "https://www.guidetosunnah.com/storage/posts/unnamed-1466_centerThumb.jpg",
        "country": "عمان",
        "date": "",
        "category": "هيئات ومراكز لنشر السنة",
        "coordinates": {
          "latitude": 23.614328,
          "longitude": 58.545284
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/centers/show/item-moss-dar-alhdyth-alhsny",
        "title": "مؤسسة دار الحديث الحسنية",
        "description": "تأسست في المغرب وهدفها تكوين علماء راسخي القدم في الحديث النبوي الشريف وفي العلوم الشرعية عموما. وذلك استباقا للفراغ العلمي الذي يحدثه رحيل كبار...",
        "image": "https://www.guidetosunnah.com/storage/posts/unnamed-2467_centerThumb.jpg",
        "country": "المغرب",
        "date": "",
        "category": "هيئات ومراكز لنشر السنة",
        "coordinates": {
          "latitude": 33.9715904,
          "longitude": -6.8498129
        },
        "email": "edhh.sic.web@gmail.com"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/centers/show/item-mrkz-abn-alktan-lldrasat-oalabhath-fy-alhdyth-alshryf-oalsyr-alaatr",
        "title": "مركز ابن القطان للدراسات والأبحاث في الحديث الشريف والسيرة العطرة",
        "description": "مركز تابع للرابطة المحمدية للعلماء تم تأسيسه بمدينة العرائش، قصد الإسهام في المحافظة على الثوابت الدينية، وتدعيم الأمن الروحي للأمة، من خلال إبرا...",
        "image": "https://www.guidetosunnah.com/storage/posts/logo-arrabita-1109_centerThumb.png",
        "country": "المغرب",
        "date": "",
        "category": "هيئات ومراكز لنشر السنة",
        "coordinates": {
          "latitude": 35.174427,
          "longitude": -6.147396
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/centers/show/item-mydytk-grob",
        "title": "ميديتك جروب",
        "description": "ميديتِك جروب شركة عالميه متخصصة في صناعة الأجهزة الطبية للعديد من المجالات كالعناية المركزة و الطوارئ و غرف العمليات و المنزلية و غيرهم و الحاصلة على...",
        "image": "https://www.guidetosunnah.com/storage/posts/pp475_centerThumb.jpg",
        "country": "الهند",
        "date": "",
        "coordinates": {
          "latitude": 30,
          "longitude": 22
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/centers/show/item-dar-alaalom-dyobnd",
        "title": "دار العلوم - ديوبند",
        "description": "من أكبر الجامعات الإسلامية في الهند، بدأت كمدرسة صغيرة تختص بتدريس العلوم الإسلامية واللغة العربية، قام على إنشائها محمد قاسم النانونوتي، وتهتم بتعليم...",
        "image": "https://www.guidetosunnah.com/storage/posts/darul-uloom-logo2-1024x354483_centerThumb.jpg",
        "country": "الهند",
        "date": "",
        "category": "هيئات ومراكز لنشر السنة",
        "coordinates": {
          "latitude": 29.691021,
          "longitude": 77.682244
        },
        "email": "info@darululoom-deoband.com"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/centers/show/item-ndo-alaalmaaa-lknao",
        "title": "ندوة العلماء - لكناو",
        "description": "مؤسسة إسلامية تهتم بتدريس الحديث الشريف خاصة، أسست في لكناو في الهند عام 1311هـ، تهتم بتحقيق المخطوطات.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2022-12-04-210652484_centerThumb.png",
        "country": "الهند",
        "date": "",
        "category": "هيئات ومراكز لنشر السنة",
        "coordinates": {
          "latitude": 26.846694,
          "longitude": 80.946166
        },
        "email": "nizamat@nadwa.in"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/centers/show/item-dar-alhdyth-alnory",
        "title": "دار الحديث النورية",
        "description": "من أقدم المراكز الدينية في العالم الإسلامي، أنشأها نور الدين الزنكي، وتولى مشيختها عدد من العلماء منهم: علاء الدين بن العطار تلميذ الإمام النووي، وابن...",
        "image": "https://www.guidetosunnah.com/storage/posts/305036634-553966346527799-2597601481155243404-n485_centerThumb.jpg",
        "country": "سوريا",
        "date": "",
        "category": "هيئات ومراكز لنشر السنة"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/centers/show/item-mrkz-aalom-alhdyth-alnboy-alshryf",
        "title": "مركز علوم الحديث النبوي الشريف",
        "description": "مؤسسة تعليمية تعنى بتدريس الحديث الشريف وعلومه، في لبنان، ويقوم عليها أساتذة وعلماء مختصون.",
        "image": "https://www.guidetosunnah.com/storage/posts/309608187-155149570500454-3090847093249947382-n486_centerThumb.jpg",
        "country": "لبنان",
        "date": "",
        "category": "هيئات ومراكز لنشر السنة",
        "email": "alhadithsciences@gmail.com"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/centers/show/item-mns-taaa",
        "title": "منصة تاء",
        "description": "منصة تعلّم العلوم الشرعية بشكل تفاعلي، ودروس شاملة لتعلم الصلاة وأحكام الإسلام واختبارات لكافة العلوم الشرعية. لزيارة المنصة اضغط هنا.",
        "image": "https://www.guidetosunnah.com/storage/posts/ta583_centerThumb.png",
        "country": "السعودية",
        "date": "",
        "category": "هيئات ومراكز لنشر السنة"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/centers/show/item-mgals-smaaa-snn-altrmthy-d-mhmd-hsham-tahry",
        "title": "مجالس سماع سنن الترمذي – د/ محمد هشام طاهري",
        "description": "مجلس سماع سنن الترمذي لفضيلة الشيخ الدكتور محمد هشام طاهري.",
        "image": "https://www.guidetosunnah.com/storage/posts/maxresdefault186-centerthumb736_centerThumb.jpg",
        "country": "السعودية",
        "date": "",
        "category": "مجالس سماع السنة",
        "coordinates": {
          "latitude": 21.42251,
          "longitude": 39.826168
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/centers/show/item-almrkz-alsaaody-lltlaoat-alkrany-oalahadyth-alnboy",
        "title": "المركز السعودي للتلاوات القرآنية والأحاديث النبوية",
        "description": "مركز رسمي تابع لهيئة الإذاعة والتلفزيون، متخصص في تسجيل المصاحف القرآنية الصوتية والأحاديث النبوية.",
        "image": "https://www.guidetosunnah.com/storage/posts/xljtnntq-400x400754_centerThumb.jpg",
        "country": "السعودية",
        "date": "",
        "category": "مجالس سماع السنة"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/centers/show/item-gmaay-hda-alkhyry-ltaalym-alaalom-alshraay",
        "title": "جمعية هداة الخيرية لتعليم العلوم الشرعية",
        "description": "جمعية أهلية مرخصة متخصصة في التعليم الإلكتروني الشرعي عبر البث الفضائي والنظام التعليمي الخاص بالجمعية.",
        "image": "https://www.guidetosunnah.com/storage/posts/310985899-6247135648646919-8129018519091541696-n796-centerthumb801_centerThumb.jpg",
        "country": "السعودية",
        "date": "",
        "category": "هيئات ومراكز لنشر السنة",
        "coordinates": {
          "latitude": 24.7913361,
          "longitude": 46.6255497
        },
        "email": "info@hdat.sa"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/centers/show/item-mns-hfath-altaalymy",
        "title": "منصة حفاظ التعليمية",
        "description": "جهة تعليمية غير ربحية، متخصصة بتعليم الحديث النبوي، حفظاً وتفهماً، وتحمل على عاتقها نشره، مواكبة في ذلك التقنية الحديثة.",
        "image": "https://www.guidetosunnah.com/storage/posts/347833827-1323058111956068-3336656884807265514-n800_centerThumb.jpg",
        "country": "السعودية",
        "date": "",
        "category": "هيئات ومراكز لنشر السنة",
        "email": "hoffadh@gmail.com"
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/centers/show/item-hlkat-alkran-oalmton-alaalmy-fy-almsgd-alnboy",
        "title": "حلقات القرآن والمتون العلمية في المسجد النبوي",
        "description": "حلقات تعلمية افتراضية عن طريق الإنترنت، يسمع فيها الطلاب المتون العملية في غرف صوتية خلال ساعات دراسية معينة",
        "image": "https://www.guidetosunnah.com/storage/posts/ln-97-1821_centerThumb.jpg",
        "country": "السعودية",
        "date": "",
        "category": "مجالس سماع السنة",
        "coordinates": {
          "latitude": 24.468333,
          "longitude": 39.610833
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/centers/show/post-64411781102245",
        "title": "أكاديمية البرهان",
        "description": "منصة تعليمية رقمية \"للتعليم عن بُعد\" تابعة لجمعية البرهان في المملكة العربية السعودية (الرياض)، وتُعنى بتقديم برامج أكاديمية متخصصة لتعليم علوم القرآن...",
        "image": "https://www.guidetosunnah.com/storage/posts/5s1I7koSObcMYANx1rDN2JYWhbgCTxyajHvvB4Hr_centerThumb.jpg",
        "country": "السعودية",
        "date": "",
        "category": "هيئات ومراكز لنشر السنة",
        "coordinates": {
          "latitude": 24.7135517,
          "longitude": 46.6752957
        },
        "email": "info@alborhanacademy.com"
      }
    ]
  },
  "children": {
    "root": "https://www.guidetosunnah.com/ar/services/main-categories-khdmat-alsnt-llatfal",
    "pages": 2,
    "categories": [
      {
        "url": "https://www.guidetosunnah.com/ar/services/khdmat-alsnt-llatfal/main-categories-khdmat-alsnt-llatfal-aflam-krtwn",
        "label": "أفلام كرتون"
      },
      {
        "url": "https://www.guidetosunnah.com/ar/services/khdmat-alsnt-llatfal/main-categories-khdmat-alsnt-llatfal-akhlaq-nbwyt",
        "label": "أخلاق نبوية"
      },
      {
        "url": "https://www.guidetosunnah.com/ar/services/khdmat-alsnt-llatfal/main-categories-khdmat-alsnt-llatfal-alsyrt-alnbwyt",
        "label": "السيرة النبوية"
      }
    ],
    "items": [
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%B3%D9%84%D8%B3%D9%84%D8%A9-%D8%AA%D8%B9%D9%84%D9%85-%D8%A7%D9%84%D8%B3%D9%86%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D9%84%D9%84%D8%A3%D8%B7%D9%81%D8%A7%D9%84-79",
        "title": "سلسلة تعلم السنة النبوية للأطفال",
        "description": "أحاديث نبوية للأطفال مقدمة بشكل قصص كرتونية من إنتاج دار ياقوتة باللغة عربية ومذيلة بالنص.",
        "image": "https://www.guidetosunnah.com/storage/posts/maxresdefault159_relatedServiceThumb.jpg",
        "country": "",
        "date": "14/3/2026",
        "category": "أفلام كرتون",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/maxresdefault159_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=QuxN1v1yrcw&list=PL13rkpGOKP5x8jd1UeaDCczIkhheInS5I",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A3%D8%AD%D8%A7%D8%AF%D9%8A%D8%AB-%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D9%84%D8%AA%D8%B9%D9%84%D9%8A%D9%85-%D8%A7%D9%84%D8%A3%D8%B7%D9%81%D8%A7%D9%84-80",
        "title": "أحاديث نبوية لتعليم الأطفال",
        "description": "سلسلة أحاديث نبوية لتعليم الأطفال مكتوبة ومقروءة، مقدَّمة من قناة الخير للأطفال في موقع يوتيوب",
        "image": "https://www.guidetosunnah.com/storage/posts/hqdefault160_relatedServiceThumb.jpg",
        "country": "",
        "date": "14/3/2026",
        "category": "أفلام كرتون",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/hqdefault160_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=mZLOLOt8xW8&list=PLE3e2NriMDYR5rCgbp196U8LXwyI7H0m2",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A3%D8%B7%D9%8A%D8%A8-%D8%A7%D9%84%D9%83%D9%84%D8%A7%D9%85-%D8%A3%D8%AD%D8%A7%D8%AF%D9%8A%D8%AB-%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D9%84%D9%84%D8%A3%D8%B7%D9%81%D8%A7%D9%84-81",
        "title": "أطيب الكلام أحاديث نبوية للأطفال",
        "description": "أطيب الكلام - برنامج مقدم من قناة سنا للأطفال، يقدم أحاديث نبوية للأطفال، ينمي فيهم حبهم للسيرة النبوية صلى الله عليه وسلم، ويقدم أحاديثه بطريقة رائعة ومشوقة.",
        "image": "https://www.guidetosunnah.com/storage/posts/maxresdefault-1161_relatedServiceThumb.jpg",
        "country": "",
        "date": "14/3/2026",
        "category": "أفلام كرتون",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/maxresdefault-1161_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=lpWTa6sH7bQ&list=PL2EDctC_BXyysuSS6CN47amRUdcZ0dW6T",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%8A%D9%88%D9%85%D9%8A%D8%A7%D8%AA-%D8%B3%D9%84%D9%85%D9%89-%D8%B1%D8%B3%D9%88%D9%85-%D9%85%D8%AA%D8%AD%D8%B1%D9%83%D8%A9-83",
        "title": "يوميات سلمى - رسوم متحركة",
        "description": "كرتون اسلامي تعليمي وهادف للأطفال بدون موسيقى",
        "image": "https://www.guidetosunnah.com/storage/posts/slm-oalsla-oa00-00-2220160918-223333-1163_relatedServiceThumb.jpg",
        "country": "",
        "date": "14/3/2026",
        "category": "أخلاق نبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/slm-oalsla-oa00-00-2220160918-223333-1163_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=3confo7t8e8&list=PL0XvsQvmdRm2zAxUxq_5o6hg8nXtfkOG4",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%82%D8%B5%D8%B5-%D9%83%D8%B1%D8%AA%D9%88%D9%86%D9%8A%D8%A9-%D9%84%D9%84%D8%A3%D8%B7%D9%81%D8%A7%D9%84-85",
        "title": "قصص كرتونية للأطفال",
        "description": "سلسلة حلقات كرتونية، عن الأخلاق الإسلامية، تزرع في الطفال القيم الإسلامية وتنمي فيه حب الخير ومساعدة الناس.",
        "image": "https://www.guidetosunnah.com/storage/posts/maxresdefault-2165_relatedServiceThumb.jpg",
        "country": "",
        "date": "14/3/2026",
        "category": "أخلاق نبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/maxresdefault-2165_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=kcKJgJbd7kI&list=PL6pC5aDZHHJOdxwuVtuESxI5dBdGjZUM7",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D9%84%D9%84%D8%A3%D8%B7%D9%81%D8%A7%D9%84-%D9%88%D8%A7%D9%84%D9%86%D8%A7%D8%B4%D8%A6%D8%A9-%D8%B4%D8%A8%D9%83%D8%A9-%D8%A7%D9%84%D8%A3%D9%84%D9%88%D9%83%D8%A9-86",
        "title": "السيرة النبوية للأطفال والناشئة - شبكة الألوكة",
        "description": "أحداث السيرة النبوية من ولادته حتى وفاته صلى الله عليه وسلم، يعرضها الأستاذ مسعد حسين محمد بطريقة سهلة ومشوقة.",
        "image": "https://www.guidetosunnah.com/storage/posts/unnamed-3122_relatedServiceThumb.jpg",
        "country": "",
        "date": "14/3/2026",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/unnamed-3122_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.alukah.net/library/0/126981/",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%83%D8%AA%D8%A7%D8%A8-%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D8%B1%D8%B3%D9%88%D9%84-%D9%84%D9%84%D8%A3%D8%B7%D9%81%D8%A7%D9%84-%D9%85%D8%AD%D9%85%D9%88%D8%AF-%D8%A7%D9%84%D9%85%D8%B5%D8%B1%D9%8A-88",
        "title": "كتاب سيرة الرسول للأطفال - محمود المصري",
        "description": "كتاب سيرة الرسول للأطفال للشيخ محمود المصري",
        "image": "https://www.guidetosunnah.com/storage/posts/435752018-12-241545665385167_relatedServiceThumb.jpg",
        "country": "",
        "date": "14/3/2026",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/435752018-12-241545665385167_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://foulabook.com/ar/book/%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D8%B1%D8%B3%D9%88%D9%84-%D9%84%D9%84%D8%A3%D8%B7%D9%81%D8%A7%D9%84-pdf",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D9%84%D9%84%D8%B5%D8%BA%D8%A7%D8%B1-%D9%88%D8%A7%D9%84%D9%8A%D8%A7%D9%81%D8%B9%D9%8A%D9%86-89",
        "title": "السيرة النبوية - للصغار واليافعين",
        "description": "سلسلة أحداث السيرة النبوية للصغار واليافعين عبارة عن ستة عشرَ كتابًا، من دار القلم، ملونة وجذابة.",
        "image": "https://www.guidetosunnah.com/storage/posts/130845168_relatedServiceThumb.jpeg",
        "country": "",
        "date": "14/3/2026",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/130845168_showWebsiteThumb.jpeg",
        "primaryAction": {
          "url": "https://www.jarir.com/arabic-books-130845.html",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D9%84%D9%84%D8%A3%D8%B7%D9%81%D8%A7%D9%84-2-%D8%B1%D8%B3%D9%88%D9%85-%D9%85%D8%AA%D8%AD%D8%B1%D9%83%D8%A9-93",
        "title": "السيرة النبوية للأطفال 2 – رسوم متحركة",
        "description": "سلسلة حلقات كرتونية للأطفال، تعرض أحداث السيرة النبوية بطريقة رائعة وسهلة.",
        "image": "https://www.guidetosunnah.com/storage/posts/hqdefault172_relatedServiceThumb.jpg",
        "country": "",
        "date": "14/3/2026",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/hqdefault172_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=DNbfYT467sA&list=PLgmigW0CdagPFwc9hBIeZzRxxsPa3XHCc",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D9%84%D9%84%D8%A3%D8%B7%D9%81%D8%A7%D9%84-%D8%B1%D8%B3%D9%88%D9%85-%D9%85%D8%AA%D8%AD%D8%B1%D9%83%D8%A9-94",
        "title": "السيرة النبوية للأطفال – رسوم متحركة",
        "description": "سلسلة حلقات كرتونية للأطفال، تعرض أحداث السيرة النبوية لهم، وتقرب فهمها، معروضة بطريقة رائعة وسهلة.",
        "image": "https://www.guidetosunnah.com/storage/posts/download173_relatedServiceThumb.jpg",
        "country": "",
        "date": "14/3/2026",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/download173_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=extTOR-vrls&list=PL2551E9B410D84FF3",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D9%84%D9%84%D8%A3%D8%B7%D9%81%D8%A7%D9%84-%D9%82%D9%86%D8%A7%D8%A9-%D9%82%D8%B3%D8%B7%D9%86%D8%B7%D9%8A%D9%86%D9%8A%D8%A9-%D8%A7%D9%84%D8%AF%D8%B9%D9%88%D9%8A%D8%A9-95",
        "title": "السيرة النبوية للأطفال - قناة قسطنطينية الدعوية",
        "description": "لتعليم طفلك سيرة النبي صلى الله عليه وسلم ، تقدم لك قناة قسطنطينية الدعوية السيرة النبوية للأطفال، بصوت طفولي، مع رسوم جميلة وجذابة.",
        "image": "https://www.guidetosunnah.com/storage/posts/maxresdefault174_relatedServiceThumb.jpg",
        "country": "",
        "date": "14/3/2026",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/maxresdefault174_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=FoJ-97lw5KU&list=PLxx2PpBF8JWpNENE3aXeGAiE9rWwQqQ4a&index=1",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A3%D9%87%D9%85-%D8%A3%D8%AD%D8%AF%D8%A7%D8%AB-%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D9%84%D9%84%D8%A3%D8%B7%D9%81%D8%A7%D9%84-96",
        "title": "أهم أحداث السيرة النبوية للأطفال",
        "description": "السيرة النبوية للشيخ أحمد بن قذلان المزروعي، موضحة بالنصوص، مقروءة من قبل صوتٍ طفولي رائع وجميل، مقدمة في قناة قناة القرآن والسنة يفهم سلف الأمة في اليوتيوب.",
        "image": "https://www.guidetosunnah.com/storage/posts/hqdefault-1175_relatedServiceThumb.jpg",
        "country": "",
        "date": "14/3/2026",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/hqdefault-1175_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=0QkjedcJ8BU&list=PLpX9hXawyBK6FfDbV5L4BtG17JuvtW29t",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D9%84%D9%84%D8%A3%D8%B7%D9%81%D8%A7%D9%84-%D8%AE%D8%B1%D8%A7%D8%A6%D8%B7-%D8%AA%D9%88%D8%B6%D9%8A%D8%AD%D9%8A%D8%A9-97",
        "title": "السيرة النبوية للأطفال - خرائط توضيحية",
        "description": "السيرة النبوية للأطفال، مدعومة بخرائط توضيحية، مع تعليق صوتي واضح، مقدمة من قناة حدائق الرحمن في موقع يوتيوب.",
        "image": "https://www.guidetosunnah.com/storage/posts/cat-269323_relatedServiceThumb.png",
        "country": "",
        "date": "14/3/2026",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/cat-269323_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=KQ9OUfXx4OM&list=PL921qE6zItpycXcJ0MWBkhbfjEGWN_Yfi",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A8%D8%B3%D8%AA%D8%A7%D9%86-%D8%A7%D9%84%D8%A3%D8%AD%D8%A7%D8%AF%D9%8A%D8%AB-114",
        "title": "بستان الأحاديث",
        "description": "مجموعة من الأحاديث الميسرة للطفل بأسلوب تفاعلي يسهل حفظها من تطبيق بستان الأحاديث من تنفيذ شركة تطبيقات الطفولة.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2022-12-04-202134482_relatedServiceThumb.png",
        "country": "",
        "date": "14/3/2026",
        "category": "أفلام كرتون",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2022-12-04-202134482_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://youtu.be/VoZAripJUAU",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D9%84%D9%84%D8%A3%D8%B7%D9%81%D8%A7%D9%84-%D8%A3%D9%86%D8%B4%D8%B7%D8%A9-%D9%85%D8%AA%D9%86%D9%88%D8%B9%D8%A9-169",
        "title": "السيرة النبوية للأطفال + أنشطة متنوعة",
        "description": "كتيب متكامل يشتمل على أهم محطات السيرة النبوية للأطفال فيعرضها عرضاً مبسطاً مصحوباً بأنشطة متنوعة ممتعة للتحميل من موقع رياض الجنة.",
        "image": "https://www.guidetosunnah.com/storage/posts/ryad654_relatedServiceThumb.png",
        "country": "",
        "date": "14/3/2026",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/ryad654_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://riadaljanna.com/%D8%A7%D9%84%D8%B3%D9%8A%D8%B1%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D9%84%D9%84%D8%A3%D8%B7%D9%81%D8%A7%D9%84/",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%85%D8%B3%D8%A7%D8%A8%D9%82%D8%A9-%D8%A7%D8%B9%D8%B1%D9%81-%D9%86%D8%A8%D9%8A%D9%83-171",
        "title": "مسابقة اعرف نبيك",
        "description": "برنامج أنا مسلم برنامج يهتم ببناء العقيدة والتوحيد والمفاهيم الأساسية للدين الإسلامي للأطفال والكبار ويهتم باأخلاق الإسلامية.",
        "image": "https://www.guidetosunnah.com/storage/posts/bsm656_relatedServiceThumb.png",
        "country": "",
        "date": "14/3/2026",
        "category": "السيرة النبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/bsm656_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=deC6Jor1VFQ&list=PLeSYFIf0ZyIMMnT4NsKdnAa1RBVjBIIoi",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%85%D9%86%D8%B8%D9%88%D9%85%D8%A9-%D8%A3%D8%AD%D8%B3%D9%86-%D8%A7%D9%84%D8%A3%D8%AE%D9%84%D8%A7%D9%82-172",
        "title": "منظومة أحسن الأخلاق",
        "description": "سلسلة منظومه أحسن الأخلاق لتعليم الأطفال الأخلاق النبوية",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2023-01-30-164754715_relatedServiceThumb.jpg",
        "country": "",
        "date": "14/3/2026",
        "category": "أخلاق نبوية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2023-01-30-164754715_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.youtube.com/watch?v=khzcoYx4UBY&list=PLBvKbKoWD7RUb9MQ-xAS4QwtUyxQdwKw1&index=1",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%85%D8%B3%D8%A7%D8%A8%D9%82%D8%A9-%D8%A7%D9%84%D8%AA%D8%AF%D8%B1%D9%8A%D8%A8%D8%A7%D8%AA-%D8%A7%D9%84%D8%B9%D9%82%D9%84%D9%8A%D8%A9-%D9%84%D8%AD%D9%81%D8%B8-%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A-%D8%A7%D9%84%D8%AF%D9%88%D9%84%D9%8A-180",
        "title": "مسابقة التدريبات العقلية لحفظ الحديث النبوي الدولي",
        "description": "أهداف المسابقة :",
        "image": "https://www.guidetosunnah.com/storage/posts/shaaar-altdrybat-alaakly-odor-anaaash-alaakl745_relatedServiceThumb.png",
        "country": "",
        "date": "14/3/2026",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/shaaar-altdrybat-alaakly-odor-anaaash-alaakl745_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://aqlyat.net/%D9%86%D8%B8%D8%A7%D9%85-%D9%85%D8%B3%D8%A7%D8%A8%D9%82%D8%A9-%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A/",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%85%D8%B3%D8%A7%D8%A8%D9%82%D8%A7%D8%AA-%D8%AC%D8%A7%D9%85%D8%B9%D8%A9-%D8%A7%D9%84%D8%A5%D9%85%D8%A7%D9%85-%D9%85%D8%AD%D9%85%D8%AF-%D8%A8%D9%86-%D8%B3%D8%B9%D9%88%D8%AF-%D9%84%D8%AD%D9%81%D8%B8-%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB-%D8%A7%D9%84%D8%B4%D8%B1%D9%8A%D9%81-182",
        "title": "مسابقات جامعة الإمام محمد بن سعود لحفظ الحديث الشريف",
        "description": "تقوم جامعة الإمام محمد بن سعود الإسلامية بإطلاق مسابقات متنوعة لحفظ الحديث الشريف والسنة النبوية والإعلان عنها وعن نتائجها من خلال موقعها الرسمي.",
        "image": "https://www.guidetosunnah.com/storage/posts/9i9cn6mr-400x400747_relatedServiceThumb.jpg",
        "country": "",
        "date": "14/3/2026",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/9i9cn6mr-400x400747_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://units.imamu.edu.sa/deanships/sa/news/Pages/1439-7-26.aspx",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%85%D8%B3%D8%A7%D8%A8%D9%82%D8%A9-%D8%A7%D9%84%D9%85%D8%AD%D8%AF%D8%AB-%D8%A7%D9%84%D8%B5%D8%BA%D9%8A%D8%B1-%D9%81%D9%8A-%D9%82%D8%B7%D8%B1-184",
        "title": "مسابقة المحدث الصغير في قطر",
        "description": "تنفذ المسابقة على مستوى جميع مدارس دولة قطر للبنين والبنات بهدف نشر حديث النبي ـ صلى الله عليه وسلم ـ والحث على اتباع سنته والاقتداء بهديه",
        "image": "https://www.guidetosunnah.com/storage/posts/326568260-5829996687090807-7479942823029558251-n749_relatedServiceThumb.png",
        "country": "",
        "date": "14/3/2026",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/326568260-5829996687090807-7479942823029558251-n749_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://ibit.ly/mXXL",
          "label": "مشاهدة"
        }
      }
    ]
  },
  "competition": {
    "root": "https://www.guidetosunnah.com/ar/services/main-categories-msabqat-alsnt-alnbwyt",
    "pages": 1,
    "categories": [],
    "items": [
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%AC%D9%88%D8%A7%D8%A6%D8%B2-%D8%A7%D9%84%D8%A3%D9%85%D9%8A%D8%B1-%D9%86%D8%A7%D9%8A%D9%81-%D8%A8%D9%86-%D8%B9%D8%A8%D8%AF%D8%A7%D9%84%D8%B9%D8%B2%D9%8A%D8%B2-%D8%A2%D9%84-%D8%B3%D8%B9%D9%88%D8%AF-%D8%A7%D9%84%D8%B9%D8%A7%D9%84%D9%85%D9%8A%D8%A9-3",
        "title": "جوائز الأمير نايف بن عبدالعزيز آل سعود العالمية",
        "description": "الجائزة العالمية للسنة النبوية والدراسات الإسلامية المعاصرة، وجائزة نايف بن عبد العزيز آل سعود لحفظ الحديث النبوي، والجائزة التقديرية لخدمة السنة النبوية، جوائز سنوية لخدمة السنة النبوية الشريفة.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2023-02-09-212117717_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2023-02-09-212117717_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://naifprize.org.sa/",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%85%D8%B3%D8%A7%D8%A8%D9%82%D8%A9-%D8%A7%D9%84%D8%A3%D9%85%D9%8A%D8%B1-%D8%B3%D9%84%D8%B7%D8%A7%D9%86-%D8%A8%D9%86-%D8%B9%D8%A8%D8%AF-%D8%A7%D9%84%D8%B9%D8%B2%D9%8A%D8%B2-%D9%84%D8%AD%D9%81%D8%B8-%D8%A7%D9%84%D9%82%D8%B1%D8%A2%D9%86-%D9%88%D8%A7%D9%84%D8%B3%D9%86%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-4",
        "title": "مسابقة الأمير سلطان بن عبد العزيز لحفظ القرآن والسنة النبوية",
        "description": "من مبادرات الخير التي تبناها الأمير سلطان بن عبد العزيز آل سعود - رحمه الله - في العاصمة الإندونيسية مسابقة الأمير سلطان بن عبدالعزيز لحفظ القرآن الكريم والسنة النبوية لدول آسيان والباسيفيك.",
        "image": "https://www.guidetosunnah.com/storage/posts/l-deayzi-400x400-1718_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/l-deayzi-400x400-1718_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://twitter.com/sbafquran",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D8%AC%D8%A7%D8%A6%D8%B2%D8%A9-%D9%88%D8%B2%D8%A7%D8%B1%D8%A9-%D8%A7%D9%84%D8%AA%D8%B1%D8%A8%D9%8A%D8%A9-%D9%88%D8%A7%D9%84%D8%AA%D8%B9%D9%84%D9%8A%D9%85-%D9%84%D9%84%D9%82%D8%B1%D8%A2%D9%86-%D8%A7%D9%84%D9%83%D8%B1%D9%8A%D9%85-%D9%88%D8%A7%D9%84%D8%B3%D9%86%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D8%A7%D9%84%D8%A8%D8%AD%D8%B1%D9%8A%D9%86-115",
        "title": "جائزة وزارة التربية والتعليم للقرآن الكريم والسنة النبوية - البحرين",
        "description": "ضمن اهتمام وزارة التربية والتعليم بكتاب الله العزيز، والعناية بحفظه وتجويده وبالسنة النبوية، تواصل إدارة الخدمات الطلابية بالتعاون مع إدارتي المناهج والإشراف التربوي تنظيم جائزة وزارة التربية والتعليم للقرآن الكريم والسنة النبوية بهدف تشجيع طلبة مدارس المملكة وحثهم على حفظ القرآن الكريم والسنة النبوية، وعلى مدى أكثر من أربعين عاما وسجل المسابقة حافل بالإنجازات وتنمية مواهب العديد من الطلبة المتميزين في هذا المجال، دعما لنشر القرآن الكريم والسنة النبوية بين أبنائه وتشجيعا لهم على التخلق بآدابهما، والسير على هداهما ونهجهما.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2023-02-09-212611720_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2023-02-09-212611720_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "http://www.moedu.gov.bh/QuranAward/content.aspx?page_key=key_intro&lang=ar",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%85%D8%B3%D8%A7%D8%A8%D9%82%D8%A9-%D9%88%D8%B2%D8%A7%D8%B1%D8%A9-%D8%A7%D9%84%D8%A3%D9%88%D9%82%D8%A7%D9%81-%D8%A7%D9%84%D9%85%D8%B5%D8%B1%D9%8A%D8%A9-%D9%84%D9%84%D8%B3%D9%86%D8%A9-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A%D8%A9-%D8%A7%D9%84%D9%85%D8%B4%D8%B1%D9%81%D8%A9-179",
        "title": "مسابقة وزارة الأوقاف المصرية للسنة النبوية المشرفة",
        "description": "أعلنت وزارة الأوقاف عن مسابقة السنة النبوية المشرفة لعام 2023، والمخصصة لحفظ وفهم ودراسة 100 حديث مختارة ومحددة، في إطار حرص وزارة الأوقاف على خدمة السنة النبوية المشرفة، المصدر الثاني للتشريع في ديننا الحنيف، والعمل على فهم مقاصدها فهمًا صحيحًا.",
        "image": "https://www.guidetosunnah.com/storage/posts/screenshot-2023-03-07-172018743_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/screenshot-2023-03-07-172018743_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://www.elwatannews.com/news/details/6398338",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%85%D8%B3%D8%A7%D8%A8%D9%82%D8%A9-%D8%A7%D9%84%D8%AD%D8%AF%D9%8A%D8%AB-%D8%A7%D9%84%D9%86%D8%A8%D9%88%D9%8A-%D8%A7%D9%84%D8%B4%D8%B1%D9%8A%D9%81-%D9%84%D9%84%D8%B7%D9%84%D8%A7%D8%A8-%D9%85%D9%86-%D9%88%D8%B2%D8%A7%D8%B1%D8%A9-%D8%A7%D9%84%D8%AA%D8%B1%D8%A8%D9%8A%D8%A9-%D9%88%D8%A7%D9%84%D8%AA%D8%B9%D9%84%D9%8A%D9%85-%D9%81%D9%8A-%D8%A7%D9%84%D8%A3%D8%B1%D8%AF%D9%86-181",
        "title": "مسابقة الحديث النبوي الشريف للطلاب - من وزارة التربية والتعليم في الأردن",
        "description": "هي مسابقة تقيمها وزارة التربية والتعليم في المملكة الأردنية الهاشمية وتقوم بالإعلان عنها في موقعها الرسمي.",
        "image": "https://www.guidetosunnah.com/storage/posts/logo-1746_relatedServiceThumb.png",
        "country": "",
        "date": "",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/logo-1746_showWebsiteThumb.png",
        "primaryAction": {
          "url": "https://moe.gov.jo/node/83344",
          "label": "مشاهدة"
        }
      }
    ]
  },
  "exhibition": {
    "root": "https://www.guidetosunnah.com/ar/services/main-categories-maard-lltaryf-balnby",
    "pages": 1,
    "categories": [
      {
        "url": "https://www.guidetosunnah.com/ar/services/maard-lltaryf-balnby/main-categories-maard-lltaryf-balnby-mtahf-mqtnyat-alnby",
        "label": "متاحف مقتنيات النبي ﷺ"
      },
      {
        "url": "https://www.guidetosunnah.com/ar/services/maard-lltaryf-balnby/main-categories-maard-lltaryf-balnby-maard-taryfyt",
        "label": "معارض تعريفية"
      }
    ],
    "items": [
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%85%D8%AA%D8%AD%D9%81-%D8%AA%D9%88%D8%A8-%D9%83%D8%A7%D8%A8%D9%8A-%D9%82%D8%B5%D8%B1-%D8%A7%D9%84%D8%A8%D8%A7%D8%A8-%D8%A7%D9%84%D8%B9%D8%A7%D9%84%D9%8A-40",
        "title": "متحف توب كابي (قصر الباب العالي)",
        "description": "متحف توب كابي (قصر الباب العالي) مقتنياته – صلى الله عليه وسلم – معروضة بقسم يُعرف باسم هركاي شريف أوداسي (غرفة الحرم المقدس)",
        "image": "https://www.guidetosunnah.com/storage/posts/dscf1311-1100326_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "متاحف مقتنيات النبي ﷺ",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/dscf1311-1100326_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.dailysabah.com/arabic/history/2016/03/07/pictures-sacred-relics-in-topkapi-palace",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%85%D8%B9%D8%B1%D8%B6-%D9%85%D8%AD%D9%85%D8%AF-%D8%B1%D8%B3%D9%88%D9%84-%D8%A7%D9%84%D9%84%D9%87-%D8%A7%D9%84%D9%85%D8%AF%D9%8A%D9%86%D8%A9-%D8%A7%D9%84%D9%85%D9%86%D9%88%D8%B1%D8%A9-41",
        "title": "معرض (محمد رسول الله) - المدينة المنورة",
        "description": "معرض دائم مقام في المدينة المنورة غرب المسجد النبوي ، تم افتتاحه في عام 2013 بمساحة 2000 م2.",
        "image": "https://www.guidetosunnah.com/storage/posts/oajh-almaard111_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "معارض تعريفية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/oajh-almaard111_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://ar.wikipedia.org/wiki/%D9%85%D8%B9%D8%B1%D8%B6_%D9%85%D8%AD%D9%85%D8%AF_%D8%B1%D8%B3%D9%88%D9%84_%D8%A7%D9%84%D9%84%D9%87",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%85%D8%B9%D8%B1%D8%B6-%D8%A7%D9%84%D8%A5%D8%B3%D9%84%D8%A7%D9%85-%D8%A7%D9%84%D8%AF%D8%A7%D8%A6%D9%85-42",
        "title": "معرض الإسلام الدائم",
        "description": "معرض الإسلام الدائم بلندن في فبراير 2020م.",
        "image": "https://www.guidetosunnah.com/storage/posts/7ab26686-2578-453c-8b8b-2647d8761a09-16x9-1200x676439_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "معارض تعريفية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/7ab26686-2578-453c-8b8b-2647d8761a09-16x9-1200x676439_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://www.marefa.org/%D8%A7%D9%84%D9%85%D8%B1%D9%83%D8%B2_%D8%A7%D9%84%D8%AB%D9%82%D8%A7%D9%81%D9%8A_%D8%A7%D9%84%D8%A5%D8%B3%D9%84%D8%A7%D9%85%D9%8A_%D9%81%D9%8A_%D9%84%D9%86%D8%AF%D9%86",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%85%D8%AA%D8%AD%D9%81-%D8%A7%D9%84%D8%B3%D9%84%D8%A7%D9%85-%D8%B9%D9%84%D9%8A%D9%83-%D8%A3%D9%8A%D9%87%D8%A7-%D8%A7%D9%84%D9%86%D8%A8%D9%8A-%D9%85%D9%83%D8%A9-44",
        "title": "متحف السلام عليك أيها النبي - مكة",
        "description": "تقوم فكرة المتحف على تصنيع ما استعمله النبي محمد أو امتلكه، أو ورد ذكره على لسانه من: أثاث - وسلاح - ولباس - وأوانٍ - ومقتنيات - وعملات - ومكاييل - وموازين - وغيرها، بهدف الشرح العملي والمثال التطبيقي والتعريفي لها، إضافة إلى استخدام أحدث وسائل التقنية في التصوير والتجسيد والعرض والشرح والتوصيف لتلك الأشياء التي يحتاج الناس إلى معرفة أشكالها وأوصافها وحقائقها، حيث يتم عرضها في هذا القسم لتكتمل بذلك أهداف الموسوعة بالتوثيق الكامل لعصر النبوة بكل أبعاده وأشكال الحياة فيه.",
        "image": "https://www.guidetosunnah.com/storage/posts/b19dc493-13c2-401b-be48-d53c171784f3327_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "معارض تعريفية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/b19dc493-13c2-401b-be48-d53c171784f3327_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "https://ar.wikipedia.org/wiki/%D8%A7%D9%84%D8%B3%D9%84%D8%A7%D9%85_%D8%B9%D9%84%D9%8A%D9%83_%D8%A3%D9%8A%D9%87%D8%A7_%D8%A7%D9%84%D9%86%D8%A8%D9%8A",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%85%D8%B9%D8%B1%D8%B6-%D9%86%D8%A8%D9%8A-%D8%A7%D9%84%D8%B1%D8%AD%D9%85%D8%A9-%D8%A7%D9%84%D8%AF%D8%A7%D8%A6%D9%85-%D9%81%D9%8A-%D9%85%D8%AF%D8%B1%D9%8A%D8%AF-47",
        "title": "معرض نبي الرحمة الدائم في مدريد",
        "description": "تم افتتاحه في 2011م، من تنظيم رابطة العالم الإسلامي.",
        "image": "https://www.guidetosunnah.com/storage/posts/mhmd-nby-alrhm329_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "معارض تعريفية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/mhmd-nby-alrhm329_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "http://mercyprophet.org/mul/ar/exhibitionsgallery",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%85%D8%B9%D8%B1%D8%B6-%D9%86%D8%A8%D9%8A-%D8%A7%D9%84%D8%B1%D8%AD%D9%85%D8%A9-%D8%A7%D9%84%D8%AF%D8%A7%D8%A6%D9%85-%D9%81%D9%8A-%D9%83%D9%88%D8%A8%D9%86%D9%87%D8%A7%D8%AC%D9%86-48",
        "title": "معرض نبي الرحمة الدائم في كوبنهاجن",
        "description": "معرض نبي الرحمة الدائم في كوبنهاجن، تم افتتاحه في 2011، تنظيم رابطة العالم الإسلامي بالتعاون مع اتحاد مسلمي الدانمارك.",
        "image": "https://www.guidetosunnah.com/storage/posts/maalomat-aan-mdyn-kobnhajn438_relatedServiceThumb.jpg",
        "country": "",
        "date": "",
        "category": "معارض تعريفية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/maalomat-aan-mdyn-kobnhajn438_showWebsiteThumb.jpg",
        "primaryAction": {
          "url": "http://mercyprophet.org/mul/ar/node/2457",
          "label": "مشاهدة"
        }
      },
      {
        "sourceUrl": "https://www.guidetosunnah.com/ar/service/show/%D9%85%D8%B9%D8%B1%D8%B6-%D8%B1%D8%AD%D9%85%D8%A9-%D9%84%D9%84%D8%B9%D8%A7%D9%84%D9%85%D9%8A%D9%86-%D9%81%D9%8A-%D9%81%D9%8A%D9%8A%D9%86%D8%A7-49",
        "title": "معرض رحمة للعالمين في فيينا",
        "description": "معرض نظمه المركز العالمي للتعريف بالنبي ونصرته التابع لرابطة العالم الإسلامي والمجلس الأعلى للمسلمين في ألمانيا بالتعاون مع المركز الإسلامي في فيينا وهو الهيئة الدينية الإسلامية الرسمية في النمسا وذلك وسط حضور جماهيري كبير ضم عدداً من سفراء الدول العربية والإسلامية ونخبة من الأكاديميين والإعلاميين النمساويين.",
        "image": "https://www.guidetosunnah.com/storage/posts/1550233121469_relatedServiceThumb.jpeg",
        "country": "",
        "date": "",
        "category": "معارض تعريفية",
        "detailImage": "https://www.guidetosunnah.com/storage/posts/1550233121469_showWebsiteThumb.jpeg",
        "primaryAction": {
          "url": "http://mercyprophet.org/mul/ar/exhibitionsgallery",
          "label": "مشاهدة"
        }
      }
    ]
  },
  "meta": {
    "source": "https://www.guidetosunnah.com/ar",
    "importedAt": "2026-08-13T11:18:53.558Z",
    "itemCount": 423,
    "policy": "All root pagination and all published subcategory pagination are merged before normalization."
  }
};
